/* eslint-disable jsx-a11y/accessible-emoji */
/* eslint-disable no-self-assign */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useCallback, useLayoutEffect } from "react";
import styles from "./SelfAssesment.module.css";
import { useProgress } from "./progressContext";
import { useHistory } from "react-router-dom";
import { useAssessment } from "./AssessmentContext"; // Assuming AssessmentProvider is exported
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { GoalsMultiSelect } from "./AssesmentGoals";
import { modalState } from "../voice-agent/InactivityModalState";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import RecoveryService from "../../services/CrashRecoveryService";
import { URL, URLPlan, HOME_VIDEO, ZONES, LOGO, SKELETON, SKELETON_PLACEHOLDER, CPG_OPTIONS, BACK_CPG_OPTIONS, testMap, negativeTestMap, activityLevels, testSpecificIntroVideos, DEFAULT_INTRO_VIDEO, messaging, BETA_URL, floorOptions, balanceOptions, scheduleTimeOptions, sessionOptions, scheduleDaysOptions, goalOptions, SeatedTrunkRotation, CLINICAL_PATHS, HOME_VIDEO_2, OVERRIDE_TARGETS, getFirstTestForSubtype, getSecondTestForSubtype, getOverrideTarget, DIAGNOSTIC_CERTAINTY_SCORES, SUBTYPE_TO_CPG_MAP, SAFETY_QUESTIONS, ZONE_BUTTONS, TAB_COORDS, hlType, splitHalf, edgeSide, PLACEHOLDER_VIDEO } from "./CONSTANTS";
import checkBrowserSupport from "./browserDetect";
import PdfViewer from "../pdfViewer/PDFViewer";
import MyraInteraction from "./MyraInteractionController";
import GSAExitHandler from "./GSAExitHandler";
import { MYRA_MESSAGES } from "../self-assesment2/GSA_MYRA_MESSAGES";

var subDomain = "api";
if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
  subDomain = "uatapi";
}

// ANALYTICS: Define the base URL for the new analytics API endpoint.
const ANALYTICS_API_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment";

window.trSessionId = localStorage.getItem("trSessionId") || "";

function getUrlTrackingFields() {
  const params = new URLSearchParams(window.location.search);

  const variant = params.get("variant") || localStorage.getItem("variant") || null;
  const gclid = params.get("gclid");
  const gbraid = params.get("gbraid");
  const wbraid = params.get("wbraid");

  const hasGoogleClickId = Boolean(gclid || gbraid || wbraid || variant);

  const fields = {};

  if (variant) {
	  localStorage.setItem("variant", variant);
	  fields.variant = variant;
  }
  if (gclid) fields.gclid = gclid;
  if (gbraid) fields.gbraid = gbraid;
  if (wbraid) fields.wbraid = wbraid;

  if (hasGoogleClickId) {
    fields.isComeFromGoogle = true;
  }

  return fields;
}
// Race-condition guard: holds the in-flight startSession promise so
// concurrent callers wait for the first call instead of creating duplicates.
let _pendingSessionPromise = null;

let _pendingIpPromise = null;
let _pendingFrontIpSessionUpdatePromise = null;

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function ensureFrontIp(timeoutMs) {
  if (window.backupIP) {
    return Promise.resolve(window.backupIP);
  }

  if (!_pendingIpPromise) {
    _pendingIpPromise = fetch("https://virdio.weborik.com/init.php")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch front IP");
        }

        return res.json();
      })
      .then((data) => {
        window.backupIP = data?.session || "";
        return window.backupIP;
      })
      .catch((error) => {
        console.warn("ensureFrontIp Error:", error);
        return "";
      })
      .finally(() => {
        _pendingIpPromise = null;
      });
  }

  // If timeoutMs is provided, allow callers to use the old timeout behavior.
  // If not provided, wait until the IP request truly finishes.
  if (typeof timeoutMs === "number") {
    return Promise.race([
      _pendingIpPromise,
      wait(timeoutMs).then(() => window.backupIP || ""),
    ]);
  }

  return _pendingIpPromise;
}

function startFrontIpUpdateAfterSession(sessionId) {
  if (!sessionId) return;

  // Avoid duplicate background IP updates.
  if (_pendingFrontIpSessionUpdatePromise) return;

  // If IP is already known, no need to refetch.
  // The session_start payload already includes cached window.backupIP if available.
  if (window.backupIP) return AnalyticsService.trackStep({}, null, { frontIpOnly: true });

  _pendingFrontIpSessionUpdatePromise = ensureFrontIp()
    .then((frontIp) => {
      if (!frontIp) return;

      window.trSessionId = window.trSessionId || sessionId;

      // IP-only update. Does not resend/overwrite assessment data.
      return AnalyticsService.trackStep({}, null, { frontIpOnly: true });
    })
    .catch((error) => {
      console.warn("Background front IP update failed:", error);
    })
    .finally(() => {
      _pendingFrontIpSessionUpdatePromise = null;
    });
}

// ANALYTICS: Create a helper service to manage all analytics API calls.
export const AnalyticsService = {
  /**
   * Starts a new analytics session when the user first lands on the page.
   * Uses a pending-promise guard to prevent duplicate session creation
   * when multiple components call startSession() simultaneously.
   * @returns {Promise<string|null>} The unique session ID from the backend, or null on failure.
   */
  startSession: (trackingFields = {}) => {
	  const existingSessionId = window.trSessionId || localStorage.getItem("trSessionId");

	  if (existingSessionId) {
		window.trSessionId = existingSessionId;

		// Best-effort background IP update if needed.
		startFrontIpUpdateAfterSession(existingSessionId);

		return Promise.resolve(existingSessionId);
	  }

	  if (_pendingSessionPromise) {
		return _pendingSessionPromise;
	  }

	  _pendingSessionPromise = (async () => {
		try {
		  function getDeviceType() {
			const ua = navigator.userAgent;

			if (/iPad|Tablet|Nexus 7|Nexus 10|SM-T|Tab/i.test(ua)) {
			  return "tablet";
			}

			if (/Mobi|Android|iPhone|iPod|Phone/i.test(ua)) {
			  return "mobile";
			}

			return "desktop";
		  }

		  const urlTrackingFields = getUrlTrackingFields();
		  
		  if ( window.backupIP ) {
			localStorage.setItem("bckip", window.backupIP);
		  }

		  const payload = {
			event: "session_start",
			device_info: navigator.userAgent,
			session_start_time: new Date().toISOString(),

			// Do not wait for IP here.
			// If already known, send it. Otherwise send empty and update later.
			front_ip: window.backupIP || localStorage.getItem("bckip") || "",
			
			variant_save: localStorage.getItem("variant") || "",

			device_type: getDeviceType() + " | " + window.location.host.replace("www.", ""),

			// Caller can still add non-URL fields or override deliberately.
			...trackingFields,

			// URL-derived attribution should always be present when available.
			...urlTrackingFields,
		  };

		  const response = await fetch(`${ANALYTICS_API_URL}/init`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
		  });

		  if (!response.ok) throw new Error("Failed to start session");

		  const data = await response.json();

		  localStorage.setItem("trSessionId", data.session_id);
		  window.trSessionId = data.session_id;

		  // Start IP fetch/update only after session exists.
		  // Do not await this.
		  startFrontIpUpdateAfterSession(data.session_id);
		  setTimeout(() => { startFrontIpUpdateAfterSession(data.session_id); }, 2000);
		  setTimeout(() => { startFrontIpUpdateAfterSession(data.session_id); }, 10000);

		  return data.session_id;
		} catch (error) {
		  console.error("AnalyticsService.startSession Error:", error);
		  return null;
		} finally {
		  _pendingSessionPromise = null;
		}
	  })();

	  return _pendingSessionPromise;
	},

  /**
   * Tracks a specific step in the user's journey.
   * @param {object} assessmentData - The complete, current state of the user's assessment answers.
   */
  trackStep: async (assessmentData = {}, callback, options = {}) => {
	  window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

	  if (!window.trSessionId && !options.frontIpOnly) {
		await AnalyticsService.startSession();
		window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";
	  }

	  if (!window.trSessionId) {
		console.warn("AnalyticsService.trackStep: No session ID provided.");
		return;
	  }
	  
	  if ( window.backupIP ) { localStorage.setItem("bckip", window.backupIP); }

	  try {
		const payload = {
		  session_id: window.trSessionId,
		  session_last_update: new Date().toISOString(),
		  front_ip: window.backupIP || localStorage.getItem("bckip") || "",
		  variant_save: localStorage.getItem("variant") || "",
		};

		if (!options.frontIpOnly) {
		  let enhancedData = {
			...assessmentData,
			analyticsId: window.trSessionId,
		  };

		  if (window.timeTracker) {
			const currentGSADuration = window.timeTracker.getGSADuration();

			if (currentGSADuration !== null) {
			  enhancedData.gsaDurationSec = currentGSADuration;
			  console.log(`Current GSA duration: ${currentGSADuration} seconds`);
			}
		  }

		  payload.assessment_data = enhancedData;
		}
		
		if ( options.frontIpOnly && !payload.front_ip ) {
			console.warn("AnalyticsService.trackStep: Not found.");
			return;
		}

		fetch(`${ANALYTICS_API_URL}/data`, {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify(payload),
		})
		  .then((resp) => {
			if (!resp.ok) {
			  throw new Error("Failed to track analytics event");
			}

			if (options.frontIpOnly) {
			  console.log(`Front IP updated for session ${window.trSessionId}:`, window.backupIP);
			} else {
			  console.log(`Analytics event tracked for session ${window.trSessionId}:`, assessmentData);
			}

			if (callback) {
			  callback();
			}
		  })
		  .catch((error) => {
			console.error("AnalyticsService.trackStep fetch Error:", error);
		  });
	  } catch (error) {
		console.error("AnalyticsService.trackStep Error:", error);
	  }
	},
  saveFullData: async (fullData) => {
    window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

    if (!window.trSessionId) {
      console.warn("AnalyticsService.saveFullData: No session ID found.");
      return;
    }

    try {
      const payload = {
        session_id: window.trSessionId,
        fullData,
      };

      const response = await fetch(`${ANALYTICS_API_URL}/fulldata`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Full data saved:", data);
      return data;
    } catch (error) {
      console.error("AnalyticsService.saveFullData Error:", error);
    }
  },
};

// Add this utility at the top of your homescreen.jsx or create a separate file
class TimeTracker {
  constructor() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }

  // Call this when landing page loads
  startLandingTimer() {
    this.landingStartTime = Date.now();
    console.log("Landing timer started");
  }

  // Call this when user clicks "Start GSA"
  startGSATimer() {
    this.gsaStartTime = Date.now();
    console.log("GSA timer started");

    // Also calculate time spent on landing
    if (this.landingStartTime) {
      const landingDurationSec = Math.round((this.gsaStartTime - this.landingStartTime) / 1000);
      return {
        gsaStartedAt: new Date().toISOString(),
        timeOnLandingSec: landingDurationSec,
      };
    }

    return {
      gsaStartedAt: new Date().toISOString(),
      timeOnLandingSec: null,
    };
  }

  // Call this on each screen to get updated GSA duration
  getGSADuration() {
    if (!this.gsaStartTime) return null;
    return Math.round((Date.now() - this.gsaStartTime) / 1000);
  }

  // Reset all timers (when user restarts)
  reset() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }
}

// Create global instance
window.timeTracker = new TimeTracker();

// Add this to your homescreen.jsx or utilities
class ScreenFlowTracker {
  constructor() {
    this.screenFlow = [];
  }

  // Call when entering a screen
  enterScreen(screenName) {
    const entry = {
      screen: screenName,
      enteredAt: new Date().toISOString(),
      completed: false,
    };
    this.screenFlow.push(entry);
    console.log(`Entered screen: ${screenName}`);
    return entry;
  }

  // Call when completing/exiting a screen
  exitScreen(screenName, options = {}) {
    const screen = this.screenFlow.find((s) => s.screen === screenName && !s.completed);
    if (screen) {
      screen.completed = options.completed || true;
      screen.exitedAt = new Date().toISOString();

      // Add optional exit reason
      if (options.exitReason) {
        screen.exitReason = options.exitReason;
      }

      console.log(`Exited screen: ${screenName}`, options);
    }
    return screen;
  }

  // Get current screen flow data
  getScreenFlow() {
    return [...this.screenFlow];
  }

  // Reset for new session
  reset() {
    this.screenFlow = [];
  }
}

// Create global instance
window.screenTracker = new ScreenFlowTracker();

// custom hook which will scroll to top when component mounts
const useScrollToTop = () => {
  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, []);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export function MyraFab({ onFabTap, onPickChat, onPickVoice, isFabExpanded, isBubbleVisible, onDismissBubble, statusText }) {
  const [showText, setShowText] = useState(true);
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [isAgentSpeaking, setIsAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        MyraInteraction.closeFab();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const unsubMode = MyraInteraction.on("modeChange", ({ mode }) => {
      setMode(mode);
    });

    // Listen to voice service state changes
    const checkVoiceState = () => {
      if (window.VoiceService) {
        const isSpeaking = window.VoiceService._isAgentSpeaking || false;
        const isListen = window.VoiceService._isListening || false;
        setIsAgentSpeaking(isSpeaking);
        setIsListening(isListen);
      }
    };

    // Initial check
    checkVoiceState();

    // Set up interval to check voice state (or use callbacks if available)
    const interval = setInterval(checkVoiceState, 500);

    // Also listen to VoiceService callbacks if available
    if (VoiceService?._callbacks) {
      const originalOnAgentSpeechStart = VoiceService._callbacks.onAgentSpeechStart;
      const originalOnAgentSpeechEnd = VoiceService._callbacks.onAgentSpeechEnd;
      const originalOnListeningStart = VoiceService._callbacks.onListeningStart;
      const originalOnListeningStop = VoiceService._callbacks.onListeningStop;

      VoiceService._callbacks.onAgentSpeechStart = () => {
        setIsAgentSpeaking(true);
        if (originalOnAgentSpeechStart) originalOnAgentSpeechStart();
      };

      VoiceService._callbacks.onAgentSpeechEnd = () => {
        setIsAgentSpeaking(false);
        if (originalOnAgentSpeechEnd) originalOnAgentSpeechEnd();
      };

      VoiceService._callbacks.onListeningStart = () => {
        setIsListening(true);
        if (originalOnListeningStart) originalOnListeningStart();
      };

      VoiceService._callbacks.onListeningStop = () => {
        setIsListening(false);
        if (originalOnListeningStop) originalOnListeningStop();
      };
    }

    return () => {
      if (unsubMode) unsubMode();
      clearInterval(interval);
    };
  }, []);
  const getBubbleText = () => {
    if (!mode) {
      return "Press to ask me anything";
    }

    if (mode === "chat" || mode === "button") {
      return "";
    }

    if (mode === "voice") {
      if (isAgentSpeaking) {
        return "Speaking...";
      } else if (isListening) {
        return statusText;
      }
      return "";
    }

    return "";
  };
  const shouldShowBubble = () => {
    if (!showText) return false;
    if (!isBubbleVisible) return false;

    // Don't show bubble if text is empty
    const bubbleText = getBubbleText();
    if (!bubbleText) return false;

    return true;
  };

  return (
    // On Tap of the Fab Openning Chat - TODO: Remove onClick from here to enable chat/voice selection
    <div ref={modalRef} className={styles.myraFab} id="myraFab" onClick={onPickChat}> 
      {/* Expand options — shown when fab is expanded */}
      <div className={`${styles.myraExpand} ${isFabExpanded ? styles.myraExpandOpen : ""}`}>
        <div className={styles.myraOpt} onClick={onPickChat}>
          <svg viewBox="0 0 24 24">
            <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
          </svg>
          <span>Chat with Myra</span>
        </div>
        <div className={styles.myraOpt} onClick={onPickVoice}>
          <svg viewBox="0 0 24 24">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
          </svg>
          <span>Speak to Myra</span>
        </div>
      </div>

      {/* FAB row — button + bubble */}
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* Main FAB button */}
        <button className={styles.myraFabBtn} onClick={onFabTap}>
          <svg viewBox="0 0 24 24" style={{ width: 14, height: 14 }}>
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
          </svg>
          <span>Myra</span>
          <div className={styles.fabDot} />
        </button>

        {/* Bubble - only show when visible */}
        {shouldShowBubble() && getBubbleText() && (
          <div className={styles.myraBubble} id="mBub">
            {getBubbleText()}
            <button
              className={styles.bubbleX}
              onClick={(e) => {
                e.stopPropagation();
                setShowText(false);
              }}
            >
              &times;
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// ChatPanel — bottom sheet
// ─────────────────────────────────────────────
export function ChatPanel({ messages, onClose, onSend, onSwitchVoice, onSwitchButton, isChatLoading }) {
  const inputRef = useRef(null);
  const msgsRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [isDragging, setIsDragging] = useState(false);
  const dragStartY = useRef(null);
  const dragStartHeight = useRef(null);
  const panelRef = useRef(null);
  const getDefaultHeight = () =>
    window.innerWidth <= 768
      ? window.innerHeight * 0.5 // mobile: 50%
      : window.innerHeight * 0.55; // desktop: 55%

  const [panelHeight, setPanelHeight] = useState(getDefaultHeight);
  const [isExpanded, setIsExpanded] = useState(false);

  const MIN_HEIGHT = 200;
  const MAX_HEIGHT = window.innerHeight - 24;

  const handleDragStart = (e) => {
    // support both mouse and touch
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;
    dragStartY.current = clientY;
    dragStartHeight.current = panelHeight;
    setIsDragging(true);
    e.preventDefault();
  };

  useEffect(() => {
    const handleDragMove = (e) => {
      if (!isDragging) return;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      // dragging UP increases height, dragging DOWN decreases
      const delta = dragStartY.current - clientY;
      const newHeight = Math.min(MAX_HEIGHT, Math.max(MIN_HEIGHT, dragStartHeight.current + delta));
      setPanelHeight(newHeight);
    };

    const handleDragEnd = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener("mousemove", handleDragMove);
      window.addEventListener("mouseup", handleDragEnd);
      window.addEventListener("touchmove", handleDragMove, { passive: false });
      window.addEventListener("touchend", handleDragEnd);
    }

    return () => {
      window.removeEventListener("mousemove", handleDragMove);
      window.removeEventListener("mouseup", handleDragEnd);
      window.removeEventListener("touchmove", handleDragMove);
      window.removeEventListener("touchend", handleDragEnd);
    };
  }, [isDragging]);

  const handleExpandToggle = () => {
    const EXPANDED_HEIGHT = Math.min(window.innerHeight - 24, 720);
    const DEFAULT_HEIGHT = 480;
    const MOBILE_DEFAULT = window.innerHeight * 0.5;
    const MOBILE_EXPANDED = window.innerHeight * 0.85;

    const isMobile = window.innerWidth <= 768;

    const handleExpandToggle = () => {
      if (!isExpanded) {
        setPanelHeight(isMobile ? MOBILE_EXPANDED : EXPANDED_HEIGHT);
      } else {
        setPanelHeight(isMobile ? MOBILE_DEFAULT : DEFAULT_HEIGHT);
      }
      setIsExpanded((e) => !e);
    };
  };

  useEffect(() => {
    const t = setTimeout(() => {
      inputRef.current?.focus();
    }, 300);

    return () => clearTimeout(t);
  }, [mode]);

  useEffect(() => {
    if (msgsRef.current) {
      msgsRef.current.scrollTop = msgsRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = () => {
    const text = inputValue.trim();
    if (!text || isChatLoading) return;
    const screen = MyraInteraction.getCurrentScreen();
    if (screen === "movement_test_1" || screen === "movement_test_2") {
        window.trackFlutterEvent({
          event_name: "user_input_received",
          context_type: screen,
          input_mode: "chat",
          input_text: text,
          // ...extra,
        });
    }
    onSend(text);
    setInputValue("");
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
  const isDesktop = () => {
    return window.innerWidth > 768;
  };
  const handleKeyDown = (e) => {
    if (!isDesktop()) return;

    if (e.key === "Enter") {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div ref={panelRef} className={`${styles.chatPanel} ${isDragging ? styles.chatPanelDragging : ""}`} style={{ height: panelHeight }}>
      <div className={styles.chatDragHandle} onMouseDown={handleDragStart} onTouchStart={handleDragStart}>
        <div className={styles.chatDragBar} />
      </div>

      {/* Header */}
      <div className={styles.chatHdr}>
        <h4>Chat with Myra</h4>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* {typeof window !== "undefined" && window.inApp === true && (
            <>
              <button className={styles.chatSwitch} onClick={onSwitchVoice}>
                Switch to Voice
              </button>

              <button className={styles.chatSwitch} onClick={onSwitchButton}>
                Use Buttons
              </button>
            </>
          )} */}
          <button className={styles.chatClose} onClick={onClose} title="Collapse">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 9l-7 7-7-7" />
            </svg>
          </button>
        </div>
      </div>

      {/* Messages */}
      <div className={styles.chatMsgs} ref={msgsRef}>
        {messages?.length === 0 && (
          <div className={styles.chatMsg}>
            <div className={styles.chatMyra}>Hi! I'm Myra. Type a message or use the buttons on screen.</div>
          </div>
        )}
        {messages?.map((msg, i) => (
          <div className={styles.chatMsg} key={i}>
            {msg.sender === "myra" ? (
              <div style={{ textAlign: "left" }}>
                <div className={styles.chatMyra}>{msg.text}</div>
              </div>
            ) : (
              <div style={{ textAlign: "right" }}>
                <div className={styles.chatUser}>{msg.text}</div>
              </div>
            )}
          </div>
        ))}
        {isChatLoading && (
          <div className={styles.chatTypingIndicator}>
            <span />
            <span />
            <span />
          </div>
        )}
      </div>

      {/* Input */}
      <div className={styles.chatInputRow}>
        <input ref={inputRef} value={inputValue} onChange={handleInputChange} className={styles.chatIn} inputMode="text" placeholder={isChatLoading ? "Myra is typing…" : "Type your question…"} type="text" {...(isDesktop() && { onKeyDown: handleKeyDown })} />
        <button className={styles.chatSend} onClick={handleSend}>
          {isChatLoading ? (
            <span style={{ fontSize: 12 }}>...</span>
          ) : (
            <svg viewBox="0 0 24 24">
              <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// VoicePanel — bottom sheet
// ─────────────────────────────────────────────
export function VoicePanel({ isAgentSpeaking, onClose, onSwitchChat, onSwitchButton, onMicRequest, statusText }) {
  const [micState, setMicState] = React.useState("checking");
  const [deviceMessage, setDeviceMessage] = React.useState("");
  const [issAgentSpeaking, setIssAgentSpeaking] = useState(false);
  const [isListening, setIsListening] = useState(false);

  const checkPermissionState = async () => {
    try {
      if (navigator.permissions && navigator.permissions.query) {
        const status = await navigator.permissions.query({ name: "microphone" });
        setMicState(status.state);

        status.onchange = () => {
          console.log("[VoicePanel] Permission changed to:", status.state);
          setMicState(status.state);
        };
      } else {
        try {
          const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
          stream.getTracks().forEach((track) => track.stop());
          setMicState("granted");
        } catch (err) {
          setMicState(err.name === "NotAllowedError" ? "denied" : "prompt");
        }
      }
    } catch (error) {
      console.error("[VoicePanel] Permission check failed:", error);
      setMicState("prompt");
    }
  };

  React.useEffect(() => {
    checkPermissionState();
  }, []);
  React.useEffect(() => {
    const handlePermissionGranted = () => {
      console.log("[VoicePanel] Received permission granted event");
      setMicState("granted");
    };

    const handlePermissionDenied = () => {
      console.log("[VoicePanel] Received permission denied event");
      setMicState("denied");
    };

    const handlePermissionCheck = () => {
      checkPermissionState();
    };

    window.addEventListener("mic-permission-granted", handlePermissionGranted);
    window.addEventListener("mic-permission-denied", handlePermissionDenied);
    window.addEventListener("mic-permission-check", handlePermissionCheck);

    return () => {
      window.removeEventListener("mic-permission-granted", handlePermissionGranted);
      window.removeEventListener("mic-permission-denied", handlePermissionDenied);
      window.removeEventListener("mic-permission-check", handlePermissionCheck);
    };
  }, []);

  useEffect(() => {
    // Listen to voice service state changes
    const checkVoiceState = () => {
      if (VoiceService) {
        const isSpeaking = VoiceService._isAgentSpeaking || false;
        const isListen = VoiceService._isListening || false;
        setIssAgentSpeaking(isSpeaking);
        setIsListening(isListen);
      }
    };

    // Initial check
    checkVoiceState();

    // Set up interval to check voice state (or use callbacks if available)
    const interval = setInterval(checkVoiceState, 500);

    // Also listen to VoiceService callbacks if available
    if (VoiceService?._callbacks) {
      const originalOnAgentSpeechStart = VoiceService._callbacks.onAgentSpeechStart;
      const originalOnAgentSpeechEnd = VoiceService._callbacks.onAgentSpeechEnd;
      const originalOnListeningStart = VoiceService._callbacks.onListeningStart;
      const originalOnListeningStop = VoiceService._callbacks.onListeningStop;

      VoiceService._callbacks.onAgentSpeechStart = () => {
        setIssAgentSpeaking(true);
        if (originalOnAgentSpeechStart) originalOnAgentSpeechStart();
      };

      VoiceService._callbacks.onAgentSpeechEnd = () => {
        setIssAgentSpeaking(false);
        if (originalOnAgentSpeechEnd) originalOnAgentSpeechEnd();
      };

      VoiceService._callbacks.onListeningStart = () => {
        setIsListening(true);
        if (originalOnListeningStart) originalOnListeningStart();
      };

      VoiceService._callbacks.onListeningStop = () => {
        setIsListening(false);
        if (originalOnListeningStop) originalOnListeningStop();
      };
    }

    return () => {
      clearInterval(interval);
    };
  }, []);

  // Build device-specific instructions whenever state flips to denied
  React.useEffect(() => {
    if (micState !== "denied") return;

    const ua = navigator.userAgent.toLowerCase();
    const isMac = /macintosh|mac os x/.test(ua);
    const isWindows = /win/.test(ua);
    const isIPhone = /iphone/.test(ua);
    const isIPad = /ipad/.test(ua);
    const isAndroid = /android/.test(ua);

    if (isMac) {
      setDeviceMessage("To enable it, open System Settings → Privacy & Security → Microphone and make sure your browser is toggled On. Then come back and refresh this page.");
    } else if (isWindows) {
      setDeviceMessage("To enable it, open Settings → Privacy & Security → Microphone and make sure your browser is set to Allow. Then come back and refresh this page.");
    } else if (isIPhone || isIPad) {
      setDeviceMessage("To enable it, go to Settings → Apps → Safari → Microphone and set it to Allow or Ask. Then come back and refresh this page.");
    } else if (isAndroid) {
      setDeviceMessage("To enable it, go to Settings → Apps → Chrome → Permissions → Microphone and set it to Allow. Then come back and refresh this page.");
    } else {
      setDeviceMessage("To enable it, check your browser or system settings for microphone permissions.");
    }
  }, [micState]);

  const handleAllowMic = () => {
    if (onMicRequest) onMicRequest();
  };

  // Header is always the same — extract to avoid repeating it
  const header = (
    <div className={styles.voicePanelHdr}>
      <h4>Speaking to Myra</h4>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button className={styles.chatSwitch} onClick={onSwitchChat}>
          Switch to Chat
        </button>
        <button className={styles.chatSwitch} onClick={onSwitchButton}>
          Use Buttons
        </button>
        <button className={styles.chatClose} onClick={onClose} title="Collapse">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>
    </div>
  );

  // Still checking — show nothing in the body to avoid flicker
  if (micState === "checking") {
    return <div className={styles.voicePanel}>{header}</div>;
  }

  // User has not yet responded to the browser prompt
  // if (micState === "prompt") {
  //   return (
  //     <div className={styles.voicePanel}>
  //       {header}
  //       <div className={styles.voiceStatus}>
  //         {/* <p>Myra needs microphone access to hear you.</p> */}
  //         <p className={styles.voiceHint}>To speak with me, you’ll need to grant microphone access. If you’d prefer not to, you can always chat with me instead</p>
  //         <button className={styles.introARButton} onClick={handleAllowMic}>
  //           Grant Mic Access
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  // User explicitly blocked the browser prompt — show device instructions
  if (micState === "denied") {
    return (
      <div className={styles.voicePanel}>
        {header}
        <div className={styles.voiceStatus}>
          <p>Microphone access was blocked.</p>
          <p className={styles.voiceHint}>{deviceMessage}</p>
        </div>
      </div>
    );
  }
  if (micState === "prompt") {
    return (
      <div className={styles.voicePanel}>
        {header}
        <div className={styles.voiceStatus}>
          <p>Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.</p>
        </div>
      </div>
    );
  }

  // micState === 'granted' — normal speaking/listening view
  return (
    <div className={styles.voicePanel}>
      {header}
      <div className={styles.voiceStatus}>
        <div className={styles.voiceCircle}>
          <svg viewBox="0 0 24 24">
            <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
          </svg>
        </div>
        <p>
          <p>{issAgentSpeaking ? "Myra is speaking…" : isListening ? statusText : ""}</p>
        </p>
        <p className={styles.voiceHint}>Speak naturally. Myra will guide you.</p>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────
// IntroARModeCard — shown on the Intro AR screen
// ─────────────────────────────────────────────
export function IntroARModeCard({ introARState, selectedMode, onSelectMode }) {
  const [hideConfirmation, setHideConfirmation] = useState(false);

  useEffect(() => {
    if (!introARState.showModeCard && introARState.showConfirmation) {
      const timer = setTimeout(() => {
        setHideConfirmation(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [introARState.showModeCard, introARState.showConfirmation]);
  // If mode was already chosen, show confirmation
  if (!introARState.showModeCard) {
    if (!introARState.showConfirmation || hideConfirmation) return null;
    return (
      <div
        className={styles.modeConfirm}
        style={{
          background: "var(--teal-light)",
          borderRadius: "10px",
          padding: "12px 14px",
          margin: "14px 0",
        }}
      >
        <p
          style={{
            fontSize: "14px",
            color: "var(--teal-deep)",
            fontWeight: "600",
          }}
        >
          {introARState.confirmationText}
        </p>
      </div>
    );
  }

  const modes = [
    {
      id: "voice",
      label: "Speak to Myra",
      badge: "Recommended",
      desc: "Speak to me hands-free — I just need microphone access.",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.91-3c-.49 0-.9.36-.98.85C16.52 14.2 14.47 16 12 16s-4.52-1.8-4.93-4.15c-.08-.49-.49-.85-.98-.85-.61 0-1.09.54-1 1.14.49 3 2.89 5.35 5.91 5.78V20c0 .55.45 1 1 1s1-.45 1-1v-2.08c3.02-.43 5.42-2.78 5.91-5.78.1-.6-.39-1.14-1-1.14z" />
        </svg>
      ),
    },
    {
      id: "chat",
      label: "Chat with Myra",
      badge: null,
      desc: "Type your responses to me — no microphone needed.",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
        </svg>
      ),
    },
    {
      id: "button",
      label: "Tap Responses",
      badge: null,
      desc: "I'll speak the instructions; you tap to respond — no mic needed.",
      icon: (
        <svg viewBox="0 0 24 24">
          <path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14zm-2-8H9v-2h6v2zm0 4H9v-2h6v2z" />
        </svg>
      ),
    },
  ];
  const onContinueHandler = async () => {
    // 1. Confirm the selected mode with controller
    MyraInteraction.confirmIntroARMode(selectedMode);
    console.log("SELECTED MODE : ", selectedMode);
    setHideConfirmation(true);
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      await window.audioPlayer.ctx.resume();
    }

    // 2. If voice mode is selected, show mic permission if needed
    if (selectedMode === "voice") {
      const granted = await window.requestMicrophonePermission({
        onGrant: () => {
          // window.initAR();
          MyraInteraction.switchMode("voice", true);
          window.mayraCode.handleMicClick(true, true, false, true);
          const currentHealth = VoiceService._isActuallyListening();
          if (!currentHealth.healthy) {
            console.log("[RECONNECT] Starting listening");
            VoiceService._startListening().catch((err) => {
              setTimeout(() => {
                VoiceService._startListening().catch((e) => console.error("[RECONNECT] Retry also failed:", e));
              }, 2000);
            });
          }
        },
        onDeny: () => {
          MyraInteraction.switchMode("chat", true);
          window.initAR();
          VoiceService.startFlowWithoutAnnouncement(window.currentFlow || VoiceService._currentFlow);
          let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
          // MyraInteraction.pickChat();
          MyraInteraction.onMyraMessage(msg);
          if (window.videoController) {
            window.videoController.play();
          }
        },
      });
      let msg = "Great — I'm listening. I'll guide you through the movement test. Just follow the video and I'll let you know when we're ready to start.";
    }
    if (selectedMode === "chat") {
      MyraInteraction.switchMode("chat", true);
      // No mic permission needed
      // MyraInteraction.confirmIntroARMode("chat");
      let msg = "Great — I'll guide you through the movement test. Just follow the video and type here if you have any questions.";
      // VoiceService.announceBubbleMessage(msg);
      window.initAR();
      VoiceService.startFlowWithoutAnnouncement(window.currentFlow || VoiceService._currentFlow);
      // MyraInteraction.openChat();
      // MyraInteraction.onMyraMessage(msg);
      if (window.videoController) {
        window.videoController.play();
      }
      const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
      if (isIOS && window.audioPlayer) {
        await window.audioPlayer.unlockAudioForChat();
      }
      // MyraInteraction.closeChat();
      // MyraInteraction.openChat();
      // window.mayraCode.startFlowWithoutMic();
      // No mic modal shown
      // Chat panel will open when needed
    }
    if (selectedMode === "button") {
      MyraInteraction.switchMode("button", true);
      // window.initAR();
      VoiceService.startFlowWithoutAnnouncement(window.currentFlow || VoiceService._currentFlow);
      let msg = "No message. Myra begins speaking via TTS when the test starts.";
      // VoiceService.announceBubbleMessage(msg);
      if (window.videoController) {
        window.videoController.play();
      }
    }
  };

  return (
    <div className={styles.modeSection}>
      <div className={styles.msTitle}>Choose How You Communicate With Myra</div>
      <div className={styles.msSub}>During your movement test, how would you like her to guide you?</div>
      <div className={styles.modeOpts}>
        {modes.map((mode) => (
          <div key={mode.id} className={`${styles.modeOpt} ${selectedMode === mode.id ? styles.modeOptSel : ""}`} onClick={() => onSelectMode(mode.id)}>
            <div className={styles.moIcon}>{mode.icon}</div>
            <div className={styles.moText}>
              <h5>
                {mode.label}
                {mode.badge && <span className={styles.recBadge}>{mode.badge}</span>}
              </h5>
              <p>{mode.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className={styles.modeSwitchNote}>You can switch how you interact with Myra anytime.</div>
      <button onClick={onContinueHandler} className={styles.introARButton}>
        Got it
      </button>
    </div>
  );
}

export const InactivityModalManager = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Subscribe to modal state changes
    const unsubscribe = modalState.subscribe((visible) => {
      setIsVisible(visible);
    });

    // Listen for VoiceService events
    const handleShowModal = () => {
      modalState.show();
    };

    document.addEventListener("showInactivityModal", handleShowModal);

    return () => {
      unsubscribe();
      document.removeEventListener("showInactivityModal", handleShowModal);
    };
  }, []);

  const handleClose = () => {
    modalState.hide();

    // Dispatch resume event for other components
    document.dispatchEvent(
      new CustomEvent("inactivityModalResume", {
        detail: { timestamp: Date.now() },
      }),
    );
  };

  return <InactivityModal isVisible={isVisible} onClose={handleClose} />;
};

// Mic Permission Modal
export const MicPermissionModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [deviceMessage, setDeviceMessage] = useState("");

  useEffect(() => {
    const handlePermissionDenied = () => {
      console.log("[MicPermissionModal] Event received: micPermissionDenied");
      setIsVisible(true);
    };

    document.addEventListener("micPermissionDenied", handlePermissionDenied);

    return () => {
      document.removeEventListener("micPermissionDenied", handlePermissionDenied);
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMac = /macintosh|mac os x/.test(userAgent);
      const isWindows = /win/.test(userAgent);
      const isIPhone = /iphone/.test(userAgent);
      const isIPad = /ipad/.test(userAgent);
      const isAndroid = /android/.test(userAgent);

      if (isMac) {
        setDeviceMessage("To enable it, open System Settings → Privacy & Security → Microphone and make sure your browser is toggled On. Then come back and refresh this page.");
      } else if (isWindows) {
        setDeviceMessage("To enable it, open Settings → Privacy & Security → Microphone and make sure your browser is set to Allow. Then come back and refresh this page.");
      } else if (isIPhone || isIPad) {
        setDeviceMessage("To enable it, go to Settings → Apps → Safari → Microphone and set it to Allow or Ask. Then come back and refresh this page.");
      } else if (isAndroid) {
        setDeviceMessage("To enable it, go to Settings → Apps → Chrome → Permissions → Microphone and set it to Allow. Then come back and refresh this page.");
      } else {
        // Fallback for other devices
        setDeviceMessage("To enable it, check your browser/system settings for microphone permissions.");
      }
    }
  }, [isVisible]);

  const handleClose = () => {
    console.log("[MicPermissionModal] Closing modal");
    setIsVisible(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains(styles.modalBackdrop)) {
      handleClose();
    }
  };

  console.log("[MicPermissionModal] Rendering, isVisible:", isVisible);

  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.micPermModal} onClick={handleBackdropClick}>
      <div className={styles.micPermModalContent}>
        <h3 className={styles.micPermModalTitle}>Microphone Access Needed</h3>
        <p className={styles.micPermModalHeading}>Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.</p>
        <p className={styles.micPermModalText}>{deviceMessage}</p>
        <button onClick={handleClose} className={styles.micPermModalBtn}>
          OK
        </button>
      </div>
    </div>
  );
};

export const InactivityModal = ({ isVisible, onClose }) => {
  // Handle ESC key
  useEffect(() => {
    if (!isVisible) return;

    const handleEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleEsc);
    // Prevent background scrolling
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "";
    };
  }, [isVisible, onClose]);

  // Don't render if not visible
  if (!isVisible) return null;

  // Handle overlay click (click outside modal)
  const handleOverlayClick = (e) => {
    const inactivityData = {
      type: "RESET_INACTIVITY",
      data: { action: "RESET_INACTIVITY" },
    };

    if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
      VoiceService._ws.send(JSON.stringify(inactivityData));
    }
    if (window.mayraCode) {
      window.mayraCode.doSay("Great! We'll pick up right where we left off.", () => {
        if (e.target === e.currentTarget) {
          VoiceService.resumeCompletely();
          onClose();
        }
      });
    }
  };

  return (
    <div className={styles.InactivityModalOverlay} onClick={handleOverlayClick}>
      <div className={styles.InactivityModalModal}>
        <h2 className={styles.InactivityModalHeading}>I have paused...</h2>
        <button className={styles.InactivityModalButton} onClick={onClose}>
          Resume for Myra
        </button>
      </div>
    </div>
  );
};

export const usePreventNavigation = (redirectPath) => {
  // const history = useHistory();
  // useEffect(() => {
  //   const handlePopState = (e) => {
  //     window.location.replace("/");
  //   };

  //   window.addEventListener("popstate", handlePopState);
  //   return () => {
  //     window.removeEventListener("popstate", handlePopState);
  //   };
  // }, [history, redirectPath]);

  // commented because we will show the modal first if user says no it will stay on the same screen else it will redirected to homescreen.

  return;
};

export const RestartPopup = () => {
  const [visible, setVisible] = useState(false);
  let userName = localStorage.getItem("self_name") || "";

  useEffect(() => {
    const popup = document.getElementById("restartPopup");
    if (!popup) return;

    // Observe style changes
    const observer = new MutationObserver(() => {
      const isVisible = popup.style.display !== "none";
      setVisible(isVisible);
    });

    observer.observe(popup, { attributes: true, attributeFilter: ["style"] });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (visible && window.mayraCode) {
      window.mayraCode.doSay(`${userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.`);
    }
  }, [visible, userName]);

  return (
    <div
      id="restartPopup"
      style={{
        display: "none",
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          textAlign: "center",
          width: "300px",
        }}
      >
        <h3
          style={{
            marginBottom: "15px",
            fontSize: "18px",
            fontWeight: 600,
          }}
        >
          Assessment Ended
        </h3>
        <p style={{ marginBottom: "20px" }}>{userName}, I noticed you weren't able to complete all 10 reps of that test. That's completely okay — it just means this program may not be the right fit right now. For your safety, the best next step is to check in with a licensed provider who can guide you in person.</p>
        <button
          id="restartOkBtn"
          style={{
            padding: "10px 20px",
            background: "#0d9488",
            border: "none",
            borderRadius: "6px",
            color: "white",
            cursor: "pointer",
          }}
        >
          OK
        </button>
      </div>
    </div>
  );
};

// custom Button Component
const CommonButton = ({ onClick, disabled, title, className }) => {
  return (
    <button onClick={onClick} disabled={disabled} className={`${className} ${styles.commonButton} ${disabled ? styles.disabledButton : ""}`}>
      {title}
    </button>
  );
};

// Custom Header Component

const getCurrentMicState = async () => {
  if (typeof navigator !== "undefined" && navigator.permissions && navigator.permissions.query) {
    try {
      const status = await navigator.permissions.query({ name: "microphone" });
      return status.state; // 'granted' | 'denied' | 'prompt'
    } catch {
      return "prompt"; // fall back to our cached state
    }
  }
  return "prompt"; // Safari/older browsers
};

const Header = ({ showIcon = true, showProgress = true, screenName = "gsa", videoRef = null }) => {
  const history = useHistory();
  const [showExitModal, setShowExitModal] = useState(false);
  const { assessmentData, updateAssessmentData, resetAssessmentData } = useAssessment();
  const { progress } = useProgress();
  const handleExitModel = () => {
    // Cleanup
    resetAssessmentData();
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("userCondition");
    window.trSessionId = null;
    localStorage.removeItem("trSessionId");
    _pendingSessionPromise = null;
    if (window.movementTestPayload) {
      window.movementTestPayload = null;
    }
    window.exitHandlerOpen = false;
    if (window.mayraCode) {
      window.mayraCode.setIsVisible(false);
      window.mayraCode.forceStop();
    }
    // if (window.mayraCode) {
    //   window.mayraCode.handleMicClick(true);
    // }

    if (window.destroyOwnedResources) {
      window.destroyOwnedResources();
    }
    if (window.destroyFlutterResources) {
      window.destroyFlutterResources();
    }

    localStorage.setItem("loadAfterReloadAutoHome", "1");
    setTimeout(() => {
      window.location.replace(window.location.origin);
    }, 500);
  };

  window.updateMicModalCancel = (resetValue) => {
    let updatedData = {
      ...assessmentData,
      userCancelMic: resetValue === true ? 0 : 1,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
  };
  const handleOpenMyraChat = (msg) => {
    window.initFromUserGesture();
    if (window.audioPlayer && window.audioPlayer.pcm) {
      // Stoping the any ongoing PCM playback
      if (typeof window.audioPlayer.ttsPcmAbort === "function") {
        window.audioPlayer.ttsPcmAbort();
      }
      // Force reset state
      window.audioPlayer.pcm.active = false;
      window.audioPlayer.pcm.queuedSamples = 0;
      window.audioPlayer.pcm.endReceived = false;
      window.audioPlayer.pcm.floatQueue = [];
      window.audioPlayer.pcm.floatQueueSamples = 0;
      window.audioPlayer.pcm.sources.clear();
    }

    // trySay();

    console.log("MESSAGE IS : ", msg);
    // First close the exit modal
    setShowExitModal(false);
    window.exitHandlerOpen = false;
    MyraInteraction.closeVoice();
    MyraInteraction.closeChat();
    window.mayraCode.setIsVisible(true);

    // Small delay to ensure modal is closed
    setTimeout(() => {
      // Set mode to chat if not already
      if (MyraInteraction.getMode() !== "chat") {
        MyraInteraction.pickChat();
        MyraInteraction.onMyraMessage(msg);
      } else {
        MyraInteraction.openChat();
        MyraInteraction.onMyraMessage(msg);
      }
    }, 100);
  };
  const handleOpenMyraVoice = async (msg) => {
    const flowToStart = VoiceService._currentFlow || window.currentFlow;
    const userName = localStorage.getItem("self_name");

    window.initFromUserGesture();
    if (window.audioPlayer && window.audioPlayer.pcm) {
      // Stoping the any ongoing PCM playback
      if (typeof window.audioPlayer.ttsPcmAbort === "function") {
        window.audioPlayer.ttsPcmAbort();
      }
      // Force reset state
      window.audioPlayer.pcm.active = false;
      window.audioPlayer.pcm.queuedSamples = 0;
      window.audioPlayer.pcm.endReceived = false;
      window.audioPlayer.pcm.floatQueue = [];
      window.audioPlayer.pcm.floatQueueSamples = 0;
      window.audioPlayer.pcm.sources.clear();
    }
    if (window.audioPlayer?.ctx?.state === "suspended") {
      await window.audioPlayer.ctx.resume();
    }
    const granted = await window.requestMicrophonePermission({
      onGrant: () => {
        if (MyraInteraction.getCurrentScreen() === "intro_ar" && window.initAR) {
          window.initAR();
        }
        if (VoiceService._flowReady) {
          MyraInteraction.pickVoice();
          MyraInteraction.openVoice();
          VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, msg);
        } else {
          VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, msg);
          MyraInteraction.pickVoice();
          MyraInteraction.openVoice();
          VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
        }
      },
      onDeny: () => {
        let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
        MyraInteraction.switchMode("chat");
        MyraInteraction.openChat();
        MyraInteraction.pickChat();
        MyraInteraction.onMyraMessage(msg);
        if (window.videoController) {
          window.videoController.play();
        }
      },
    });
    setShowExitModal(false);
    // const trySay = () => {
    //   if (VoiceService._ws?.readyState === WebSocket.OPEN) {
    //     // Flow is ready, send immediately
    //     VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
    //     // WebSocket open but flow not ready yet — use the pending mechanism
    //     // that already exists in VoiceService for exactly this case
    //     VoiceService._pendingExitAnnouncement = msg;
    //   } else {
    //     VoiceService.initialize({
    //       onConnected: () => {
    //         VoiceService._ws.send(JSON.stringify({ type: "say", text: msg }));
    //         console.log("Connected voice service...");
    //       },
    //     });
    //     window.mayraCode.handleMicClick(true, true, false, true);
    //     // No connection at all — store pending and reconnect
    //     VoiceService._pendingExitAnnouncement = msg;
    //   }
    // };

    // trySay();
    // window.exitHandlerOpen = false;
    // MyraInteraction.closeChat();
    // MyraInteraction.closeVoice();
    // MyraInteraction.pickVoice();
    // MyraInteraction.openVoice();
    // window.mayraCode.setIsVisible(true);
    // const state = await getCurrentMicState();
    // if (state !== "granted") {
    //   return;
    // }
  };
  const handleCrossClicked = async () => {
    window.exitHandlerOpen = true;
    if (VoiceService._ws?.readyState !== WebSocket.OPEN) {
      VoiceService.initialize({
        onConnected: () => {
          console.log("Connected voice service...");
        },
      });
    }
    // Stop voice FIRST, synchronously, before any state changes
    VoiceService.stopAllVoiceActivity();
    VoiceService.stopAgentSpeech();
    if (window.videoController) window.videoController.pause();
    if (videoRef?.current) videoRef.current.pause();

    // State update last, isolated from voice callbacks
    setTimeout(() => {
      setShowExitModal(true);
    }, 0);
  };
  window.globalCrossClicked = handleCrossClicked;

  return (
    <div className={styles.header}>
      {/* Row 1: Logo + Progress Bar + Close */}
      <div className={styles.headerRow}>
        <img src={LOGO} alt="StartFreePT" className={styles.headerImage} style={{ margin: !showProgress ? "0 auto" : "0" }} />

        {showProgress && (
          <div className={styles.progressWrapper}>
            <div className={styles.progressContainer}>
              <div className={styles.progressBar} style={{ width: `${progress}%` }} />
            </div>
            <p>{progress}%</p>
          </div>
        )}

        {showIcon && (
          <button
            className={styles.headerCloseIcon}
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleCrossClicked();
            }}
            aria-label="Close"
          >
            &times;
          </button>
        )}
      </div>
      <GSAExitHandler
        isOpen={showExitModal}
        gsaStep={screenName}
        commMode={MyraInteraction.getMode() || null}
        onClose={() => {
          setShowExitModal(false);
          window.exitHandlerOpen = false;
        }}
        onExit={handleExitModel}
        onOpenMyraChat={(msg) => handleOpenMyraChat(msg)}
        onOpenMyraVoice={(msg) => handleOpenMyraVoice(msg)}
        onSetCommMode={(mode) => {
          if (mode === "voice") {
            MyraInteraction.pickVoice();
          } else {
            MyraInteraction.pickChat();
          }
        }}
        onAnalyticsEvent={(event) => {
          console.log("Analytics event:", event);
          AnalyticsService.trackStep(event);
        }}
      />

      {/* Row 2: Powered by line */}
      {/* <span className={styles.headerPoweredBy}>Powered by Virdio Health</span> */}

      {/* <ExitModal isOpen={showExitModal} onClose={() => setShowExitModal(false)} onExit={handleExitModel} /> */}
    </div>
  );
};
// custom Exit Modal Component
const ExitModal = ({ isOpen, onClose, onExit }) => {
  if (!isOpen) return null;

  return (
    <div id="exit-modal-overlay" className={styles.Overlay}>
      <div className={styles.Backdrop}></div>

      <div className={styles.Modal}>
        <h3 className={styles.ModalTitle}>Exit Assessment?</h3>
        <p className={styles.ModalText}>Your progress will not be saved. Are you sure you want to exit?</p>
        <div className={styles.ButtonGroup}>
          <button onClick={onClose} className={styles.CancelButton}>
            Continue Assessment
          </button>
          <button onClick={onExit} className={styles.ConfirmButton}>
            Yes, Exit
          </button>
        </div>
      </div>
    </div>
  );
};

// Custom Heading Component
const Heading = React.memo(({ heading, styles = { textAlign: "center" } }) => {
  return (
    <h2 className={styles.customHeading} style={{ ...styles }}>
      {heading}
    </h2>
  );
});

// Custom Sub-Heading Component
const SubHeading = React.memo(({ subheading, styles = { textAlign: "center" } }) => {
  return (
    <p className={styles.customSubHeading} style={{ ...styles }}>
      {subheading}
    </p>
  );
});

// Custom Video Component
const VideoComp = React.memo(({ videoSrc }) => {
  return (
    <div className={styles.HomeScreenVideoWrapper}>
      <video className={styles.HomeScreenVideo} controls autoPlay muted loop playsInline>
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
});

// Exit button component
const ExitButton = ({ onClick, title }) => {
  return (
    <button onClick={onClick} className={styles.ExitButton}>
      {title}
    </button>
  );
};

// Hard Stop Screen

export const HardStopScreen = () => {
  const history = useHistory();
  const { resetAssessmentData } = useAssessment();

  const handleClick = () => {
    localStorage.removeItem("assessmentData");
    resetAssessmentData();
    history.replace("/");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ModalContainer}>
        <div id="screen-hard-stop" className={styles.ScreenContent}>
          <svg className={styles.WarningIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
          </svg>
          <h2 className={styles.Heading}>Important Safety Notice</h2>
          <p className={styles.Text}>Thank you for your honesty. Based on your answer, your symptoms may require a direct medical evaluation.</p>
          <p className={styles.Text}>For your safety, we cannot proceed with the self-assessment at this time. Please consult a licensed medical provider.</p>

          <button onClick={handleClick} className={styles.ExitButtonHardStop}>
            Exit Assessment
          </button>
        </div>
      </div>
    </div>
  );
};
export function BackConfirmModal({ onConfirm, onCancel }) {
  return (
    <div className={styles.backBtnOverlay}>
      <div className={styles.backBtnModal}>
        <h2 className={styles.backBtnTitle}>Are you sure you want to leave?</h2>
        <p className={styles.backBtnMsg}>Your progress will be lost if you go back to the home page.</p>
        <div className={styles.backBtnRow}>
          <button className={styles.backBtnCancel} onClick={onCancel}>
            No, Stay
          </button>
          <button className={styles.backBtnConfirm} onClick={onConfirm}>
            Yes, Leave
          </button>
        </div>
      </div>
    </div>
  );
}

export const BrowserBlockScreen = ({ featureType = "gsa" }) => {
  const [result, setResult] = useState(null);

  useEffect(() => {
    const check = checkBrowserSupport(featureType);
    console.log("Browser Check Result:", check);
    if (!check.isSupported) {
      setResult(check);
    }
  }, [featureType]);

  // Browser is supported — render nothing, app continues normally
  if (!result) return null;

  const { message } = result;

  return (
    <div className={styles.deviceOverlay}>
      <div className={styles.deviceCard}>
        {/* Virdio Logo */}
        <div className={styles.deviceLogoArea}>
          <img
            src={LOGO}
            alt="Virdio Health"
            className={styles.deviceLogo}
            onError={(e) => {
              // Fallback if logo path differs — show text instead
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "block";
            }}
          />
          <span style={{ display: "none" }} className={{ ...styles.deviceLogoFallback }}>
            Virdio Health
          </span>
        </div>

        {/* Heading */}
        <p className={styles.deviceHeading}>{message.heading}</p>

        {/* Full device/browser list (unknown device only) */}
        {message.showFullList && (
          <div className={styles.deviceListContainer}>
            {message.fullList.map((item) => (
              <div key={item.device} style={styles.deviceListRow}>
                <span className={styles.listDevice}>{item.device}</span>
                <span className={styles.listDash}>—</span>
                <span className={styles.listBrowsers}>{item.browsers}</span>
              </div>
            ))}
          </div>
        )}

        {/* Action line */}
        <p className={styles.deviceAction}>{message.action}</p>

        {/* Footer / explanation */}
        <p className={styles.deviceFooter}>{message.footer}</p>
      </div>
    </div>
  );
};

const getUserConditions = () => {
  try {
    // Getting conditions from localStorage
    const userConditionStr = localStorage.getItem("userCondition");
    if (!userConditionStr) return null;

    const userCondition = JSON.parse(userConditionStr);
    const conditions = userCondition.usercondition;

    if (!conditions) return null;

    // Creating arrays from conditions
    const conditionsArray = {
      pre_existing: [],
      current: [],
    };

    // Convert to array if pre_existing exists
    if (conditions.pre_existing) {
      conditionsArray.pre_existing = [conditions.pre_existing];
    }

    // Convert to array if current exists
    if (conditions.current) {
      conditionsArray.current = [conditions.current];
    }

    // Checking if we have any conditions
    if (conditionsArray.pre_existing.length === 0 && conditionsArray.current.length === 0) {
      return null;
    }

    return conditionsArray;
  } catch (error) {
    console.error("Error getting user conditions:", error);
    return null;
  }
};
export const generatePayloadForScreen = (screenName, assessmentData, currentTest = "") => {
  const userName = window.localStorage.getItem("self_name") || "User";
  if (!window.trSessionId) {
    AnalyticsService.startSession();
  }
  // current understanding
  const getPainLocations = () => {
    return assessmentData?.selectedZones || [];
  };
  let aggregativeFactor = assessmentData?.subtypeQuestions?.value || null;
  const getAggregativeFactors = () => {
    const q1ToAggravating = {
      a: ["sitting", "slouching", "bending forward"],
      b: ["standing for a long time", "walking for a long time"],
      c: ["staying in one position too long"],
      d: ["unpredictable movements"],
      e: ["twisting", "turning", "getting in/out of a car"],
    };

    return {
      aggravating: q1ToAggravating[aggregativeFactor] || [],
    };
  };

  let perceived_subtype = assessmentData?.probableSubtype;
  const getPatternDescription = () => {
    const diagnosis = messaging.diagnosis?.[perceived_subtype];
    return diagnosis?.implications || "";
  };
  const baseline_pain = assessmentData?.painLevel ?? 5;
  let symptom_duration = assessmentData?.symptomDuration;
  let current_understanding = {
    pain_locations: getPainLocations() || [],
    aggravating_factors: getAggregativeFactors(),
    relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
    perceived_subtype: perceived_subtype,
    pattern_description: getPatternDescription(),
    baseline_pain: baseline_pain,
    symptom_duration: symptom_duration,
  };
  //  current understanding ends
  // Helper function to get current test
  const getTest1Details = () => {
    let testName = currentTest;
    return {
      name: testName || "",
      repHelp: "",
      orientation: "",
      reps: 10,
      holdTime: null,
      why_selected: messaging.diagnosis?.[perceived_subtype]?.headline,
    };
  };
  const getTest2Details = () => {
    let testName = currentTest;
    return {
      name: testName || "",
      repHelp: "",
      orientation: "",
      reps: 4,
      holdTime: null,
      why_selected: messaging.diagnosis?.[perceived_subtype]?.headline,
    };
  };
  //  test results:
  let test_results = {
    movement_test_1: { completed: true, test_name: assessmentData?.rom_test1_name, symptom_response: assessmentData.symptomResponse1, observation: "User completed all reps" },
    movement_test_2: { completed: true, test_name: assessmentData?.testName2, symptom_response: assessmentData.symptomResponseConfirm, observation: "User completed all reps" },
  };

  // payload for recovery-plan last screen
  const userProfile = {
    // Pain and assessment data
    cpgClassification: assessmentData.finalCpgClassification || "",
    subjectiveResponses: assessmentData.subtypeQuestions || {},
    symptomDuration: assessmentData.symptomDuration || "",
    preTestNPRS: assessmentData.painLevel || 0,
    probableSubtype: assessmentData.probableSubtype || "",
    finalPainSubtype: assessmentData.finalPainSubtype || "",
    recoveryScore: assessmentData.finalScore || 0,
    level: assessmentData.finalComplexityLevel || 3,

    // Biometrics
    biometrics: assessmentData.biometrics || {},

    // Additional calculated fields
    rcsCalculated: assessmentData.rcsCalculated || 0,
    totalAdjustment: assessmentData.totalAdjustment || 0,
    adjustmentDetails: assessmentData.adjustmentDetails || {},
  };

  // Build currentPlan
  const currentPlan = {
    exercises: assessmentData?.recoveryPlan?.exercises || [],
    estimatedTime: assessmentData?.recoveryPlan?.estimatedTime || "",
    rationale: assessmentData?.recoveryPlan?.rationale || "",
  };
  const userConditions = getUserConditions();

  // Screen-specific payload generators
  const payloadGenerators = {
    safety_screen: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    pain_location: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    SafetyScreeningScreen: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      current_understanding: {
        pain_locations: getPainLocations() || [],
      },
      ...(userConditions && { user_conditions: userConditions }),
    }),
    problem_area: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    cpg_questions: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      current_understanding: {
        pain_locations: getPainLocations() || [],
      },
      ...(userConditions && { user_conditions: userConditions }),
    }),
    subtype_questioning: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
      ...(userConditions && { user_conditions: userConditions }),
    }),
    self_assessment: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
      ...(userConditions && { user_conditions: userConditions }),
    }),
    nprs_symptoms: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      current_understanding: {
        pain_locations: getPainLocations() || [],
        relief_factors: messaging.diagnosis?.[perceived_subtype]?.relief,
        perceived_subtype: perceived_subtype,
        pattern_description: getPatternDescription(),
      },
      ...(userConditions && { user_conditions: userConditions }),
    }),
    test1_demo: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),

    camera_permission: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),
    movement_test_1: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),

    test1_rpe: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),
    self_report_compare: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),
    self_report_speed: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      ...(userConditions && { user_conditions: userConditions }),
    }),

    test1_symptoms: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details()],
      test_results: test_results.movement_test_1,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    test2_demo: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest2Details()],
      test_results: test_results.movement_test_1,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    movement_test_2: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest2Details()],
      test_results: test_results.movement_test_1,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    symptom2: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
      ...(userConditions && { user_conditions: userConditions }),
    }),
    personalize: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
      ...(userConditions && { user_conditions: userConditions }),
    }),

    recovery_score: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      ...userProfile,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
      ...(userConditions && { user_conditions: userConditions }),
    }),

    plan_screen: () => ({
      gsa_step: screenName,
      user_name: userName,
      input_mode: MyraInteraction.getMode() || null,
      ...current_understanding,
      current_test: [getTest1Details(), getTest2Details()],
      test_results: test_results,
      ...userProfile,
      ...currentPlan,
      ...(userConditions && { user_conditions: userConditions }),
    }),
  };

  // Get the payload generator for the requested screen
  const generator = payloadGenerators[screenName];

  if (!generator) {
    console.warn(`No payload generator found for screen: ${screenName}`);
    return {
      gsa_step: screenName,
      error: `Payload generator not configured for ${screenName}`,
    };
  }

  return generator();
};

const getBrowserDeviceData = () => ({
  browser_device: navigator.userAgent,
  timestamp_utc: new Date().toISOString(),
});

// accessgatescreen => accesscode : Dev-B0720252
export const AccessGateScreen = () => {
  usePreventNavigation("/");
  const [accessOption, setAccessOption] = useState("");
  const [betaCode, setBetaCode] = useState("");
  // const [firstName, setFirstName] = useState("");
  // const [email, setEmail] = useState("");
  // const [emailError, setEmailError] = useState("");
  const history = useHistory();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();

  const isCodeProceedDisabled = betaCode.trim() === "";

  // const isRequestProceedDisabled = (() => {
  //   const isNameValid = firstName.trim() !== "";
  //   const emailValue = email.trim();
  //   const isEmailFormatValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue);
  //   return !(isNameValid && emailValue && isEmailFormatValid);
  // })();

  // useEffect(() => {
  //   if (email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
  //     setEmailError("Please enter a valid email format.");
  //   } else {
  //     setEmailError("");
  //   }
  // }, [email]);
  useEffect(() => {
    const savedCode = localStorage.getItem("beta_access_code");
    if (savedCode) {
      setBetaCode(savedCode);
      setAccessOption("code");
    }
  }, []);

  // functions
  const submitAccessCode = async (code) => {
    console.log("--- Calling API: submitAccessCode ---");
    const payload = {
      front_ip: window.backupIP || "",
      access_code: code,
      ...getBrowserDeviceData(),
    };

    try {
      const response = await fetch(BETA_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Request failed");

      const result = await response.json();
      console.log("Backend response:", result);

      if (result?.success === true) {
        localStorage.setItem("beta_access_code", code);
      }

      return result?.success === true;
    } catch (error) {
      console.error("submitAccessCode failed:", error);
      return false;
    }
  };

  // const submitBetaRequest = async (firstName, email) => {
  //   console.log("--- Calling API Stub: submitBetaRequest ---");
  //   const payload = {
  //     first_name: firstName,
  //     email,
  //     ...getBrowserDeviceData(),
  //   };
  //   try {
  //     const response = await fetch(BETA_URL, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify(payload),
  //     });

  //     if (!response.ok) throw new Error("Request failed");

  //     console.log("Payload to send:", payload);
  //     await new Promise((r) => setTimeout(r, 500));
  //     console.log("Request submitted successfully.");
  //     console.log("---------------------------------------");
  //     return true;
  //   } catch (error) {
  //     console.error("submitBetaRequest failed:", error);
  //     return false;
  //   }
  // };

  const handleProceed = async (type, data) => {
    // Modified on Aug 7th - for user tracking
    const currentData = { ...assessmentData, started_assessment: true, beta_access_type: type, ...data };
    updateAssessmentData(currentData);
    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(currentData);

    if (type === "code") {
      const isValid = await submitAccessCode(data.code);
      if (isValid) {
        history.replace("/red-flags");
      } else {
        history.replace("/invalid-code");
      }
    }
    // else if (type === "request") {
    //   const success = await submitBetaRequest(data.firstName, data.email);
    //   if (success) history.replace("/red-flags");
    // }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header showProgress={false} />
        <h2 className={styles.AGHeading}>Beta Program Access</h2>
        <p className={styles.AGSubheading}>This guided self-assessment is part of a limited beta program. Please choose how you'd like to proceed.</p>

        <div className={styles.AGOptionsWrapper}>
          {/* Option 1: Have a code */}
          <div>
            <input type="radio" name="access-option" id="option-have-code" value="code" checked={accessOption === "code"} onChange={(e) => setAccessOption(e.target.value)} className={styles.AGHiddenRadio} />
            <label htmlFor="option-have-code" className={`${styles.AGOptionCard} ${accessOption === "code" ? styles.AGOptionCardSelected : ""}`} onClick={() => {}}>
              <h4 className={styles.AGOptionTitle}>I have an access code</h4>
            </label>

            {accessOption === "code" && (
              <div className={styles.AGOptionContent}>
                <label htmlFor="beta-code" className={styles.AGLabel}>
                  Enter your access code below
                </label>
                <input type="text" id="beta-code" value={betaCode} onChange={(e) => setBetaCode(e.target.value)} placeholder="e.g., BETA-12345" className={styles.AGInputField} autoComplete="off" />
                <button onClick={() => handleProceed("code", { code: betaCode })} className={styles.AGButton} disabled={isCodeProceedDisabled}>
                  Proceed
                </button>
              </div>
            )}
          </div>

          {/* Option 2: Request access */}
          {/* <div>
            <input
              type="radio"
              name="access-option"
              id="option-request-access"
              value="request"
              checked={accessOption === "request"}
              onChange={(e) => setAccessOption(e.target.value)}
              className={styles.AGHiddenRadio}
            />
            <label
              htmlFor="option-request-access"
              className={`${styles.AGOptionCard} ${
                accessOption === "request" ? styles.AGOptionCardSelected : ""
              }`}
              onClick={() => {}}
            >
              <h4 className={styles.AGOptionTitle}>
                I don't have a code, but I'd like to join the beta
              </h4>
            </label>

            {accessOption === "request" && (
              <div className={styles.AGOptionContent}>
                <div>
                  <label htmlFor="first-name" className={styles.AGLabel}>
                    Enter your first name
                  </label>
                  <input
                    type="text"
                    id="first-name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    className={styles.AGInputField}
                    autoComplete="off"
                  />
                </div>
                <div>
                  <label htmlFor="email" className={styles.AGLabel}>
                    Enter your email address
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={styles.AGInputField}
                    autoComplete="off"
                  />
                  <p className={styles.AGErrorText}>{emailError}</p>
                </div>
                <button
                  onClick={() => handleProceed("request", { firstName, email })}
                  className={styles.AGButton}
                  disabled={isRequestProceedDisabled}
                >
                  Proceed
                </button>
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

// invalid code screen
export const InvalidCodeScreen = () => {
  usePreventNavigation("/");
  const histroy = useHistory();
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ textAlign: "center" }}>
        <Header showProgress={false} />
        <div className={styles.invalidScreenIconWrapper}>
          <svg className={styles.invalidScreenIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
        <h2 className={styles.invalidScreenHeading}>Invalid Access Code</h2>
        <p className={styles.invalidScreenMessage}>The code you entered is not valid. Please check the code and try again.</p>
        <CommonButton title={"Try Again"} onClick={() => histroy.push("/access-gate")} />
      </div>
    </div>
  );
};

// Custom Hook to increase the height based on weather the panel is open or not
export function useMyraPanel() {
  const getState = () => {
    const isChat = MyraInteraction.isChatOpen();
    const isVoice = MyraInteraction.isVoiceOpen();
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    const mode = MyraInteraction.getMode();

    const isExpanded = isChat || isVoice;

    return {
      isExpanded,
      panelSize: isMobile ? (isChat ? "47vh" : isVoice ? "36vh" : "0vh") : isExpanded ? (mode === "chat" ? "0px" : "300px") : "0px",
      isMobile,
      mode,
    };
  };

  const [state, setState] = useState(getState());

  useEffect(() => {
    const update = () => setState(getState());

    const unsubscribers = [MyraInteraction.on("chatOpen", update), MyraInteraction.on("chatClose", update), MyraInteraction.on("voiceOpen", update), MyraInteraction.on("voiceClose", update), MyraInteraction.on("modeChange", update)];

    return () => unsubscribers.forEach((unsub) => unsub());
  }, []);

  return state;
}

// safety or red flags screen
export const SafetyScreen = () => {
  useScrollToTop();

  usePreventNavigation("/");

  localStorage.setItem("startedSelf", "1");

  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let safetyScreenPayload = generatePayloadForScreen("safety_screen", assessmentData);
  console.log("safetyScreenPayload data is : ", safetyScreenPayload);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const [safetyExit, setSafetyExit] = useState(false);
  const [showAdvisory, setShowAdvisory] = useState(false);
  const [screenStatus, setScreenStatus] = useState("checklist");
  const [outcomeText, setOutcomeText] = useState("");
  const screenStatusRef = useRef("checklist");
  const checkedItemsRef = useRef([]);
  const [choice, setChoice] = useState("");

  const history = useHistory();
  useEffect(() => {
    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }
    MyraInteraction.onScreenEnter("safety_screen");
    window.screenTracker.enterScreen("safety_screen");
    setProgress(5);
  }, []);

  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          handleClick();
        }
      },
      MOVE_ON: (value, speech, intent) => {
        handleClick();
      },
      SAFETY_CONTINUE: (value) => {
        // gtag conversion
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD",
            value: 1.0,
            currency: "USD",
          });
        }
        handleClick();
      },

      SAFETY_STOP: (value) => {
        setOutcomeText(value || "");
        setScreenStatus("stopped");
        screenStatusRef.current = "stopped";
        // Follow-up message — Myra stays available
        const followUp = MYRA_MESSAGES.safetyOutcome?.stoppedFollowUp || /* PLACEHOLDER COPY */ "I know this isn't the news you were hoping for. If you have any questions, I'm right here.";

        // Push stop card to conversation history
        setSafetyExit(true);
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          if (window.mayraCode) {
            window.mayraCode.doSay(followUp);
          }
        } else {
          VoiceService.startFlowWithoutAnnouncement("flow_gsa", "", followUp);
        }
      },

      SAFETY_ADVISORY: (value) => {
        setOutcomeText(value || "");
        setShowAdvisory(true);
        setScreenStatus("advisory");
        screenStatusRef.current = "advisory";
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(safetyScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [safetyScreenPayload, isVoiceReady, myraTurnedOnCount]);

  const handleClick = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD",
        value: 1.0,
        currency: "USD",
        event_callback: () => {
          console.log("Conversion");
        },
      });
    }

    window.screenTracker.exitScreen("safety_screen", {
      exitReason: "completed_safety",
      completed: true,
    });
    MyraInteraction.onScreenEnter("cpg_questions");
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      red_flag_exit: true,
      completed_safety_screen: true,
      // selected_problem_area: true,
      // problemArea: "LBP",
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/cpg-questions");
    // history.replace("/pain-location");
  };

  const hardStopScreen = () => {
    const updatedData = { ...assessmentData, red_flag_exit: true };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/hard-stop");
  };
  if (safetyExit) {
    return (
      <div className={styles.ScreenWrapper}>
        <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
          <Header screenName="safety_screen" />
          <div className={styles.hardStopIcon}>🩺</div>
          <div className={styles.hardStopTitle}>We recommend waiting</div>
          <p className={styles.hardStopText}>{outcomeText}</p>
        </div>
      </div>
    );
  }
  if (showAdvisory) {
    return (
      <div className={styles.ScreenWrapper}>
        <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
          <Header screenName="safety_screen" />
          <div
            style={{
              background: "#fffbeb",
              border: "1px solid #f59e0b",
              borderRadius: "0.75rem",
              padding: "1.25rem",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>⚠️</div>
            <p style={{ fontSize: "0.875rem", color: "#4b5563", lineHeight: 1.5 }}>{outcomeText}</p>
            <p style={{ fontSize: "0.8rem", color: "#9ca3af", marginTop: "0.75rem", fontStyle: "italic" }}>{choice === "leave" ? "You chose to come back later." : ""}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="safety_screen" />
        <Heading heading="Quick Safety Check" />
        <SubHeading subheading="Before we move forward, let us know if you're experiencing any of these symptoms:" />
        <ul className={styles.SymptomList}>
          <li>Sharp or shooting pain down your legs?</li>
          <li>Numbness or tingling in your legs or feet?</li>
          <li>Leg weakness, instability, or "giving out"?</li>
          <li>Changes in bowel or bladder control?</li>
        </ul>
        <p className={styles.symptomScreenSubHeading}>If none of these apply, you can press continue</p>

        <CommonButton title="Continue" onClick={handleClick} />
        <ExitButton title={"I have one or more symptoms"} onClick={hardStopScreen} />
      </div>
    </div>
  );
};

export const ProblemAreaScreen = () => {
  useScrollToTop();
  usePreventNavigation("/");
  const { setProgress } = useProgress();
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  const [selectedArea, setSelectedArea] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  console.log("selected area is : ", selectedArea);
  let problemAreaPayload = generatePayloadForScreen("problem_area", assessmentData);
  console.log("problemArea data is : ", problemAreaPayload);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const [homeAgeConfirm, setHomeAgeConfirm] = useState(false);
  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  useEffect(() => {
    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }
    MyraInteraction.onScreenEnter("problem_area");
    window.screenTracker.enterScreen("problem_area");
    setProgress(10);
  }, [setProgress]);

  useEffect(() => {
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (intent === "continue_command") {
          if (selectedArea && homeAgeConfirm === true) {
            handleContinue();
          } else {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        }
        if (extracted.problemArea) {
          setSelectedArea(extracted.problemArea);
          console.log("[VOICE] Updating problem area to:", extracted.problemArea);
        }
        console.log("EXTRACTED IS  : ", extracted);
      },
      MOVE_ON: () => {
        if (selectedArea && homeAgeConfirm === true) {
          handleContinue();
        } else {
          window.mayraCode.doSay("Please make your selection before we can move to the next screen");
        }
      },
    };
  }, [selectedArea, homeAgeConfirm]);
  useEffect(() => {
    window.initFromUserGesture();
    if (assessmentData?.EngagedOnLanding) {
      let announcementName;
      const userName = localStorage.getItem("self_name") || "";
      const hasDoneGsaBefore = localStorage.getItem("didGsaFlowBefore") === "true";
      if (hasDoneGsaBefore) {
        announcementName = "flow_gsa_welcome_back";
      } else {
        announcementName = "flow_gsa_first_time";
      }
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        window.mayraCode.setIsVisible(true);
        window.mayraForwardCode = {
          midjourneyData: problemAreaPayload,
        };
        window.currentFlow = "flow_gsa";
        VoiceService._currentFlow = "flow_gsa";
        setTimeout(() => {
          window.mayraCode.startFlow("flow_gsa", announcementName, () => {
            localStorage.setItem("didGsaFlowBefore", "true");
            console.log("User has completed GSA flow, flag set");
          });
        }, 500);
      }
    } else {
      VoiceService._currentFlow = "flow_gsa";
      window.currentFlow = "flow_gsa";
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraForwardCode = {
          midjourneyData: problemAreaPayload,
        };
      }, 1000);
    }
  }, []);
  useEffect(() => {
    if (window.exitHandlerOpen) return;
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(problemAreaPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [problemAreaPayload, isVoiceReady, myraTurnedOnCount]);

  useEffect(() => {
    if (window.exitHandlerOpen) return;
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  const problemAreas = Object.keys(CLINICAL_PATHS).map((key) => ({
    id: key,
    label: CLINICAL_PATHS[key].name,
  }));
  const COMING_SOON = ["Shoulder", "Elbow", "Ankle", "Wrist", "Neck", "Flexibility"];

  const handleSelect = (areaId) => {
    window.problemArea = areaId;
    setSelectedArea(areaId);
  };
  const handleChange = (e) => {
    setHomeAgeConfirm(e.target.checked);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      setHomeAgeConfirm((prev) => !prev);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Thanks! We'll notify you when we add more areas.");
    setIsModalOpen(false);
  };
  const handleContinue = () => {
    window.screenTracker.exitScreen("problem_area", {
      exitReason: "problem_area_selected",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    const updatedData = {
      ...assessmentData,
      selected_problem_area: true,
      problemArea: selectedArea,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    history.replace("/pain-location");
  };

  useEffect(() => {
    const check = checkBrowserSupport("gsa");
    console.log("Browser Check Result:", check);
    if (!check.isSupported) {
      setShowMemberBlockScreen(true);
    }
  }, []);

  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="gsa" />;
  }

  return (
    <>
      <div className={styles.ScreenWrapper}>
        <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
          <Header screenName="problem_area" />

          {/* content */}
          <div className={styles.ProbAreaContent}>
            <h1 className={styles.ProbAreaQuestion}>Where did your pain initially start?</h1>

            <p className={styles.ProbAreaSubtitle}>You can pinpoint multiple locations on the next screen.</p>

            {/* <p className={styles.ProbAreaHelperText}>You'll pinpoint the exact location on the next screen.</p> */}
            <div className={styles.ProbAreaOptions}>
              {problemAreas.map((item) => (
                <div key={item.id} className={`${styles.ProbAreaOptionCard} ${selectedArea === item.id ? styles.ProbAreaSelected : ""}`} onClick={() => handleSelect(item.id)}>
                  {item.label}
                </div>
              ))}
            </div>
          </div>
          {/* coming soon */}
          {/* <div className={styles.ProbAreaComingSoonSection}>
            <div className={styles.ProbAreaComingSoonHeader}>
              <span className={styles.ProbAreaComingSoonLabel}>Coming Soon</span>
            </div>

            <div className={styles.ProbAreaComingSoonTags}>
              {COMING_SOON.map((tag) => (
                <span key={tag} className={styles.ProbAreaTag}>
                  {tag}
                </span>
              ))}
            </div>

            <div className={styles.ProbAreaNotifyLink} onClick={() => setIsModalOpen(true)}>
              Get notified when we add your area →
            </div>
          </div> */}
          {/* <button className={styles.ProbAreaContinueBtn} disabled={!selectedArea} onClick={handleContinue}>
            Continue
          </button> */}
          <div className={styles.HomeScreenCheckboxWrapper}>
            <input autoComplete="off" type="checkbox" id="age-confirm" className={styles.HomeScreenCheckboxInput} checked={homeAgeConfirm} onChange={handleChange} onKeyDown={handleKeyDown} />
            <label htmlFor="age-confirm" className={styles.HomeScreenCheckboxLabel} tabIndex={0}>
              I confirm I am 18 years of age or older.
            </label>
          </div>
          <CommonButton title={"Continue"} onClick={handleContinue} disabled={!selectedArea || !homeAgeConfirm} />
        </div>
      </div>
      {/* {isModalOpen && (
        <div className={styles.ProbAreaModalOverlay} onClick={() => setIsModalOpen(false)}>
          <div className={styles.ProbAreaModal} onClick={(e) => e.stopPropagation()}>
            <h2 className={styles.ProbAreaModalTitle}>Get Notified</h2>
            <p className={styles.ProbAreaModalSubtitle}>We'll let you know when we add support for your area.</p>

            <form className={styles.ProbAreaModalForm} onSubmit={handleSubmit}>
              <input type="email" required placeholder="Enter your email" className={styles.ProbAreaModalInput} />
              <button className={styles.ProbAreaModalBtn}>Notify Me</button>
            </form>

            <button className={styles.ProbAreaModalClose} onClick={() => setIsModalOpen(false)}>
              Maybe later
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};

export const PainLocationScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  const [selectedZones, setSelectedZones] = useState(new Set());
  console.log("selected zones are : ", selectedZones);
  const canvasRef = useRef(null);
  const bodyWrapRef = useRef(null);
  const bodyImgRef = useRef(null);
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  console.log("assessmentData in pain location screen is : ", assessmentData);
  let painLocationScreenPayload = generatePayloadForScreen("pain_location", assessmentData);
  console.log("painLocationScreenPayload data is : ", painLocationScreenPayload);
  const history = useHistory();
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.screenTracker.enterScreen("pain_location");
    MyraInteraction.onScreenEnter("pain_location");
    setProgress(15);
  }, []);
  useEffect(() => {
    if (!assessmentData.problemArea) {
      history.replace("/red-flags");
    }
  }, [assessmentData.problemArea, history]);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (intent === "continue_command") {
          if (selectedZones.size <= 0) {
            // handleContinue();
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
        if (extracted && extracted.selectedZones) {
          // Convert array to Set
          const zonesArray = Array.isArray(extracted.selectedZones) ? extracted.selectedZones : [extracted.selectedZones];
          const zonesSet = new Set(zonesArray);
          setSelectedZones(zonesSet);
          console.log("[VOICE] Updating selectedZones to:", zonesSet);
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (selectedZones.size <= 0) {
          // handleContinue();
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(painLocationScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [painLocationScreenPayload, isVoiceReady, myraTurnedOnCount]);

  const curTab = assessmentData.problemArea || "LBP";
  const zoneButtons = ZONE_BUTTONS[curTab] || { left: [], right: [] };

  const toggleZone = (side, zoneName) => {
    const key = `${side}:${zoneName}`;
    setSelectedZones((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  };

  // Canvas sizing
  const sizeCanvas = () => {
    const cv = canvasRef.current;
    const bw = bodyWrapRef.current;
    if (!cv || !bw) return;
    cv.width = bw.offsetWidth;
    cv.height = bw.offsetHeight;
  };

  // Get image rect relative to body wrapper
  const imgRect = () => {
    const bimg = bodyImgRef.current;
    const bw = bodyWrapRef.current;
    if (!bimg || !bw) return { x: 0, y: 0, w: 0, h: 0 };
    const ir = bimg.getBoundingClientRect();
    const wr = bw.getBoundingClientRect();
    return { x: ir.left - wr.left, y: ir.top - wr.top, w: ir.width, h: ir.height };
  };

  // Convert percentage coords to canvas pixels
  const pctToCanvas = (px, py, pw, ph) => {
    const r = imgRect();
    return [r.x + (px / 100) * r.w, r.y + (py / 100) * r.h, (pw / 100) * r.w, (ph / 100) * r.h];
  };

  // Rounded rectangle path helper
  const rrect = (ctx, x, y, w, h, rad) => {
    rad = Math.min(rad, w / 2, h / 2);
    ctx.moveTo(x + rad, y);
    ctx.arcTo(x + w, y, x + w, y + h, rad);
    ctx.arcTo(x + w, y + h, x, y + h, rad);
    ctx.arcTo(x, y + h, x, y, rad);
    ctx.arcTo(x, y, x + w, y, rad);
    ctx.closePath();
  };

  // Draw highlights on canvas
  const drawHL = () => {
    const cv = canvasRef.current;
    if (!cv) return;
    const ctx = cv.getContext("2d");
    ctx.clearRect(0, 0, cv.width, cv.height);

    selectedZones.forEach((key) => {
      const [side, ...rest] = key.split(":");
      const name = rest.join(":");
      // Back-facing body: "left" button → use "right" coords and vice versa
      const lookupSide = side === "left" ? "left" : "right";
      const reg = TAB_COORDS[curTab]?.[lookupSide]?.[name];
      if (!reg) return;

      const [cx, cy, cw, ch] = pctToCanvas(reg[0], reg[1], reg[2], reg[3]);
      const type = hlType(name);
      const visSide = lookupSide;

      if (type === "full") {
        ctx.fillStyle = "rgba(220,38,38,0.35)";
        ctx.beginPath();
        rrect(ctx, cx, cy, cw, ch, 5);
        ctx.fill();
      } else if (type === "split") {
        ctx.fillStyle = "rgba(220,38,38,0.35)";
        const half = splitHalf(name);
        if (half === "upper") {
          ctx.beginPath();
          rrect(ctx, cx, cy, cw, ch / 2, 5);
          ctx.fill();
        } else {
          ctx.beginPath();
          rrect(ctx, cx, cy + ch / 2, cw, ch / 2, 5);
          ctx.fill();
        }
      } else if (type === "edge") {
        ctx.strokeStyle = "rgba(220,38,38,0.70)";
        ctx.lineWidth = 3.5;
        ctx.setLineDash([]);
        const es = edgeSide(name);
        ctx.beginPath();
        if (es === "inner") {
          if (visSide === "left") {
            ctx.moveTo(cx, cy);
            ctx.lineTo(cx, cy + ch);
          } else {
            ctx.moveTo(cx + cw, cy);
            ctx.lineTo(cx + cw, cy + ch);
          }
        } else {
          if (visSide === "left") {
            ctx.moveTo(cx + cw, cy);
            ctx.lineTo(cx + cw, cy + ch);
          } else {
            ctx.moveTo(cx, cy);
            ctx.lineTo(cx, cy + ch);
          }
        }
        ctx.stroke();
      }
    });
  };

  // Effect to redraw canvas when selections change
  useEffect(() => {
    sizeCanvas();
    drawHL();
  }, [selectedZones, curTab]);

  // Effect to handle window resize
  useEffect(() => {
    const handleResize = () => {
      sizeCanvas();
      drawHL();
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [selectedZones, curTab]);

  const handleContinue = () => {
    window.screenTracker.exitScreen("pain_location", {
      exitReason: "zones_selected",
      completed: true,
    });
    MyraInteraction.onScreenEnter("safety_screen");
    const screenFlow = window.screenTracker.getScreenFlow();
    // Convert Set to Array for storage
    const selectedZonesArray = [...selectedZones];
    const updatedData = {
      ...assessmentData,
      selected_pain_location: true,
      selectedZones: selectedZonesArray,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData({ selectedZones: selectedZonesArray });
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    const problemArea = assessmentData.problemArea;
    if (problemArea === "HIP" || problemArea === "THIGH" || problemArea === "KNEE") {
      history.replace("/safety-screening");
    } else {
      // history.replace("/cpg-questions");
      history.replace("/red-flags");
    }
  };
  // Helper to render zone buttons
  const renderZoneButton = (zoneName, side) => {
    const key = `${side}:${zoneName}`;
    const isSelected = selectedZones.has(key);
    return (
      <button key={key} className={`${styles.ZoneBtn} ${isSelected ? styles.ZoneBtnSelected : ""}`} onClick={() => toggleZone(side, zoneName)} aria-pressed={isSelected}>
        {zoneName}
      </button>
    );
  };

  // Parse composite key for display
  const formatSelection = (key) => {
    const [side, ...rest] = key.split(":");
    const name = rest.join(":");
    return `${side.charAt(0).toUpperCase() + side.slice(1)} ${name}`;
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="pain_location" />
        <Heading heading="Highlight Your Pain Areas" />
        <SubHeading subheading="Tap the buttons on both sides of the body to highlight where you’re feeling pain." />
        <div className={styles.BodySection}>
          <span className={`${styles.SideLabel} ${styles.SideLabelLeft}`}>LEFT</span>
          <span className={`${styles.SideLabel} ${styles.SideLabelRight}`}>RIGHT</span>

          {/* Left button column (viewer's left = body's RIGHT side for back-facing) */}
          <div className={`${styles.BtnCol} ${styles.BtnColLeft}`}>{zoneButtons.left.map((zoneName) => renderZoneButton(zoneName, "left"))}</div>

          {/* Body image with canvas overlay */}
          <div className={styles.BodyWrap} ref={bodyWrapRef}>
            <img
              ref={bodyImgRef}
              src={SKELETON}
              alt="Human body outline"
              className={styles.BodyImg}
              onLoad={() => {
                sizeCanvas();
                drawHL();
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = SKELETON_PLACEHOLDER;
              }}
            />
            <canvas ref={canvasRef} className={styles.HlCanvas} />
          </div>

          {/* Right button column (viewer's right = body's LEFT side for back-facing) */}
          <div className={`${styles.BtnCol} ${styles.BtnColRight}`}>{zoneButtons.right.map((zoneName) => renderZoneButton(zoneName, "right"))}</div>
        </div>

        {/* Selected areas chips */}
        {/* <div className={styles.SelectedAreaWrapper}>
          <h3 className={styles.SelectedAreaTitle}>Selected Areas:</h3>
          <div className={styles.ChipsWrapper}>
            {selectedZones.size > 0 ? (
              [...selectedZones].sort().map((key) => (
                <span className={styles.Chip} key={key}>
                  {formatSelection(key)}
                  <span
                    className={styles.ChipX}
                    onClick={() => {
                      const [side, ...rest] = key.split(":");
                      toggleZone(side, rest.join(":"));
                    }}
                  >
                    ×
                  </span>
                </span>
              ))
            ) : (
              <span className={styles.NoSelection}>Tap buttons to select pain areas</span>
            )}
          </div>
        </div> */}
        <CommonButton title={"Continue"} onClick={handleContinue} disabled={selectedZones.size === 0} />
      </div>
    </div>
  );
};

export const SafetyScreeningScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  const { assessmentData, updateAssessmentData } = useAssessment();
  const history = useHistory();
  const [selectedOption, setSelectedOption] = useState(null);
  let SafetyScreeningPayload = generatePayloadForScreen("SafetyScreeningScreen", assessmentData);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const [safetyExit, setSafetyExit] = useState(false);
  const [showAdvisory, setShowAdvisory] = useState(false);
  const [screenStatus, setScreenStatus] = useState("checklist");
  const [outcomeText, setOutcomeText] = useState("");
  const screenStatusRef = useRef("checklist");
  const checkedItemsRef = useRef([]);
  const [choice, setChoice] = useState("");

  const problemArea = assessmentData.problemArea;
  const safetyData = SAFETY_QUESTIONS[problemArea];

  useEffect(() => {
    window.screenTracker.enterScreen("safety_screening");
    MyraInteraction.onScreenEnter("SafetyScreeningScreen");
    setProgress(20);
  }, [setProgress]);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    // Redirect if no problem area or if LBP (shouldn't reach this screen)
    if (!problemArea || problemArea === "LBP" || !safetyData) {
      history.replace("/cpg-questions");
    }
  }, [problemArea, safetyData, history]);

  useEffect(() => {
    window.initFromUserGesture();

    // Voice command handlers
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedOption) {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedOption) {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },

      SAFETY_CONTINUE: (value) => {
        // gtag conversion
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD",
            value: 1.0,
            currency: "USD",
          });
        }
        handleContinue();
      },

      SAFETY_STOP: (value) => {
        setOutcomeText(value || "");
        setScreenStatus("stopped");
        screenStatusRef.current = "stopped";
        // Follow-up message — Myra stays available
        const followUp = MYRA_MESSAGES.safetyOutcome?.stoppedFollowUp || /* PLACEHOLDER COPY */ "I know this isn't the news you were hoping for. If you have any questions, I'm right here.";

        // Push stop card to conversation history
        setSafetyExit(true);
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          if (window.mayraCode) {
            window.mayraCode.doSay(followUp);
          }
        } else {
          VoiceService.startFlowWithoutAnnouncement("flow_gsa", "", followUp);
        }
      },

      SAFETY_ADVISORY: (value) => {
        setOutcomeText(value || "");
        setShowAdvisory(true);
        setScreenStatus("advisory");
        screenStatusRef.current = "advisory";
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(SafetyScreeningPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [SafetyScreeningPayload, isVoiceReady, myraTurnedOnCount, selectedOption]);

  const handleSelect = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (!selectedOption) return;

    window.screenTracker.exitScreen("safety_screening", {
      exitReason: selectedOption.value === "CLEAR" ? "cleared_safety" : "excluded_safety",
      completed: true,
    });
    MyraInteraction.onScreenEnter("cpg_questions");

    const screenFlow = window.screenTracker.getScreenFlow();
    const updatedData = {
      ...assessmentData,
      safetyScreenResult: selectedOption.value,
      safetyScreenSelection: selectedOption.id,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    // Route based on selection
    if (selectedOption.value === "CLEAR") {
      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-18002481001/kXlOCNefkpccEOmeoIhD",
          value: 1.0,
          currency: "USD",
          event_callback: () => {
            console.log("Conversion");
          },
        });
      }

      history.replace("/cpg-questions");
    } else {
      history.replace("/hard-stop");
    }
  };

  if (!safetyData) return null;

  if (safetyExit) {
    return (
      <div className={styles.ScreenWrapper}>
        <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
          <Header screenName="safety_screening" />
          <div className={styles.hardStopIcon}>🩺</div>
          <div className={styles.hardStopTitle}>We recommend waiting</div>
          <p className={styles.hardStopText}>{outcomeText}</p>
        </div>
      </div>
    );
  }
  if (showAdvisory) {
    return (
      <div className={styles.ScreenWrapper}>
        <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
          <Header screenName="safety_screening" />
          <div
            style={{
              background: "#fffbeb",
              border: "1px solid #f59e0b",
              borderRadius: "0.75rem",
              padding: "1.25rem",
              textAlign: "center",
            }}
          >
            <div style={{ fontSize: "1.5rem", marginBottom: "0.5rem" }}>⚠️</div>
            <p style={{ fontSize: "0.875rem", color: "#4b5563", lineHeight: 1.5 }}>{outcomeText}</p>
            <p style={{ fontSize: "0.8rem", color: "#9ca3af", marginTop: "0.75rem", fontStyle: "italic" }}>{choice === "leave" ? "You chose to come back later." : ""}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="safety_screening" />
        <Heading heading="Additional Safety Check" />
        <SubHeading subheading={safetyData.prompt} />
        <div className={styles.OptionList} style={{ marginTop: "1.5rem" }}>
          {safetyData.options.map((option) => {
            const isSelected = selectedOption?.id === option.id;
            return (
              <div className={styles.OptionWrapper} key={option.id}>
                <input type="radio" autoComplete="off" name="safety-option" id={`safety-${option.id}`} value={option.id} checked={isSelected} onChange={() => handleSelect(option)} className={styles.HiddenRadio} />
                <label htmlFor={`safety-${option.id}`} tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleSelect(option)} className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}>
                  <h4 className={styles.OptionLabelText}>{option.label}</h4>
                </label>
              </div>
            );
          })}
        </div>
        <CommonButton title={"Continue"} disabled={!selectedOption} onClick={handleContinue} />
      </div>
    </div>
  );
};

// has leg pain function
const hasLegPain = (selectedZones = []) => {
  const legZones = ["left:Thigh", "right:Thigh", "left:Lower Leg", "right:Lower Leg"];

  return selectedZones.some((zone) => legZones.includes(zone));
};
// cpg to subtype mapping
const cpgToSubtype = (cpgValue) => {
  // switch (cpgValue) {
  //   case "LBP with Mobility Deficits":
  //     return "LIMITED_LUMBAR_MOBILITY";
  //   case "LBP with Movement Coordination Impairments":
  //     return "NEUTRAL_SENSITIVE";
  //   default:
  //     return null;
  // }
  if (!cpgValue) return null;
  if (cpgValue.includes("Mobility Deficits")) {
    return "LIMITED_LUMBAR_MOBILITY";
  }
  if (cpgValue.includes("Movement Coordination") || cpgValue.includes("Both / Not Sure")) {
    return "NEUTRAL_SENSITIVE";
  }
  return null;
};

// cpq question screen
export const CPGQuestionScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let cpgQuestionScreenPayload = generatePayloadForScreen("cpg_questions", assessmentData);
  console.log("cpgQuestionScreenPayload data is : ", cpgQuestionScreenPayload);
  const history = useHistory();
  const [selectedOption, setSelectedOption] = useState(null);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  console.log("CPG OPTION : ", selectedOption);
  // Get problem area from assessment data
  const problemArea = assessmentData.problemArea || "LBP";
  const clinicalPath = CLINICAL_PATHS[problemArea];

  // Determine which options to show based on problem area
  const selectedZones = assessmentData.selectedZones || [];
  const isLegPain = hasLegPain(selectedZones);
  console.log("problemArea is  : ", assessmentData.problemArea);
  console.log("selectedZones is  : ", selectedZones);
  console.log("is leg pain  : ", isLegPain);
  let options;
  let questionText;
  if (problemArea === "LBP") {
    // EXISTING LBP LOGIC - NO CHANGES
    options = isLegPain ? CPG_OPTIONS : BACK_CPG_OPTIONS;
    questionText = isLegPain ? "Which of these best describes the feeling in your leg?" : "Which of these best describes your main complaint?";
  } else if (clinicalPath && clinicalPath.cpgQuestion) {
    // HIP, THIGH, or KNEE
    options = clinicalPath.cpgQuestion.options;
    questionText = clinicalPath.cpgQuestion.prompt;
  } else {
    // Fallback
    options = BACK_CPG_OPTIONS;
    questionText = "Which of these best describes your main complaint?";
  }
  useEffect(() => {
    MyraInteraction.onScreenEnter("cpg_questions");
    window.screenTracker.enterScreen("cpg_questions");
    setProgress(25);
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedOption || selectedOption === null) {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedOption || selectedOption === null) {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(cpgQuestionScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [cpgQuestionScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    const probableSubtype = cpgToSubtype(selectedOption?.value);
    console.log("Probable Subtype:", probableSubtype);
    window.screenTracker.exitScreen("cpg_questions", {
      exitReason: "cpg_selected",
      completed: true,
    });
    MyraInteraction.onScreenEnter("subtype_questioning");
    const screenFlow = window.screenTracker.getScreenFlow();

    let updatedData = {
      ...assessmentData,
      cpgValue: selectedOption,
      screenFlow: screenFlow,
      cpgForBackend: selectedOption.cpgForBackend || null,
      session_last_update: new Date().toISOString(),
    };
    if (problemArea === "LBP") {
      // EXISTING LBP LOGIC - NO CHANGES
      const probableSubtype = cpgToSubtype(selectedOption?.value);
      updatedData = {
        ...updatedData,
        ...(isLegPain ? {} : { probableSubtype }),
      };

      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);

      if (isLegPain) {
        history.replace("/subtype-questioning");
      } else {
        history.replace("/pre-npr");
      }
    } else {
      // HIP, THIGH, or KNEE routing
      const selectedCpgOption = selectedOption;

      // Store the CPG for backend matching
      updatedData.cpgCategory = selectedCpgOption.value;
      updatedData.cpgForBackend = selectedCpgOption.cpgForBackend;

      if (selectedCpgOption.routesTo === "direct") {
        // Direct path - no subtype question, go straight to tests

        // THIGH NEURAL ROUTING: Use zone data to determine appropriate subtype
        // Medical rationale: Different nerves affect different thigh regions
        // - Posterior: Sciatic nerve → Hamstring exercises
        // - Lateral: Lateral femoral cutaneous nerve → ITB exercises
        // - Anterior: Femoral nerve → Quad exercises
        // - Multiple zones: Conservative default → Hamstring exercises
        if (assessmentData.problemArea === "THIGH" && selectedCpgOption.value === "THIGH_NEURAL_INVOLVEMENT") {
          const zones = assessmentData.selectedZones || [];
          const zoneString = zones.join(" ").toLowerCase();

          // Single zone selections get targeted routing
          if (zones.length === 1) {
            if (zoneString.includes("anterior") || zoneString.includes("front")) {
              updatedData.probableSubtype = "QUADRICEPS_LOADING_IMPACT_INTOLERANCE";
            } else if (zoneString.includes("lateral") || zoneString.includes("outer")) {
              updatedData.probableSubtype = "ITB_FRICTION_SYNDROME";
            } else {
              // Posterior or any other single zone
              updatedData.probableSubtype = "HAMSTRING_LOADING_LENGTHENING_DEFICIT";
            }
          } else {
            // Multiple zones selected - use conservative hamstring default
            updatedData.probableSubtype = "HAMSTRING_LOADING_LENGTHENING_DEFICIT";
          }
        } else {
          // All other direct routes use the configured subtype from CONSTANTS
          updatedData.probableSubtype = selectedCpgOption.directSubtype;
        }

        updatedData.skipSubtypeQuestion = true;

        // Track original selection if it was consolidated
        if (selectedCpgOption.displayLabel) {
          updatedData.originalSelection = selectedCpgOption.displayLabel;
        }

        updateAssessmentData(updatedData);
        localStorage.setItem("assessmentData", JSON.stringify(updatedData));
        AnalyticsService.trackStep(updatedData);

        // Skip subtype question, go to pre-npr
        history.replace("/pre-npr");
      } else {
        // Routes to subtype question
        updatedData.subtypeQuestionIndex = selectedCpgOption.subtypeQuestionIndex;

        updateAssessmentData(updatedData);
        localStorage.setItem("assessmentData", JSON.stringify(updatedData));
        AnalyticsService.trackStep(updatedData);

        history.replace("/subtype-questioning");
      }
    }
  };
  const handleChange = (e) => {
    const selected = options.find((opt) => opt.id === e.target.id);
    setSelectedOption(selected);
    console.log("Selected Option:", selectedOption);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSelectedOption(option);
      console.log("Selected Option:", selectedOption);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="cpg_questions" />
        <div>
          <h3 className={styles.CPGQuestionHeading}>{questionText}</h3>
          <div className={styles.OptionList}>
            {options.map((option) => {
              const isSelected = selectedOption?.id === option.id;

              return (
                <div className={styles.OptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="cpg" id={option.id} value={option.value} checked={isSelected} onChange={handleChange} className={styles.HiddenRadio} />
                  <label htmlFor={option.id} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, option)} className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}>
                    <h4 className={styles.OptionLabelText}>{option.label}</h4>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <CommonButton title={"Continue"} disabled={!selectedOption} onClick={handleContinue} />
      </div>
    </div>
  );
};

// SubtypeQuestioningScreen

export const SubtypeQuestioningScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  console.log("assessmentData in subtype questioning screen is : ", assessmentData);
  console.log("selected option is : ", selectedOption);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  const problemArea = assessmentData.problemArea || "LBP";
  const clinicalPath = CLINICAL_PATHS[problemArea];
  const Q1_OPTIONS = [
    {
      id: "q1a",
      value: "a",
      label: "Feels worse when sitting, slouching, or bending forward.",
    },
    {
      id: "q1b",
      value: "b",
      label: "Feels worse when standing or walking for a long time.",
    },
    {
      id: "q1e", // New ID
      value: "e", // New Value
      label: "Feels worse with twisting, turning, or getting in/out of a car.",
    },
    {
      id: "q1c",
      value: "c",
      label: "Feels worse if I stay in one position too long.",
    },
    {
      id: "q1d",
      value: "d",
      label: "Hard to say—it seems to be unpredictable.", // Modified wording for clarity
    },
  ];

  // Determine which subtype question to show
  let subtypeQuestion;
  let questionText;
  let options;

  if (problemArea === "LBP") {
    questionText = "Which best describes your lower back pain?";
    options = Q1_OPTIONS;
  } else if (clinicalPath && clinicalPath.subtypeQuestions) {
    // HIP, THIGH, or KNEE
    const questionIndex = assessmentData.subtypeQuestionIndex || 0;
    subtypeQuestion = clinicalPath.subtypeQuestions[questionIndex];
    questionText = subtypeQuestion?.prompt || "Please select an option:";
    options = subtypeQuestion?.options || [];
  }

  let subTypeQuestionScreenPayload = generatePayloadForScreen("subtype_questioning", assessmentData);
  console.log("subTypeQuestionScreenPayload data is : ", subTypeQuestionScreenPayload);

  const history = useHistory();
  useEffect(() => {
    setProgress(35);
    window.screenTracker.enterScreen("subtype_questioning");
    MyraInteraction.onScreenEnter("subtype_questioning");
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedOption || selectedOption === null) {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedOption || selectedOption === null) {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(subTypeQuestionScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [subTypeQuestionScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    window.screenTracker.exitScreen("subtype_questioning", {
      exitReason: "subtype_selected",
      completed: true,
    });
    MyraInteraction.onScreenEnter("self_assessment");
    const screenFlow = window.screenTracker.getScreenFlow();
    const updatedData = {
      ...assessmentData,
      probableSubtype: selectedOption.value,
      subtypeSelection: selectedOption,
      subtypeQuestions: selectedOption,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    // Track original selection if it was consolidated (user picked rotational but routes to posterior)
    if (selectedOption.displayLabel) {
      updatedData.originalSelection = selectedOption.displayLabel;
    }

    // Set CPG for backend based on problem area and subtype
    if (SUBTYPE_TO_CPG_MAP[problemArea]?.[selectedOption.value]) {
      updatedData.cpgForBackend = SUBTYPE_TO_CPG_MAP[problemArea][selectedOption.value];
    }

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    if (problemArea === "LBP") {
      history.replace("/self-assesment");
    } else {
      history.replace("/pre-npr");
    }
  };

  const handleChange = (e) => {
    const selected = options.find((option) => option.id === e.target.value);
    setSelectedOption(selected);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSelectedOption(option);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="subtype_questioning" />
        <div>
          <h3 className={styles.CPGQuestionHeading}>{questionText}</h3>
          <div id="q1-options" className={styles.Q1OptionList}>
            {options.map((option) => {
              const isSelected = selectedOption?.id === option.id;
              return (
                <div className={styles.Q1OptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="q1" id={option.id} value={option.id} checked={isSelected} onChange={handleChange} className={styles.HiddenRadio} />
                  <label
                    htmlFor={option.id}
                    tabIndex={0}
                    onKeyDown={(e) => handleKeyDown(e, option)}
                    className={`${styles.OptionLabel} ${isSelected ? styles.OptionSelected : styles.OptionUnselected}`}
                    style={{
                      borderWidth: isSelected ? "5px" : "2px",
                      borderStyle: "solid",
                    }}
                  >
                    <h4 className={styles.OptionLabelText}>{option.label}</h4>
                  </label>
                </div>
              );
            })}
          </div>

          <CommonButton title="Continue" onClick={handleContinue} disabled={!selectedOption} />
        </div>
      </div>
    </div>
  );
};

// Function to determine subtype based on answers
function getSubtypeFromAnswers(q1, q2) {
  if (q1 === "a") {
    return q2 === "yes" ? "FLEXION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => before
    // return q2 === "yes" ? "EXTENSION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => after
  }
  if (q1 === "b") {
    return q2 === "yes" ? "EXTENSION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => before
    // return q2 === "yes" ? "FLEXION_INTOLERANT" : "NEUTRAL_SENSITIVE"; // => after
  }
  // START ADDITION
  if (q1 === "e") {
    return q2 === "yes" ? "ROTATIONAL_INTOLERANT" : "NEUTRAL_SENSITIVE";
  }
  // END ADDITION
  return "NEUTRAL_SENSITIVE"; // q1 === c or d
}

// self assessment screen
export const SelfAssessmentScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let selfAssesmentScreenPayload = generatePayloadForScreen("self_assessment", assessmentData);
  console.log("selfAssesmentScreenPayload data is : ", selfAssesmentScreenPayload);
  console.log("selfAssesment data is : ", assessmentData);
  const { subtypeQuestions } = assessmentData;
  const [selectedAnswer, setSelectedAnswer] = useState("");
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { setProgress } = useProgress();
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const history = useHistory();
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    setProgress(45);
    window.screenTracker.enterScreen("self_assessment");
    MyraInteraction.onScreenEnter("self_assessment");
  }, []);
  useEffect(() => {
    // Optional safety: redirect if no subtype question
    if (!subtypeQuestions?.value) {
      history.replace("/subtype-questioning");
    }
  }, [subtypeQuestions]);
  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (!selectedAnswer || selectedAnswer === "") {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!selectedAnswer || selectedAnswer === "") {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(selfAssesmentScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [selfAssesmentScreenPayload, isVoiceReady, myraTurnedOnCount]);

  if (!subtypeQuestions) {
    return <p className="text-center mt-6">Invalid question flow.</p>;
  }

  const question = (() => {
    switch (subtypeQuestions.value) {
      case "a":
        return {
          id: "screen-q2a",
          name: "q2a",
          title: "Does gently arching your back or standing up straight help ease the pain?",
        };
      case "b":
        return {
          id: "screen-q2b",
          name: "q2b",
          title: "Does sitting down or slouching help ease the pain?",
        };
      case "e": // New case for rotation
        return {
          id: "screen-q2e",
          name: "q2e",
          title: "Does it feel better when you avoid twisting motions?",
        };
      case "c":
      case "d":
        return {
          id: "screen-q3",
          name: "q3",
          title: "Is changing positions the best way to find relief?",
        };
      default:
        return null;
    }
  })();

  const handleContinue = () => {
    window.screenTracker.exitScreen("self_assessment", {
      exitReason: "self_assessment_completed",
      completed: true,
    });
    MyraInteraction.onScreenEnter("nprs_symptoms");
    const screenFlow = window.screenTracker.getScreenFlow();

    const probableSubtype = getSubtypeFromAnswers(subtypeQuestions.value, selectedAnswer);

    const updatedData = {
      ...assessmentData,
      selfAssessmentAnswer: selectedAnswer,
      probableSubtype,
      screenFlow: screenFlow,
      subtypeQuestions: subtypeQuestions,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    history.replace("/pre-npr");
  };
  const handleKeyDown = (e, value) => {
    if (e.key === "Enter") {
      onChange({ target: { name: question.name, value } });
    }
  };

  const onChange = (e) => {
    setSelectedAnswer(e.target.value);
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="self_assessment" />
        <div>
          <div id={question.id} className={styles.ScreenSection}>
            <h3 className={styles.SectionTitle}>{question.title}</h3>
            <div className={styles.OptionRow}>
              {/* YES */}
              <input type="radio" autoComplete="off" name={question.name} id={`${question.name}_yes`} value="yes" className={styles.HiddenRadio} checked={selectedAnswer === "yes"} onChange={onChange} />
              <label htmlFor={`${question.name}_yes`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, "yes")} className={`${styles.OptionButton} ${selectedAnswer === "yes" ? styles.OptionSelected : styles.OptionUnselected}`}>
                <h4 className={styles.OptionText}>Yes</h4>
              </label>

              {/* NO / UNSURE */}
              <input type="radio" autoComplete="off" name={question.name} id={`${question.name}_no`} value="no" className={styles.HiddenRadio} checked={selectedAnswer === "no"} onChange={onChange} />
              <label htmlFor={`${question.name}_no`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, "no")} className={`${styles.OptionButton} ${selectedAnswer === "no" ? styles.OptionSelected : styles.OptionUnselected}`}>
                <h4 className={styles.OptionText}>No / Unsure</h4>
              </label>
            </div>
          </div>

          <CommonButton title="Continue" onClick={handleContinue} disabled={!selectedAnswer} />
        </div>
      </div>
    </div>
  );
};

// get pain colors component

const getInlinePainStyle = (value, isSelected) => {
  let color = "#10B981";
  let textColor = "#15803D";

  if (value > 3 && value <= 7) {
    color = "#F59E0B";
    textColor = "#CA8A04";
  } else if (value > 7) {
    color = "#EF4444";
    textColor = "#B91C1C";
  }

  return {
    borderColor: color,
    color: isSelected ? "white" : textColor,
    backgroundColor: isSelected ? color : "white",
    transform: isSelected ? "scale(1.1)" : "scale(1)",
  };
};

// pre-npr screen
export const PreNprScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  let preNprScreenPayload = generatePayloadForScreen("nprs_symptoms", assessmentData);
  console.log("preNprScreenPayload data is : ", preNprScreenPayload);
  const history = useHistory();
  const [painLevel, setPainLevel] = useState(null);
  const [symptomDuration, setSymptomDuration] = useState("");
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [myraTurnedOnCount, setMyraTurnedOnCount] = useState(0);
  console.log("Assessment Data in PreNprScreen:", assessmentData);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  useEffect(() => {
    setProgress(55);
    window.screenTracker.enterScreen("nprs_symptoms");
    MyraInteraction.onScreenEnter("nprs_symptoms");
  }, []);

  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        setMyraTurnedOnCount((prev) => prev + 1);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.initFromUserGesture();

    // Set up command handler immediately
    window.currentCommandsAudio = {
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        // Handle continue command
        if (intent === "continue_command") {
          if (!painLevel || !symptomDuration || painLevel === null || symptomDuration === "") {
            if (window.mayraCode) {
              window.mayraCode.doSay("Please make your selection before we can move to the next screen");
            }
          } else {
            handleContinue();
          }
          return;
        }

        // Handle extracted data
        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          // Handle pain level
          if (extracted.painLevel !== undefined && extracted.painLevel !== null) {
            const painValue = typeof extracted.painLevel === "number" ? extracted.painLevel : parseInt(extracted.painLevel);

            if (!isNaN(painValue) && painValue >= 0 && painValue <= 10) {
              setPainLevel(painValue);
              console.log("[VOICE] Updating pain level to:", painValue);
            }
          }

          // Handle symptom duration
          if (extracted.symptomDuration) {
            // Map the duration to the expected values: "ACUTE", "SUBACUTE", "CHRONIC"
            let durationValue = extracted.symptomDuration;

            // If it's a descriptive string, map it to the correct value
            if (typeof durationValue === "string") {
              const durationMap = {
                "less than 6 weeks": "ACUTE",
                acute: "ACUTE",
                "6 weeks to 3 months": "SUBACUTE",
                subacute: "SUBACUTE",
                "more than 3 months": "CHRONIC",
                chronic: "CHRONIC",
                "over 3 months": "CHRONIC",
              };

              // Check if it's a mapped value
              const lowerValue = durationValue.toLowerCase();
              if (durationMap[lowerValue]) {
                durationValue = durationMap[lowerValue];
              } else if (durationValue === "ACUTE" || durationValue === "SUBACUTE" || durationValue === "CHRONIC") {
                // Already in correct format
                durationValue = durationValue;
              } else {
                // Try to determine from the text
                if (lowerValue.includes("week") && parseInt(lowerValue) < 6) {
                  durationValue = "ACUTE";
                } else if (lowerValue.includes("month")) {
                  durationValue = "CHRONIC";
                }
              }
            }

            // Only update if it's a valid value
            if (["ACUTE", "SUBACUTE", "CHRONIC"].includes(durationValue)) {
              setSymptomDuration(durationValue);
              console.log("[VOICE] Updating symptom duration to:", durationValue);
            }
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (!painLevel || !symptomDuration || painLevel === null || symptomDuration === "") {
          if (window.mayraCode) {
            window.mayraCode.doSay("Please make your selection before we can move to the next screen");
          }
        } else {
          handleContinue();
        }
      },
    };

    // Function to initialize voice when ready
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        VoiceService._currentFlow = "flow_gsa";
        window.currentFlow = "flow_gsa";
        window.mayraCode.setIsVisible(true);

        // Try to send data if WebSocket is ready
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(preNprScreenPayload);
          setIsVoiceReady(true);
          console.log("Successfully sent midjourney data");
        }
      }
    };

    // Check immediately
    initializeVoice();

    // Set up interval to check WebSocket connection
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    // Set up listener for WebSocket connection
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      console.log("VoiceService connected, sending midjourney data");
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    // Cleanup
    return () => {
      clearInterval(checkConnectionInterval);
      // Restore original callback if it exists
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [preNprScreenPayload, isVoiceReady, myraTurnedOnCount]);
  const handleContinue = () => {
    VoiceService._currentFlow = null;
    window.currentFlow = null;
    MyraInteraction.switchMode(null);
    // if (!assessmentData?.EngagedOnLanding) {
    //   window.mayraCode.handleMicClick(true);
    // }
    if (window.initFromUserGesture) {
      window.initFromUserGesture();
    }
    // if (VoiceService._ws?.readyState === WebSocket.OPEN) {
    //   window.mayraCode.handleMicClick(true);
    //   VoiceService.stopAllVoiceActivity();
    //   VoiceService.forceStop();
    // }

    const nextTest = determineNextTest(assessmentData.probableSubtype, 1);
    const testName = nextTest?.name || "";

    window.screenTracker.exitScreen("nprs_symptoms", {
      exitReason: "npr_completed",
      completed: true,
    });
    MyraInteraction.onScreenEnter("test1_demo");
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      painLevel,
      symptomDuration,
      floorCapability: testName === "Supine Double Knee to Chest" ? "" : "floor",
      completed_nprs: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    if (testName === "Supine Double Knee to Chest") {
      history.replace("/test-intro");
    } else {
      window.clickedOnceOpen = false;
      history.replace("/test-intro");
    }
  };
  const isFormComplete = painLevel !== null && symptomDuration !== "";
  const handleSymptomKeyDown = (e, value) => {
    if (e.key === "Enter") {
      setSymptomDuration(value);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="nprs_symptoms" />

        <div>
          <div id="screen-pre-nprs" className={styles.ScreenContainer}>
            <h3 className={styles.ScreenTitle}>Tell Us About Your Pain</h3>

            {/* Pain Level Section */}
            <div className={styles.PainSection}>
              <p className={styles.PainPrompt}>What is your pain level right now?</p>
              <p className={styles.PainSubtext}>(0 is no pain, 10 is the worst imaginable)</p>

              <div className={styles.PainGrid}>
                {Array.from({ length: 11 }, (_, i) => {
                  const isSelected = painLevel === i;

                  return (
                    <button key={i} type="button" tabIndex={0} onClick={() => setPainLevel(i)} onKeyDown={(e) => e.key === "Enter" && setPainLevel(i)} className={`${styles.PainCircle}`} style={getInlinePainStyle(i, isSelected)}>
                      {i}
                    </button>
                  );
                })}
              </div>

              <div className={styles.PainScaleLabels}>
                <span className={styles.NoPain}>No Pain</span>
                <span className={styles.WorstPain}>Worst Pain</span>
              </div>
            </div>

            {/* Symptom Duration Section */}
            <div className={styles.SymptomSection}>
              <p className={styles.PainPrompt}>How long have you been experiencing these symptoms?</p>
              <div id="symptom-duration-options" className={styles.OptionList}>
                {[
                  {
                    id: "duration-acute",
                    value: "ACUTE",
                    label: "Less than 6 weeks",
                  },
                  {
                    id: "duration-subacute",
                    value: "SUBACUTE",
                    label: "6 weeks to 3 months",
                  },
                  {
                    id: "duration-chronic",
                    value: "CHRONIC",
                    label: "More than 3 months",
                  },
                ].map(({ id, value, label }) => (
                  <div className={styles.OptionWrapper} key={id}>
                    <input type="radio" autoComplete="off" name="symptom-duration" id={id} value={value} className={styles.HiddenRadio} checked={symptomDuration === value} onChange={(e) => setSymptomDuration(e.target.value)} />
                    <label htmlFor={id} tabIndex={0} onKeyDown={(e) => handleSymptomKeyDown(e, value)} className={`${styles.OptionLabel} ${symptomDuration === value ? styles.OptionSelected : styles.OptionUnselected}`}>
                      <h4 className={styles.OptionLabelText}>{label}</h4>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* <button id="pre-nprs-continue" onClick={handleContinue} className={styles.ContinueButton} disabled={!isFormComplete}>
              Continue
            </button> */}
            <CommonButton title="Continue" onClick={handleContinue} disabled={!isFormComplete} />
          </div>
        </div>
      </div>
    </div>
  );
};

// floor capability screen floor-capability
export const FloorCapabilityScreen = () => {
  usePreventNavigation("/");
  const [selected, setSelected] = useState("");
  console.log("FloorCapabilityScreen Rendered : ", selected);
  const { assessmentData, updateAssessmentData } = useAssessment();
  console.log("painLevel : ", assessmentData.painLevel);

  const history = useHistory();
  const { setProgress } = useProgress();
  useEffect(() => {
    setProgress(60);
  }, []);

  const handleChange = (value) => {
    setSelected(value);
  };

  const handleKeyDown = (e, value) => {
    if (e.key === "Enter" || e.key === " ") {
      setSelected(value);
    }
  };

  const handleSubmit = () => {
    if (window.initFromUserGesture) {
      window.initFromUserGesture();
    }

    const updatedData = {
      ...assessmentData,
      floorCapability: selected,
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    window.clickedOnceOpen = false;

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);
    history.replace("/test-intro");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header screenName="floor_capability" />
        <h3 className={styles.capascrTitle}>Quick Check-In: What Works Best for You?</h3>
        <p className={styles.capascrDescription}>Your upcoming movement test is designed for the floor, but we want to make sure it’s comfortable for you. Let us know what works best for your current needs.</p>

        <div id="floor-capability-options-pre-test" className={styles.capascrOptions}>
          {[
            {
              id: "pre-capability-floor",
              value: "floor",
              label: "I’m comfortable getting on and off the floor",
            },
            {
              id: "pre-capability-bed",
              value: "bed",
              label: "I’d prefer to do it on my bed",
            },
            {
              id: "pre-capability-seated",
              value: "seated_standing",
              label: "I need a seated or standing option",
            },
          ].map((opt) => (
            <div key={opt.id} className={styles.capascrOption}>
              <input type="radio" name="floor-capability-pre-test" id={opt.id} value={opt.value} checked={selected === opt.value} onChange={() => handleChange(opt.value)} className={styles.capascrHiddenRadio} />
              <label htmlFor={opt.id} className={`${styles.capascrLabel} ${selected === opt.value ? styles.capascrSelected : ""}`} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, opt.value)}>
                <h4 className={styles.capascrLabelText}>{opt.label}</h4>
              </label>
            </div>
          ))}
        </div>
        <CommonButton title={"Continue"} disabled={!selected} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export function determineNextTest(probableSubtype, testNumber) {
  const selectedMap = testNumber === 1 ? testMap : negativeTestMap;
  return selectedMap[probableSubtype] || null;
}

// /intro-ar
export const IntroAR = () => {
  const history = useHistory();
  const { setProgress } = useProgress();
  const { assessmentData } = useAssessment();

  // Local state for mode selection
  const [selectedMode, setSelectedMode] = useState("voice");

  // Get intro AR state from controller
  const introARState = MyraInteraction.getIntroARState();

  console.log("IntroAR Rendered: ", introARState);

  let testName;
  if (assessmentData.floorCapability === "seated_standing") {
    testName = "Seated Single Knee to Chest";
  } else {
    const nextTest = determineNextTest(assessmentData.probableSubtype, 1);
    testName = nextTest?.name || "";
  }

  const introVideoUrl = testSpecificIntroVideos[testName] || DEFAULT_INTRO_VIDEO;

  useEffect(() => {
    setProgress(63);
    // Notify controller that we entered this screen
    MyraInteraction.onScreenEnter("intro_ar");
  }, [setProgress]);

  const handleModeSelect = (mode) => {
    setSelectedMode(mode);
    // Update the global reference in MyraAgent
    if (window.mayraCode && window.mayraCode.onIntroARModeSelect) {
      window.mayraCode.onIntroARModeSelect(mode);
    }

    window.initFromUserGesture();
    if (window.preloadAllAudios) window.preloadAllAudios();
  };

  const onContinueHandler = () => {
    // 1. Confirm the selected mode with controller
    MyraInteraction.confirmIntroARMode(selectedMode);

    // 2. If voice mode is selected, show mic permission if needed
    if (selectedMode === "voice") {
      window.mayraCode.handlePickVoice();
    }
    if (selectedMode === "chat") {
      // No mic permission needed
      MyraInteraction.confirmIntroARMode("chat");
      // No mic modal shown
      // Chat panel will open when needed
    }

    // 3. Navigate to next screen
    // history.replace("/test-intro");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header screenName="intro_ar" />
        <h2 className={styles.introARHeading}>Get Ready for Your Test</h2>
        <p className={styles.introARSubtitle}>Follow these tips for the best results.</p>

        <div className={styles.introARVideoWrapper}>
          <video className={styles.introARVideo} controls autoPlay muted loop playsInline>
            <source src={introVideoUrl} type="video/mp4" />
          </video>
        </div>

        {/* Render the mode card based on controller state */}
        <IntroARModeCard introARState={introARState} selectedMode={selectedMode} onSelectMode={handleModeSelect} />

        <button onClick={onContinueHandler} className={styles.introARButton}>
          Continue
        </button>
      </div>
    </div>
  );
};

// Usage example:
// const howChallengingPayload = generatePayloadForScreen('how_challenging', assessmentData);
// detect video command from value

const detectVideoCommand = (value) => {
  const text = value.toLowerCase().trim();

  if (text.includes("pause") || text.includes("paused")) {
    return "PAUSE";
  }

  if (text.includes("play") || text.includes("resume") || text.includes("playing")) {
    return "PLAY";
  }

  if (text.includes("skip") || text.includes("skipped")) {
    return "SKIP";
  }

  if (text.includes("replay") || text.includes("replaying") || text.includes("again")) {
    return "REPLAY";
  }

  if (text.includes("expand") || text.includes("fullscreen") || text.includes("full screen")) {
    return "EXPAND";
  }

  return null;
};
function useMyraVoiceAssistant(midjourneyData, options = {}) {
  const { maxRetries = 3, sendOnConnect = true } = options;

  const [state, setState] = useState({
    isConnected: false,
    isListening: false,
    isAgentSpeaking: false,
    isReady: false,
    lastDataSent: 0,
  });

  const prevStateRef = useRef(state);
  const midjourneyDataRef = useRef(midjourneyData);
  const isMountedRef = useRef(true);

  // Update ref when midjourneyData changes
  useEffect(() => {
    midjourneyDataRef.current = midjourneyData;
  }, [midjourneyData]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Subscribe to VoiceService state changes
  useEffect(() => {
    if (!VoiceService._callbacks) return;

    // Save original callbacks
    const originalCallbacks = {
      onConnected: VoiceService._callbacks.onConnected,
      onAgentSpeechStart: VoiceService._callbacks.onAgentSpeechStart,
      onAgentSpeechEnd: VoiceService._callbacks.onAgentSpeechEnd,
      onListeningStart: VoiceService._callbacks.onListeningStart,
      onListeningStop: VoiceService._callbacks.onListeningStop,
    };

    // Override callbacks to update our state
    VoiceService._callbacks.onConnected = () => {
      console.log("[MyraHook] Connected callback");
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isConnected: true }));

        // Send midjourney data on connection if option is enabled
        if (sendOnConnect && midjourneyDataRef.current) {
          setTimeout(() => sendMidJourneyDataWithRetry(), 500);
        }
      }
      originalCallbacks.onConnected();
    };

    VoiceService._callbacks.onAgentSpeechStart = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isAgentSpeaking: true }));
      }
      originalCallbacks.onAgentSpeechStart();
    };

    VoiceService._callbacks.onAgentSpeechEnd = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isAgentSpeaking: false }));
      }
      originalCallbacks.onAgentSpeechEnd();
    };

    VoiceService._callbacks.onListeningStart = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isListening: true }));
      }
      originalCallbacks.onListeningStart();
    };

    VoiceService._callbacks.onListeningStop = () => {
      if (isMountedRef.current) {
        setState((prev) => ({ ...prev, isListening: false }));
      }
      originalCallbacks.onListeningStop();
    };

    // Restore original callbacks on cleanup
    return () => {
      if (VoiceService._callbacks && originalCallbacks) {
        VoiceService._callbacks.onConnected = originalCallbacks.onConnected;
        VoiceService._callbacks.onAgentSpeechStart = originalCallbacks.onAgentSpeechStart;
        VoiceService._callbacks.onAgentSpeechEnd = originalCallbacks.onAgentSpeechEnd;
        VoiceService._callbacks.onListeningStart = originalCallbacks.onListeningStart;
        VoiceService._callbacks.onListeningStop = originalCallbacks.onListeningStop;
      }
    };
  }, [sendOnConnect]);

  // Periodic state checking for redundancy
  useEffect(() => {
    const checkState = () => {
      if (!isMountedRef.current) return;

      const newState = {
        isConnected: VoiceService._ws?.readyState === WebSocket.OPEN,
        isListening: VoiceService._isListening,
        isAgentSpeaking: VoiceService._isAgentSpeaking,
        isReady: VoiceService._ws?.readyState === WebSocket.OPEN && VoiceService._isListening && !VoiceService._isAgentSpeaking,
        lastDataSent: state.lastDataSent,
      };

      const prevState = prevStateRef.current;

      // Detect state changes
      if (newState.isListening !== prevState.isListening) {
        console.log(`[MyraHook] Listening state changed: ${prevState.isListening} → ${newState.isListening}`);

        // Myra turned ON
        if (newState.isListening && !prevState.isListening) {
          console.log("[MyraHook] Myra turned ON - sending midjourney data");
          sendMidJourneyDataWithRetry();
        }

        // Myra turned OFF
        if (!newState.isListening && prevState.isListening) {
          console.log("[MyraHook] Myra turned OFF");
        }
      }

      // Detect connection changes
      if (newState.isConnected !== prevState.isConnected) {
        console.log(`[MyraHook] Connection state changed: ${prevState.isConnected} → ${newState.isConnected}`);

        // Reconnected while listening
        if (newState.isConnected && !prevState.isConnected && newState.isListening) {
          console.log("[MyraHook] Reconnected while listening - resending data");
          sendMidJourneyDataWithRetry();
        }
      }

      // Update refs and state
      if (JSON.stringify(newState) !== JSON.stringify(prevState)) {
        prevStateRef.current = newState;
        setState(newState);
      }
    };

    // Start checking state
    const interval = setInterval(checkState, 500);

    // Initial check
    setTimeout(checkState, 100);

    return () => clearInterval(interval);
  }, [state.lastDataSent]); // Only re-run when lastDataSent changes

  const sendMidJourneyDataWithRetry = useCallback(
    async (customData = null) => {
      const data = customData || midjourneyDataRef.current;
      if (!data) {
        console.warn("[MyraHook] No midjourney data to send");
        return false;
      }

      const sendAttempt = async (attempt = 1) => {
        try {
          if (!VoiceService._ws || VoiceService._ws.readyState !== WebSocket.OPEN) {
            throw new Error("WebSocket not connected");
          }

          console.log(`[MyraHook] Sending midjourney data (attempt ${attempt})`);
          const success = VoiceService.sendMidJourneyData(data);

          if (success) {
            console.log("[MyraHook] Midjourney data sent successfully");
            if (isMountedRef.current) {
              setState((prev) => ({
                ...prev,
                lastDataSent: Date.now(),
                isReady: true,
              }));
            }
            return true;
          } else {
            throw new Error("VoiceService.sendMidJourneyData returned false");
          }
        } catch (error) {
          console.warn(`[MyraHook] Failed to send midjourney data: ${error.message}`);

          if (attempt < maxRetries) {
            // Exponential backoff
            const delay = Math.min(5000, 1000 * Math.pow(2, attempt - 1));
            console.log(`[MyraHook] Retrying in ${delay}ms...`);

            await new Promise((resolve) => setTimeout(resolve, delay));
            return sendAttempt(attempt + 1);
          }

          console.error("[MyraHook] Max retries exceeded");
          return false;
        }
      };

      return sendAttempt();
    },
    [maxRetries],
  );

  // Manual send function
  const sendMidJourneyData = useCallback(
    (customData = null) => {
      return sendMidJourneyDataWithRetry(customData);
    },
    [sendMidJourneyDataWithRetry],
  );

  // Force send when Myra is turned on via bubble click
  const forceSendOnMyraToggle = useCallback(() => {
    console.log("[MyraHook] Force sending data on Myra toggle");
    return sendMidJourneyDataWithRetry();
  }, [sendMidJourneyDataWithRetry]);

  return {
    state,
    sendMidJourneyData,
    forceSendOnMyraToggle,
  };
}
const getTestForCurrentAssessment = (assessmentData, isSecondTest = false) => {
  const problemArea = assessmentData.problemArea || "LBP";
  const subtype = assessmentData.probableSubtype;

  window.selectedSubType = subtype;

  if (problemArea === "LBP") {
    // Use existing testMap/negativeTestMap
    return isSecondTest ? negativeTestMap[subtype] : testMap[subtype];
  } else {
    // Use CLINICAL_PATHS lookup
    return isSecondTest ? getSecondTestForSubtype(problemArea, subtype) : getFirstTestForSubtype(problemArea, subtype);
  }
};
export const TestIntroScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const floorCapability = assessmentData?.floorCapability || "floor";
  const probableSubtype = assessmentData?.probableSubtype || "NEUTRAL_SENSITIVE";
  const [videoUrl, setVideoUrl] = useState("");
  const currentTestPhase = 1;
  const testPool = currentTestPhase === 1 ? testMap : negativeTestMap;
  const [isVoiceAssistantReady, setIsVoiceAssistantReady] = useState(false);
  // let test = testPool[probableSubtype];
  let test = getTestForCurrentAssessment(assessmentData, false);
  let currentTest = test?.name;
  const testIntroPayload = generatePayloadForScreen("test1_demo", assessmentData, currentTest);
  let cameraPayload = generatePayloadForScreen("camera_permission", assessmentData, currentTest);
  window.cameraPayload = cameraPayload;
  let movementTestPayload = generatePayloadForScreen("movement_test_1", assessmentData, currentTest);
  window.movementTestPayload = movementTestPayload;
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { state: voiceState, sendMidJourneyData, forceSendOnMyraToggle } = useMyraVoiceAssistant(testIntroPayload, { maxRetries: 3, sendOnConnect: true });
  let seconndTest = getTestForCurrentAssessment(assessmentData, true);
  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const [selectedMode, setSelectedMode] = useState("voice");
  const [showDetails, setShowDetails] = useState(false);
  const introARState = MyraInteraction.getIntroARState();
  const [mode, setMode] = useState(MyraInteraction.getMode());
  useEffect(() => {
    const unsubMode = MyraInteraction.on("modeChange", ({ mode }) => {
      setMode(mode);
    });
    return () => {
      if (unsubMode) unsubMode();
    };
  }, []);

  useEffect(() => {
    window.currentCommandsAudio = {
      GIVE_NAME: (nameGiven) => {
        console.log("Got name", nameGiven);
        localStorage.setItem("self_name", nameGiven);
        window.currentFlow = "flow_demo_video";
        VoiceService._currentFlow = "flow_demo_video";
        if (mode === "voice") {
          window.mayraCode.startFlow("flow_demo_video", "first_video_play_name", () => {
            doReplyVideo();
          });
        } else {
          VoiceService.startFlowWithoutAnnouncement("flow_demo_video");
        }

        window.currentCommandsAudio = {
          SKIP_VIDEO: () => {
            doPauseVideo();
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                handleContinue();
              }, 500);
            });
          },
          MOVE_ON: () => {
            doPauseVideo();
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                handleContinue();
              }, 500);
            });
          },
          REPLAY_VIDEO: () => {
            doPauseVideo();
            window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
              setTimeout(() => {
                doReplyVideo();
              }, 400);
            });
          },
          PAUSE_VIDEO: () => {
            if (window.videoController) {
              if (window.videoController.isPaused()) {
                window.mayraCode.doSay("The video is already paused.");
              } else {
                window.videoController.pause();
                window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                  doPauseVideo();
                });
              }
            }
          },
          RESUME_VIDEO: () => {
            if (window.videoController && window.videoController.isPaused()) {
              window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          EXPAND_VIDEO: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                window.videoController.expand();
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          INVALID_COMMAND: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          VALID_COMMAND: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
        };
      },

      SKIP_NAME: () => {
        console.log("No name given");
        window.currentFlow = "flow_demo_video";
        VoiceService._currentFlow = "flow_demo_video";
        if (mode === "voice") {
          window.mayraCode.startFlow("flow_demo_video", "first_video_play_name", () => {
            doReplyVideo();
          });
        } else {
          VoiceService.startFlowWithoutAnnouncement("flow_demo_video");
        }

        window.currentCommandsAudio = {
          SKIP_VIDEO: () => {
            doPauseVideo();
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                handleContinue();
              }, 500);
            });
          },
          MOVE_ON: () => {
            doPauseVideo();
            window.mayraCode.doSay("Got it! Skipping the video.", () => {
              setTimeout(() => {
                handleContinue();
              }, 500);
            });
          },
          REPLAY_VIDEO: () => {
            doPauseVideo();
            window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
              setTimeout(() => {
                doReplyVideo();
              }, 400);
            });
          },
          PAUSE_VIDEO: () => {
            if (window.videoController) {
              if (window.videoController.isPaused()) {
                window.mayraCode.doSay("The video is already paused.");
              } else {
                window.videoController.pause();
                window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                  doPauseVideo();
                });
              }
            }
          },
          RESUME_VIDEO: () => {
            if (window.videoController && window.videoController.isPaused()) {
              window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          EXPAND_VIDEO: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                window.videoController.expand();
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          INVALID_COMMAND: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
          VALID_COMMAND: () => {
            if (window.videoController) {
              window.videoController.pause();
              window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                setTimeout(() => {
                  window.videoController.play();
                }, 400);
              });
            }
          },
        };
      },
      SKIP_VIDEO: () => {
        if (window.videoController) window.videoController.pause();
        doPauseVideo();
        window.mayraCode.doSay("Got it! Skipping the video.", () => {
          setTimeout(() => {
            handleContinue();
          }, 500);
        });
      },
      MOVE_ON: () => {
        if (window.videoController) window.videoController.pause();
        doPauseVideo();
        window.mayraCode.doSay("Got it! Skipping the video.", () => {
          setTimeout(() => {
            handleContinue();
          }, 500);
        });
      },
      REPLAY_VIDEO: () => {
        if (window.videoController) window.videoController.pause();
        doPauseVideo();
        window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
          doReplyVideo();
          if (window.videoController) window.videoController.replay();
        });
      },
      PAUSE_VIDEO: () => {
        if (window._lastPauseTime && Date.now() - window._lastPauseTime < 2000) return;
        if (window.videoController) {
          if (window.videoController.isPaused()) {
            window.mayraCode.doSay("The video is already paused.");
          } else {
            window.videoController.pause();
            window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
              window._lastPauseTime = Date.now();
              doPauseVideo();
            });
          }
        }
      },
      RESUME_VIDEO: () => {
        if (window.videoController && window.videoController.isPaused()) {
          window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
            setTimeout(() => {
              window.videoController.play();
            }, 400);
          });
        }
      },
      EXPAND_VIDEO: () => {
        if (window.videoController) {
          window.videoController.pause();
          window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
            window.videoController.expand();
            setTimeout(() => {
              window.videoController.play();
            }, 400);
          });
        }
      },
      INVALID_COMMAND: () => {
        if (window.videoController) {
          window.videoController.pause();
          window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
            setTimeout(() => {
              window.videoController.play();
            }, 400);
          });
        }
      },
      VALID_COMMAND: () => {
        if (window.videoController) {
          window.videoController.pause();
          window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
            setTimeout(() => {
              window.videoController.play();
            }, 400);
          });
        }
      },
    };
    // Donot use window?.currentCommandsAudio as dependency here as this can overwrite the commands for the next screen ( exercise flow)
  }, []);

  function initAR() {
    if (!window.mayraCode) {
      setTimeout(initAR, 300);
      return;
    }

    window.mayraForwardCode = {
      midjourneyData: testIntroPayload,
    };

    // Clear any stale callback from previous screens
    window.mayraCode.setOnMicEnabled(null);

    // Register callback BEFORE calling handleMicClick — no timing gap
    window.mayraCode.setOnMicEnabled((enabledBefore) => {
      // enabledBefore is always true now (handleMicClick fires it unconditionally)
      // but we still use it correctly in the no-name branch below
      window.mayraCode.setOnMicEnabled(null);
      window.mayraCode.setIsVisible(true);

      if (window.preloadAllAudios) window.preloadAllAudios();
      if (window.videoUnlockPlay) window.videoUnlockPlay();

      const userName = localStorage.getItem("self_name") || "";

      setTimeout(() => {
        if (userName) {
          window.currentFlow = "flow_demo_video";
          VoiceService._currentFlow = "flow_demo_video";
          window.mayraCode.startFlow("flow_demo_video", "first_test_have_name", () => {
            setTimeout(() => {
              doReplyVideo();
            }, 300);
          });

          window.currentCommandsAudio = {
            SKIP_VIDEO: () => {
              if (window.videoController) window.videoController.pause();
              doPauseVideo();
              window.mayraCode.doSay("Got it! Skipping the video.", () => {
                setTimeout(() => {
                  handleContinue();
                }, 500);
              });
            },
            MOVE_ON: () => {
              if (window.videoController) window.videoController.pause();
              doPauseVideo();
              window.mayraCode.doSay("Got it! Skipping the video.", () => {
                setTimeout(() => {
                  handleContinue();
                }, 500);
              });
            },
            REPLAY_VIDEO: () => {
              if (window.videoController) window.videoController.pause();
              doPauseVideo();
              window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                doReplyVideo();
                if (window.videoController) window.videoController.replay();
              });
            },
            PAUSE_VIDEO: () => {
              if (window._lastPauseTime && Date.now() - window._lastPauseTime < 2000) return;
              if (window.videoController) {
                if (window.videoController.isPaused()) {
                  window.mayraCode.doSay("The video is already paused.");
                } else {
                  window.videoController.pause();
                  window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                    window._lastPauseTime = Date.now();
                    doPauseVideo();
                  });
                }
              }
            },
            RESUME_VIDEO: () => {
              if (window.videoController && window.videoController.isPaused()) {
                window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },
            EXPAND_VIDEO: () => {
              if (window.videoController) {
                window.videoController.pause();
                window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                  window.videoController.expand();
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },
            INVALID_COMMAND: () => {
              if (window.videoController) {
                window.videoController.pause();
                window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },
            VALID_COMMAND: () => {
              if (window.videoController) {
                window.videoController.pause();
                window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },
          };
        } else {
          // No name — ask for it first
          // enabledBefore is always true from current handleMicClick,
          // but the distinction still matters for the speech announcement
          if (enabledBefore) {
            window.currentFlow = "flow_get_name";
            VoiceService._currentFlow = "flow_get_name";
            window.mayraCode.startFlow("flow_get_name", "first_test_no_name");
          } else {
            window.currentFlow = "flow_get_name";
            VoiceService._currentFlow = "flow_get_name";
            window.mayraCode.startFlow("flow_get_name", "first_test");
          }

          window.currentCommandsAudio = {
            GIVE_NAME: (nameGiven) => {
              console.log("Got name", nameGiven);
              localStorage.setItem("self_name", nameGiven);
              window.currentFlow = "flow_demo_video";
              VoiceService._currentFlow = "flow_demo_video";
              window.mayraCode.startFlow("flow_demo_video", "first_video_play_name", () => {
                doReplyVideo();
              });

              window.currentCommandsAudio = {
                SKIP_VIDEO: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Got it! Skipping the video.", () => {
                    setTimeout(() => {
                      handleContinue();
                    }, 500);
                  });
                },
                MOVE_ON: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Got it! Skipping the video.", () => {
                    setTimeout(() => {
                      handleContinue();
                    }, 500);
                  });
                },
                REPLAY_VIDEO: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                    setTimeout(() => {
                      doReplyVideo();
                    }, 400);
                  });
                },
                PAUSE_VIDEO: () => {
                  if (window.videoController) {
                    if (window.videoController.isPaused()) {
                      window.mayraCode.doSay("The video is already paused.");
                    } else {
                      window.videoController.pause();
                      window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                        doPauseVideo();
                      });
                    }
                  }
                },
                RESUME_VIDEO: () => {
                  if (window.videoController && window.videoController.isPaused()) {
                    window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                EXPAND_VIDEO: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                      window.videoController.expand();
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                INVALID_COMMAND: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                VALID_COMMAND: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
              };
            },
            // add demo video commands
            SKIP_VIDEO: () => {
              doPauseVideo();
              window.mayraCode.doSay("Got it! Skipping the video.", () => {
                setTimeout(() => {
                  handleContinue();
                }, 500);
              });
            },
            MOVE_ON: () => {
              doPauseVideo();
              window.mayraCode.doSay("Got it! Skipping the video.", () => {
                setTimeout(() => {
                  handleContinue();
                }, 500);
              });
            },
            REPLAY_VIDEO: () => {
              doPauseVideo();
              window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                setTimeout(() => {
                  doReplyVideo();
                }, 400);
              });
            },
            PAUSE_VIDEO: () => {
              if (window.videoController) {
                if (window.videoController.isPaused()) {
                  window.mayraCode.doSay("The video is already paused.");
                } else {
                  window.videoController.pause();
                  window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                    doPauseVideo();
                  });
                }
              }
            },
            RESUME_VIDEO: () => {
              if (window.videoController && window.videoController.isPaused()) {
                window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },
            EXPAND_VIDEO: () => {
              if (window.videoController) {
                window.videoController.pause();
                window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                  window.videoController.expand();
                  setTimeout(() => {
                    window.videoController.play();
                  }, 400);
                });
              }
            },

            SKIP_NAME: () => {
              console.log("No name given");
              window.currentFlow = "flow_demo_video";
              VoiceService._currentFlow = "flow_demo_video";
              window.mayraCode.startFlow("flow_demo_video", "first_video_play_skip_name", () => {
                doReplyVideo();
              });

              window.currentCommandsAudio = {
                SKIP_VIDEO: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Got it! Skipping the video.", () => {
                    setTimeout(() => {
                      handleContinue();
                    }, 500);
                  });
                },
                MOVE_ON: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Got it! Skipping the video.", () => {
                    setTimeout(() => {
                      handleContinue();
                    }, 500);
                  });
                },
                REPLAY_VIDEO: () => {
                  doPauseVideo();
                  window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
                    setTimeout(() => {
                      doReplyVideo();
                    }, 400);
                  });
                },
                PAUSE_VIDEO: () => {
                  if (window.videoController) {
                    if (window.videoController.isPaused()) {
                      window.mayraCode.doSay("The video is already paused.");
                    } else {
                      window.videoController.pause();
                      window.mayraCode.doSay("Sure! I'll pause the video for you. When you're ready to continue, just say Myra, resume the video.", () => {
                        doPauseVideo();
                      });
                    }
                  }
                },
                RESUME_VIDEO: () => {
                  if (window.videoController && window.videoController.isPaused()) {
                    window.mayraCode.doSay("Sure! I'll re-zume the video for you.", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                EXPAND_VIDEO: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
                      window.videoController.expand();
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                INVALID_COMMAND: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("I didn't catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
                VALID_COMMAND: () => {
                  if (window.videoController) {
                    window.videoController.pause();
                    window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
                      setTimeout(() => {
                        window.videoController.play();
                      }, 400);
                    });
                  }
                },
              };
            },
          };
        }
      }, 2000);
    });

    // silent=true → don't show overlay or auto-start a flow
    // forceStarting=true → skip the internal startFlow(currentFlow) call
    // Together: handleMicClick only initializes voice + fires onMicEnabledRef
    // window.mayraCode.handleMicClick(true, true, false, true);
  }
  window.initAR = initAR;

  useEffect(() => {
    setIsVoiceReady(voiceState.isReady);
    setIsVoiceAssistantReady(voiceState.isConnected && voiceState.isListening);
  }, [voiceState.isReady, voiceState.isConnected, voiceState.isListening]);

  useEffect(() => {
    MyraInteraction.onScreenEnter("intro_ar");
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testIntroPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  // console.log("Test is  : ", test);
  // console.log("testPool is  : ", testPool);
  const videoRef = useRef(null);
  const history = useHistory();
  window.doNextLocation = history;
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected");
      const isAgentSpeaking = window.mayraCode?.getState?.()?.isAgentSpeaking;
      if (isAgentSpeaking) {
        VoiceService.stopAgentSpeech();
      } else {
        console.log("[VIDEO] Agent not speaking, no action needed");
      }
    };

    videoElement.addEventListener("play", handleVideoPlay);
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, [videoUrl]);
  useEffect(() => {
    window.screenTracker.enterScreen("test1_demo");
    window.videoController = {
      pause: () => {
        if (videoRef.current) {
          videoRef.current.pause();
          console.log("Video paused via global controller");
        }
      },
      play: () => {
        if (videoRef.current) {
          videoRef.current.play().catch((err) => console.log("Video play failed:", err));
        }
      },
      expand: () => {
        if (videoRef.current) {
          document.body.classList.add("videoplay-expanded");
          if (document.getElementById("rom-test-video")) {
            document.getElementById("rom-test-video").onclick = function () {
              document.body.classList.remove("videoplay-expanded");
            };
          }
        }
      },
      replay: () => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch((err) => console.log("Video replay failed:", err));
        }
      },
      isPaused: () => videoRef.current?.paused ?? true,
    };

    /*
    return () => {
      console.log("Cleaning up TestIntroScreen...");

      // Stop all audio before cleanup
      if (window.stopAudio) {
        try {
          window.stopAudio();
          console.log("Stopped all audio in cleanup");
        } catch (e) {
          console.warn("Failed to stop audio:", e);
        }
      }

      // Pause and release the main video
      if (videoRef.current) {
        try {
          videoRef.current.pause();
          videoRef.current.src = "";
          videoRef.current.load();
        } catch (e) {
          console.warn("Failed to stop main video:", e);
        }
      }

      // Remove the secondary intro video if it was created dynamically
      const secondVideo = document.getElementById("secondTestVideo");
      if (secondVideo) {
        try {
          secondVideo.pause();
          secondVideo.src = "";
          secondVideo.load();
          secondVideo.remove();
          console.log("Removed secondary video element");
        } catch (e) {
          console.warn("Failed to remove secondary video:", e);
        }
      }

      // Clear global handlers to avoid leaks
      window.videoController = null;
      window.unlockAllVideos = null;
      window.currentCommandsAudio = {};

      // Optional: pause Myra (voice) system if active
      if (window.mayraCode && typeof window.mayraCode.disableCallback === "function") {
        try {
          window.mayraCode.disableCallback();
        } catch (e) {
          console.warn("Failed to disable Mayra callback:", e);
        }
      }

      // Remove any 'videoplay-expanded' class just in case
      document.body.classList.remove("videoplay-expanded");
    };
	
	*/
    const timer = setTimeout(() => {
      setIsContinueEnabled(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (test) {
      let secondtest = seconndTest?.name || "Seated Trunk Rotation";

      if (test.name === "Standing Lumbar Extension") {
        secondtest = "Toe Touch";
      } else if (test.name === "Side to Side Bend") {
        secondtest = "Seated Trunk Rotation";
      } else if (test.name === "Seated Single Knee to Chest") {
        secondtest = "Standing Lumbar Extension";
      }

      console.log("Second Test:", secondtest);

      // Create the video element
      const video = document.createElement("video");
      const videoUrl = testSpecificIntroVideos[secondtest];

      video.id = "secondTestVideo";
      video.src = videoUrl;
      video.muted = false;
      video.autoplay = false;
      video.setAttribute("playsinline", "true");
      video.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
      video.controls = true;

      video.style.position = "absolute";
      video.style.left = "0px";
      video.style.bottom = "0px";
      video.style.width = "1px";
      video.style.height = "1px";

      // Append to the body
      document.body.appendChild(video);

      if (secondtest === "Toe Touch") {
        const video2 = document.createElement("video");
        const videoUrl2 = testSpecificIntroVideos["Seated Trunk Rotation"];

        video2.id = "secondTestVideo2";
        video2.src = videoUrl2;
        video2.muted = false;
        video2.autoplay = false;
        video2.setAttribute("playsinline", "true");
        video2.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
        video2.controls = true;

        video2.style.position = "absolute";
        video2.style.left = "0px";
        video2.style.bottom = "0px";
        video2.style.width = "1px";
        video2.style.height = "1px";

        // Append to the body
        document.body.appendChild(video2);

        window.hasSecondVideoRotation = true;
      }

      if (secondtest === "Toe Touch") {
        const video2 = document.createElement("video");
        const videoUrl2 = testSpecificIntroVideos["Seated Trunk Rotation"];

        video2.id = "secondTestVideo2";
        video2.src = videoUrl2;
        video2.muted = false;
        video2.autoplay = false;
        video2.setAttribute("playsinline", "true");
        video2.setAttribute("webkit-playsinline", "true"); // iOS Safari prefix
        video2.controls = true;

        video2.style.position = "absolute";
        video2.style.left = "0px";
        video2.style.bottom = "0px";
        video2.style.width = "1px";
        video2.style.height = "1px";

        // Append to the body
        document.body.appendChild(video2);

        window.hasSecondVideoRotation = true;
      }

      window.unlockAllVideos = () => {
        if (document.getElementById("secondTestVideo")) {
          document
            .getElementById("secondTestVideo")
            .play()
            .then(() => {
              document.getElementById("secondTestVideo").pause();
            })
            .catch((err) => {
              console.log("Unlock failed 1:", err);
            });
        }

        if (document.getElementById("secondTestVideo2")) {
          document
            .getElementById("secondTestVideo2")
            .play()
            .then(() => {
              document.getElementById("secondTestVideo2").pause();
            })
            .catch((err) => {
              console.log("Unlock failed 2:", err);
            });
        }
      };
    }
  }, [test]);

  useEffect(() => {
    const userName = localStorage.getItem("self_name") || "";
    if (userName) {
      window.currentFlow = "flow_demo_video";
      VoiceService._currentFlow = "flow_demo_video";
    } else {
      window.currentFlow = "flow_get_name";
      VoiceService._currentFlow = "flow_get_name";
    }
    setProgress(65);
    window.mayraCode.setIsVisible(true);
    if (introARState.showModeCard === false) {
      if (MyraInteraction.getMode() === "voice") {
        initAR();
        window.mayraCode.handleMicClick(true, true, false, true);
        MyraInteraction.pickVoice();
        MyraInteraction.openVoice();
      } else if (MyraInteraction.getMode() === "chat") {
        initAR();
        MyraInteraction.pickChat();
        MyraInteraction.openChat();
        VoiceService.startFlowWithoutAnnouncement(window.currentFlow || VoiceService._currentFlow);
        let msg = "I'll guide you through the movement test. Just follow the video and type here if you have any questions.";
        MyraInteraction.onMyraMessage(msg);
        setTimeout(() => {
          if (videoRef.current) {
            videoRef.current?.play();
          }
          if (window.videoController) {
            window.videoController.play();
          }
        }, 500);
      } else {
        MyraInteraction.switchMode("button");
        initAR();
        window.mayraCode.handleMicClick(true, true, false, true, true);
        VoiceService.startFlowWithoutAnnouncement(window.currentFlow || VoiceService._currentFlow);
        let msg = "No message. Myra begins speaking via TTS when the test starts.";
        VoiceService.announceBubbleMessage(msg);
      }
    } else {
      initAR();

      const userName = localStorage.getItem("self_name") || "";
      if (userName) {
        window.currentFlow = "flow_demo_video";
        VoiceService._currentFlow = "flow_demo_video";
      } else {
        window.currentFlow = "flow_get_name";
        VoiceService._currentFlow = "flow_get_name";
      }
    }
  }, []);
  // window.mayraCode && window.mayraCode.doSay
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoEnd = () => {
      try {
        const videoWatchedFully = true;
        const videoDurationWatched = Math.round(videoElement.duration);
        assessmentData.test1VideoWatched = videoWatchedFully;
        assessmentData.test1VideoDuration = videoDurationWatched;
        assessmentData.watched_demo_1 = true;
        if (isVoiceAssistantReady) {
          window.mayraCode.doSay("Now, that you’ve seen how it works, let’s move to the next step.", () => {
            handleContinue();
          });
          console.log("Sent speech command to backend");
        } else {
          console.warn("WebSocket not connected - cannot send speech command");
        }
      } catch (error) {
        console.error("Error sending speech command:", error);
      }
    };
    // Add event listener for video end
    videoElement.addEventListener("ended", handleVideoEnd);

    // Cleanup function to remove event listener
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
      }
    };
  }, [isVoiceAssistantReady]);
  useEffect(() => {
    const checkVoiceAssistant = () => {
      const isReady = !!(window.mayraCode && window.mayraCode.doSay && window.mayraCode.isEnabled);
      setIsVoiceAssistantReady(isReady);
    };

    // Check initially
    checkVoiceAssistant();

    // Seting up periodic checking
    const interval = setInterval(checkVoiceAssistant, 1000);
    return () => clearInterval(interval);
  }, []);
  // useEffect(() => {
  //   const initializeVoice = () => {
  //     if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
  //       if (VoiceService._ws?.readyState === WebSocket.OPEN) {
  //         VoiceService.sendMidJourneyData(testIntroPayload);
  //         setIsVoiceReady(true);
  //       }
  //     }
  //   };
  //   initializeVoice();
  //   const checkConnectionInterval = setInterval(() => {
  //     if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
  //       initializeVoice();
  //     }
  //   }, 1000);
  //   const originalOnConnected = VoiceService._callbacks?.onConnected;
  //   VoiceService._callbacks.onConnected = () => {
  //     initializeVoice();
  //     if (originalOnConnected) originalOnConnected();
  //   };
  //   return () => {
  //     clearInterval(checkConnectionInterval);
  //     if (originalOnConnected) {
  //       VoiceService._callbacks.onConnected = originalOnConnected;
  //     }
  //   };
  // }, [testIntroPayload, isVoiceReady]);

  // this useeffect will check if the video is manually played then stop agent speech
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Simple event listener for video play
    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected - stopping agent speech");

      // Stop agent speech immediately
      VoiceService.stopAgentSpeech();
    };

    // Add event listener
    videoElement.addEventListener("play", handleVideoPlay);

    // Cleanup
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, []);

  const doReplyVideo = () => {
    if (window.clickedOnceOpen) {
      return false;
    }
    const video = videoRef.current;
    if (!video) {
      console.error("Video element not found");
      return;
    }
    videoRef.current.currentTime = 0;
    videoRef.current.play().catch((err) => console.log("Replay autoplay prevented:", err));
  };

  const doPauseVideo = () => {
    videoRef.current.pause();
  };

  if (floorCapability === "seated_standing") {
    if (test?.name === "Supine Double Knee to Chest") {
      test = { ...testMap.SUBSTITUTE_TEST_1 };
      console.log("Test is  : ", test);
    }
    if (test?.name === "Prone Press Up") {
      test = { ...negativeTestMap.SUBSTITUTE_TEST_2 };
    }
  }
  if (test?.name === "Supine Double Knee to Chest") {
    test = { ...testMap.SUBSTITUTE_TEST_1 };
  }
  const handleModeSelect = (mode) => {
    setSelectedMode(mode);
    // Update the global reference in MyraAgent
    if (window.mayraCode && window.mayraCode.onIntroARModeSelect) {
      window.mayraCode.onIntroARModeSelect(mode);
    }

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();
    window.initFromUserGesture();
    if (window.audioPlayer?.ctx?.state === "suspended") {
      window.audioPlayer.ctx.resume();
    }
    if (window.preloadAllAudios) window.preloadAllAudios();
  };

  const handleContinue = () => {
    doPauseVideo();
    VoiceService._resetAllState();

    if (window.doKeepVideoPlay) window.doKeepVideoPlay();

    const demoVideo1 = document.getElementById("rom-test-video");
    if (demoVideo1) {
      try {
        // Calculate video watching metrics before removing
        let videoWatchedFully = false;
        let videoDurationWatched = 0;

        if (demoVideo1) {
          videoDurationWatched = Math.round(demoVideo1.currentTime);

          // Check if video was watched to at least 90% completion
          if (demoVideo1.duration > 0) {
            const completionPercentage = (demoVideo1.currentTime / demoVideo1.duration) * 100;
            videoWatchedFully = completionPercentage >= 90;
          }
        }
        demoVideo1.muted = true;

        demoVideo1.pause();
        demoVideo1.removeAttribute("src");
        demoVideo1.load();
        demoVideo1.remove();

        // Store video watching metrics
        assessmentData.watched_demo_1 = true;
        assessmentData.test1VideoWatched = videoWatchedFully;
        assessmentData.test1VideoDuration = videoDurationWatched;
      } catch (err) {
        console.warn("Failed removing demoVideo1:", err);
      }
    }
    window.cameraPayload = cameraPayload;
    window.movementTestPayload = movementTestPayload;

    const testonevideoContainer = document.getElementById("testonevideo");
    if (testonevideoContainer) testonevideoContainer.innerHTML = "";

    // Stop all audio including Myra TTS before starting movement test
    if (window.stopAudio) {
      window.stopAudio();
    }

    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }
    window.screenTracker.exitScreen("test1_demo", {
      exitReason: "started_test",
      completed: true,
      videoWatched: true,
      videoSkipped: false,
    });
    MyraInteraction.onScreenEnter("camera_permission");
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      testName: test.name,
      // Video watching metrics
      test1VideoWatched: assessmentData.test1VideoWatched || false,
      test1VideoDuration: assessmentData.test1VideoDuration || 0,
      rom_test1_name: test.name,
      screenFlow: screenFlow,
      watched_demo_1: assessmentData.watched_demo_1 || false,
      rom_test1_started: true,
      session_last_update: new Date().toISOString(),
    };
    // setting wakeup lock on initialization to prevent the device from sleeping in the middle of the session
    // setTimeout(async () => {
    //   if (window.wakeLockManager) {
    //     await window.wakeLockManager.acquire();
    //   }
    // }, 100);

    window.assessmentChangeExercise = false;
    if (test.name === "Standing Lumbar Extension" && probableSubtype === "ROTATIONAL_INTOLERANT") {
      updatedData.probableSubtype = "ROTATIONAL_INTOLERANT";
      updatedData.finalPainSubtype = "ROTATIONAL_INTOLERANT";
      window.assessmentChangeExercise = true;
    }

    if (window.clickedOnceOpen) {
      return false;
    }

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    localStorage.setItem("runStep", "1");
    localStorage.setItem("loadSelf", test.name);
    if (window.loadROMExercises) {
      window.loadROMExercises(true);
    }

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").pause();
      document.querySelector("#assesmentDiv video").removeAttribute("autoplay");
    }

    window.clickedOnceOpen = true;
    window.doNextLocation = history;

    if (document.querySelector(".rom-test-start-button")) {
      document.querySelector(".rom-test-start-button").innerHTML = "Loading Movement Test…";
    }

    console.log("Tried open");
    VoiceService.sendMidJourneyData(cameraPayload);

    if (window.doCameraScreenStart) {
      window.doCameraScreenStart();
      console.log("Tried open - ready");
    } else {
      let openIntervalCheck = setInterval(() => {
        if (window.doCameraScreenStart) {
          window.doCameraScreenStart();
          console.log("Tried open - ready");
          clearInterval(openIntervalCheck);
        } else {
          console.log("Tried open - not ready");
        }
      }, 1000);
    }
  };
  const key = test?.name?.trim();
  const videoUrlSafe = testSpecificIntroVideos[key] || DEFAULT_INTRO_VIDEO;

  useEffect(() => {
    if (!test) return;
    setVideoUrl(videoUrlSafe);
  }, [test]);

  // if (!test) {
  //   return (
  //     <div className="text-center p-6">
  //       <p className="text-gray-500">Loading test instructions...</p>
  //     </div>
  //   );
  // }
  // const videoUrl = testSpecificIntroVideos[key] ? testSpecificIntroVideos[key] : DEFAULT_INTRO_VIDEO;
  // console.log("Selected key:", `"${key}"`);
  // console.log("Video URL:", videoUrl);

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="test1_demo" videoRef={videoRef} />
        <div>
          <div id="screen-rom-intro" className={styles.ScreenContainer}>
            <Heading heading="Movement Test Demo Video" />
            <SubHeading subheading="Watch this demo to learn how to perform the test." />
            <div className={styles.VideoContainer} id="testonevideo">
              {videoUrl && (
                <video
                  id="rom-test-video"
                  preload="auto"
                  className={styles.Video}
                  controls
                  playsInline
                  ref={videoRef}
                  onError={(e) => {
                    console.error("Video failed:", videoUrl, e);
                  }}
                  onLoadedData={() => console.log("Video loaded:", videoUrl)}
                  onCanPlay={() => console.log("Video can play:", videoUrl)}
                >
                  <source src={videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              )}
            </div>
            <IntroARModeCard introARState={introARState} selectedMode={selectedMode} onSelectMode={handleModeSelect} />
            {introARState.showModeCard === false && test.name && (
              <div id="rom-test-instruction" className={styles.InstructionBox}>
                <h4 className={styles.InstructionTitle}>{test.name}</h4>
                <p className={styles.InstructionText}>
                  You will be performing 10 reps.
                  <br />{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Important{" "}
                  </span>{" "}
                  : Stop & Press <strong>Skip Exercise</strong> if you feel a significant increase in pain.
                </p>
              </div>
            )}

            {<CommonButton className="rom-test-start-button" title="Continue" onClick={handleContinue} disabled={!isContinueEnabled || introARState.showModeCard} />}
          </div>
        </div>
      </div>
    </div>
  );
};
// helper getRpeClass function
const getRpeClass = (i) => {
  if (i <= 3) return "RpeBlue";
  if (i <= 7) return "RpeIndigo";
  return "RpePurple";
};
const calculateStdDev = (values) => {
  if (!values.length) return 0;
  const mean = values.reduce((sum, v) => sum + v, 0) / values.length;
  const variance = values.reduce((sum, v) => sum + Math.pow(v - mean, 2), 0) / values.length;
  return Math.sqrt(variance).toFixed(2);
};

function getRpeResponseText(normalized) {
  let agentReply = "";
  if (normalized >= 0 && normalized <= 2) {
    agentReply = "Easy—great to hear! Let’s move on to the next step.";
  } else if (normalized >= 3 && normalized <= 4) {
    agentReply = "Kinda Easy—great to hear! Let’s move on to the next step.";
  } else if (normalized >= 5 && normalized <= 6) {
    agentReply = "Just right—great! Let’s move on to the next step.";
  } else if (normalized >= 7 && normalized <= 8) {
    agentReply = "Kinda Hard—thanks for letting me know. Let’s move on to the next step.";
  } else if (normalized >= 9 && normalized <= 10) {
    agentReply = "Hard—thanks for letting me know. Let’s move on to the next step.";
  }
  return agentReply;
}
function parseDataAfterInfo() {
  let dataString = localStorage.getItem("dataAfterInfo");
  let parsedData = [];

  try {
    parsedData = JSON.parse(dataString);
    if (typeof parsedData === "string") {
      parsedData = JSON.parse(parsedData);
    }
    if (!Array.isArray(parsedData)) {
      throw new Error("Data is not an array");
    }
    const rom = parsedData.map((item) => item[0] || item[4]);
    const dur = parsedData.map((item) => Math.round(item[3] / 1000));
    return { rom, dur };
  } catch (e) {
    console.error("Failed to parse dataAfterInfo:", e);
    return { rom: [], dur: [] };
  }
}
// AI Processing Loader Component
const AIProcessingLoader = ({ message, isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.aiLoaderOverlay}>
      <div className={styles.aiLoaderContainer}>
        <p className={styles.aiLoaderText}>{message}</p>
        <div className={styles.aiLoaderSpinner}>
          <div className={styles.aiLoaderBounce1}></div>
          <div className={styles.aiLoaderBounce2}></div>
          <div className={styles.aiLoaderBounce3}></div>
        </div>
      </div>
    </div>
  );
};

const SELF_REPORT_PACE_OPTIONS = [
  {
    id: "rom_smaller",
    title: "Got smaller",
    subtitle: "My movements became smaller as I kept going.",
  },
  {
    id: "rom_bigger",
    title: "Got bigger",
    subtitle: "My movements became bigger as I kept going.",
  },
  {
    id: "rom_same",
    title: "Stayed the same",
    subtitle: "My last few reps and the first few were the same.",
  },
];

const SELF_REPORT_COMPARISON_OPTIONS = [
  {
    id: "tempo_kept_up",
    title: "Kept up",
    subtitle: "I matched Myra's speed or moved slightly faster.",
  },
  {
    id: "tempo_slower",
    title: "Slowed down",
    subtitle: "I finished all the reps but moved slower.",
  },
  {
    id: "tempo_not_finished",
    title: "Couldn't finish",
    subtitle: "I couldn't finish all the reps and had to stop.",
  },
];

const SELF_REPORT_STEP1_FLOW = "flow_selfreport_compare";
const SELF_REPORT_STEP2_FLOW = "flow_selfreport_speed";

const SELF_REPORT_COMPARE_VALUE_TO_ID = {
  ROM_SMALLER: "rom_smaller",
  ROM_BIGGER: "rom_bigger",
  ROM_SAME: "rom_same",
};

const SELF_REPORT_SPEED_VALUE_TO_ID = {
  TEMPO_KEPT_UP: "tempo_kept_up",
  TEMPO_SLOWER: "tempo_slower",
  TEMPO_NOT_FINISHED: "tempo_not_finished",
};

const getSelfReportReplyText = (id) => {
  const replyMap = {
    rom_smaller: "Got smaller, thanks for sharing. Let's move on to the next step.",
    rom_bigger: "Got bigger, thanks for sharing. Let's move on to the next step.",
    rom_same: "Stayed the same, thanks for sharing. Let's move on to the next step.",
    tempo_kept_up: "Kept up, thanks for sharing. Let's move on to the next step.",
    tempo_slower: "Slowed down, thanks for sharing. Let's move on to the next step.",
    tempo_not_finished: "Couldn't finish, thanks for sharing. Let's move on to the next step.",
  };
  return replyMap[id] || "Thanks for sharing. Let's move on to the next step.";
};

// Self-report questions (shown only for no-camera flow)
export const SelfReportQuestionsScreen = () => {
  console.log("SelfReportQuestionsScreen");
  usePreventNavigation("/");
  console.log("SelfReportQuestionsScreen 2");
  useScrollToTop();
  const { setProgress } = useProgress();
  const history = useHistory();
  const { assessmentData, updateAssessmentData } = useAssessment();
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  const [activeStep, setActiveStep] = useState(1);
  const [selectedSelfReportPace, setSelectedSelfReportPace] = useState(null);
  const [selectedSelfReportComparison, setSelectedSelfReportComparison] = useState(null);
  const selfReportAudioStepRef = useRef(0);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const selfReportPayload = generatePayloadForScreen(activeStep === 1 ? "self_report_compare" : "self_report_speed", assessmentData);

  useEffect(() => {
    const screenId = activeStep === 1 ? "self_report_compare" : "self_report_speed";
    if (activeStep === 1) {
      window.screenTracker.exitScreen("self_report_compare", {
        completed: true,
        exitReason: "advanced_to_speed_step",
      });
    }
    window.screenTracker.enterScreen(screenId);
    MyraInteraction.onScreenEnter(screenId);
  }, [activeStep]);

  useEffect(() => {
    // Keep progress + Myra prompt tied to the active step.
    setProgress(activeStep === 1 ? 72 : 75);
    selfReportAudioStepRef.current = activeStep;

    const stepPrompt = activeStep === 1 ? "Myra here! Let's check how consistent your movements were. Think about the reps you did. Would you say your movements got smaller, got bigger, or stayed the same?" : "Now, let's move on to your speed. Compared to my count, would you say you kept up, slowed down, or couldn't finish?";

    if (window.stopAudio) {
      window.stopAudio();
    }

    if (!window?.mayraCode || typeof window.mayraCode.doSay !== "function") return;

    // Slight delay after stopAudio so quick step changes always speak the latest step.
    const speakTimer = setTimeout(() => {
      if (selfReportAudioStepRef.current !== activeStep) return;
      window.mayraCode.doSay(stepPrompt, () => {});
    }, 80);

    return () => clearTimeout(speakTimer);
  }, [activeStep, setProgress]);

  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(selfReportPayload);
      }

      if (prevIsListening && !currentIsListening) {
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, [selfReportPayload, activeStep]);

  useEffect(() => {
    window.initFromUserGesture?.();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(selfReportPayload);
          setIsVoiceReady(true);
        }
      }
    };

    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);

    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };

    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [isVoiceReady, selfReportPayload, activeStep]);

  useEffect(() => {
    const stepFlow = activeStep === 1 ? SELF_REPORT_STEP1_FLOW : SELF_REPORT_STEP2_FLOW;
    window.currentFlow = stepFlow;
    VoiceService._currentFlow = stepFlow;

    window.currentCommandsAudio =
      activeStep === 1
        ? {
            SELECT_COMPARE: async (val) => {
              const normalized = (val || "").toString().trim().toUpperCase();
              const selectedId = SELF_REPORT_COMPARE_VALUE_TO_ID[normalized];
              if (!selectedId) return;

              setSelectedSelfReportPace(selectedId);
              if (window?.mayraCode && typeof window.mayraCode.doSay === "function") {
                window.mayraCode.doSay(getSelfReportReplyText(selectedId), () => setActiveStep(2));
              } else {
                setActiveStep(2);
              }
            },
          }
        : {
            SELECT_SPEED: async (val) => {
              const normalized = (val || "").toString().trim().toUpperCase();
              const selectedId = SELF_REPORT_SPEED_VALUE_TO_ID[normalized];
              if (!selectedId) return;

              setSelectedSelfReportComparison(selectedId);
              if (window?.mayraCode && typeof window.mayraCode.doSay === "function") {
                window.mayraCode.doSay(getSelfReportReplyText(selectedId), () => handleNextPage(selectedId));
              } else {
                handleNextPage(selectedId);
              }
            },
          };

    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraForwardCode = {
        midjourneyData: selfReportPayload,
      };
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraCode.startFlow(stepFlow, activeStep === 1 ? "self_report_compare" : "flow_selfreport_speed");
      }, 300);
    }
  }, [activeStep]);

  const handleNextPage = (speedOverride = null) => {
    if (activeStep === 1) {
      if (selectedSelfReportPace === null) return;
      setActiveStep(2);
      return;
    }

    const finalComparison = speedOverride ?? selectedSelfReportComparison;
    if (finalComparison === null) return;

    console.log("Selected: ", finalComparison);
    if (finalComparison === "tempo_not_finished" && window.globalCrossClicked) {
      console.log("Not finished");

      window.globalCrossClicked();
      return;
    }

    const screenFlow = window.screenTracker.getScreenFlow();
    window.screenTracker.exitScreen("self_report_speed", {
      exitReason: "self_report_submitted",
      completed: true,
    });

    const updatedData = {
      ...assessmentData,
      selfReportResponsePace: selectedSelfReportPace || "",
      selfReportResponseComparison: finalComparison || "",
      selfReportResponses: {
        pace: SELF_REPORT_PACE_OPTIONS.find((opt) => opt.id === selectedSelfReportPace) || null,
        comparison: SELF_REPORT_COMPARISON_OPTIONS.find((opt) => opt.id === finalComparison) || null,
      },
      submitted_self_report_1: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    history.replace("/how-challenging");
  };

  const activeOptions = activeStep === 1 ? SELF_REPORT_PACE_OPTIONS : SELF_REPORT_COMPARISON_OPTIONS;
  const selectedSelfReportValue = activeStep === 1 ? selectedSelfReportPace : selectedSelfReportComparison;
  const setSelectedSelfReportValue = activeStep === 1 ? setSelectedSelfReportPace : setSelectedSelfReportComparison;
  const activeHeading = activeStep === 1 ? "How Did Your Movements Compare?" : "How Was Your Speed?";
  const activeSubHeading = activeStep === 1 ? "Think about the first few reps you did and the last few reps. How did your movements change?" : "Compared to Myra's count, how would you describe your speed?";

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal}>
        <Header screenName="self_report_questions" />
        <div className={styles.ScreenContainer}>
          <h3 className={styles.howChaHeading}>{activeHeading}</h3>
          <p className={styles.selfReportSubheading}>{activeSubHeading}</p>

          <div id="self-report-widget" className={styles.selfReportOptions}>
            {activeOptions.map((option) => {
              const selected = selectedSelfReportValue === option.id;
              return (
                <div key={option.id}>
                  <button type="button" onClick={() => setSelectedSelfReportValue(option.id)} className={`${styles.selfReportCard} ${selected ? styles.selfReportCardSelected : ""}`}>
                    <h4 className={styles.selfReportCardTitle}>{option.title}</h4>
                    <p className={styles.selfReportCardSubtitle}>{option.subtitle}</p>
                  </button>
                </div>
              );
            })}
          </div>

          {/* <button onClick={handleNextPage} className={`${styles.ContinueButton} ${selectedSelfReportValue === null ? styles.ButtonDisabled : ""}`} disabled={selectedSelfReportValue === null}>
            Next
          </button> */}
          <CommonButton title="Next" onClick={() => handleNextPage()} disabled={selectedSelfReportValue === null} />
        </div>
      </div>
    </div>
  );
};

// How challenging screen
export const HowChallengingScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [romValues, setRomValues] = useState([]);
  const [durations, setDurations] = useState([]);
  const [romStdDev, setRomStdDev] = useState(0);
  const [repTimeStdDev, setRepTimeStdDev] = useState(0);
  const howChallengingPayload = generatePayloadForScreen("test1_rpe", assessmentData);
  window.movementTestPayload = null;
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const noCameraMode = localStorage.getItem("noCameraMode") === "true";

  console.log("rom values : ", romValues);
  console.log("dur values : ", durations);
  useEffect(() => {
    if (repTimeStdDev > 0 || romStdDev > 0) {
      const updatedData = {
        ...assessmentData,
        romStdDev: romStdDev,
        repTimeStdDev: repTimeStdDev,
      };
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    }
  }, [repTimeStdDev, romStdDev]);

  const [selectedRPE, setSelectedRPE] = useState(null);
  const history = useHistory();
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(howChallengingPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    if (selectedRPE !== null) {
      const updatedData = {
        ...assessmentData,
        rpe: selectedRPE,
      };
      updateAssessmentData(updatedData);
      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    }
  }, [selectedRPE]);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(howChallengingPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [howChallengingPayload, isVoiceReady]);

  useEffect(() => {
    window.screenTracker.enterScreen("test1_rpe");
    MyraInteraction.onScreenEnter("test1_rpe");
    const { rom, dur } = parseDataAfterInfo();
    if (rom.length && dur.length) {
      setRomValues(rom);
      setDurations(dur);

      const romStd = calculateStdDev(rom);
      const durStd = calculateStdDev(dur);

      setRomStdDev(romStd);
      setRepTimeStdDev(durStd);
    }

    if (noCameraMode) {
      setProgress(78);
    } else {
      setProgress(75);
    }

    // Stop all audio/video before navigating to symptoms screen
    if (window.stopAudio) {
      window.stopAudio();
    }

    // Stop all video elements
    const allVideos = document.querySelectorAll("video");
    allVideos.forEach((video) => {
      try {
        video.pause();
        video.currentTime = 0;
        console.log("Paused video element before symptoms screen:", video.id || video.src);
      } catch (err) {
        console.warn("Failed to pause video:", err);
      }
    });
  }, []);

  useEffect(() => {
    window.currentCommandsAudio = {
      SELECT_RPE: async (val) => {
        const numVal = parseInt(val);
        try {
          //  small delay to ensure loader is visible
          await new Promise((resolve) => setTimeout(resolve, 500));

          // Get AI response (this will trigger the backend AI processing)
          window.mayraCode.doSay(getRpeResponseText(numVal), () => {
            if (numVal >= 0 && numVal < 11) {
              setSelectedRPE(numVal);
              setTimeout(() => handleContinue(numVal), 500);
            }
          });
        } catch (error) {
          console.error("Error processing RPE response:", error);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          if (selectedRPE) {
            handleContinue();
          }
        }
      },
      MOVE_ON: (value, speech, intent) => {
        if (selectedRPE) {
          handleContinue();
        }
      },
    };

    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.currentFlow = "flow_rpe";
      VoiceService._currentFlow = "flow_rpe";
      window.mayraForwardCode = {
        midjourneyData: howChallengingPayload,
      };
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraCode.startFlow("flow_rpe", "rpe");
      }, 500);
    }
  }, []);

  const handleContinue = (passResp) => {
    if (!selectedRPE && !passResp) return;
    const selectedRPEM = selectedRPE ?? passResp;

    const { rom, dur } = parseDataAfterInfo();
    window.screenTracker.exitScreen("test1_rpe", {
      exitReason: "rpe_submitted",
      completed: true,
    });
    MyraInteraction.onScreenEnter("test1_symptoms");
    const screenFlow = window.screenTracker.getScreenFlow();

    const updatedData = {
      ...assessmentData,
      rpe: selectedRPEM,
      rom: rom.length ? rom : romValues, // fallback to state
      duration: dur.length ? dur : durations, // fallback to state
      submitted_rpe_1: true,
      screenFlow: screenFlow,
      rom_test1_completed: true,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));

    AnalyticsService.trackStep(updatedData);

    history.replace("/feel-affect");
  };

  return (
    <div className={styles.ScreenWrapperRpe}>
      <div className={styles.ScreenModalRpe} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="test1_rpe" />

        <div className={styles.ScreenContainer}>
          <h3 className={styles.howChaHeading}>How challenging did that movement feel?</h3>

          <div id="rpe-widget" className={styles.RPEGrid}>
            <button type="button" onClick={() => setSelectedRPE(1)} className={`${styles.RPECircle} ${selectedRPE === 1 ? styles.Selected : ""}`}>
              Easy
            </button>
            <button type="button" onClick={() => setSelectedRPE(3)} className={`${styles.RPECircle} ${selectedRPE === 3 ? styles.Selected : ""}`}>
              Kinda Easy
            </button>
            <button type="button" onClick={() => setSelectedRPE(5)} className={`${styles.RPECircle} ${selectedRPE === 5 ? styles.Selected : ""}`}>
              Just Right
            </button>
            <button type="button" onClick={() => setSelectedRPE(7)} className={`${styles.RPECircle} ${selectedRPE === 7 ? styles.Selected : ""}`}>
              Kinda Hard
            </button>
            <button type="button" onClick={() => setSelectedRPE(9)} className={`${styles.RPECircle} ${selectedRPE === 9 ? styles.Selected : ""}`}>
              Hard
            </button>
          </div>

          <div className={styles.RPELabels}>
            <span className={styles.NoEffort}>No Effort</span>
            <span className={styles.MaxEffort}>Max Effort</span>
          </div>

          {/* <button id="rpe-continue" onClick={handleContinue} className={`${styles.ContinueButton} ${selectedRPE === null ? styles.ButtonDisabled : ""}`} disabled={selectedRPE === null}>
            Continue
          </button> */}
          <CommonButton title="Continue" onClick={handleContinue} disabled={selectedRPE === null} />
        </div>
      </div>
    </div>
  );
};

// SYMPTOM_OPTIONS helper
const SYMPTOM_OPTIONS = [
  { id: "symptom-improved", value: "IMPROVED", label: "Felt Better" },
  {
    id: "symptom-tolerable",
    value: "TOLERABLE",
    label: "Felt Same",
  },
  { id: "symptom-worsened", value: "WORSENED", label: "Felt Worse" },
];

// feel affect screen

export const FeelAffectScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [symptomResponse, setSymptomResponse] = useState(null);
  console.log("Symptom Response is : ", symptomResponse);

  //  NEW STATE: AI Processing Loader
  const [isAIProcessing, setIsAIProcessing] = useState(false);
  const [aiProcessingMessage, setAiProcessingMessage] = useState("");
  const [symptom1Speech, setSymptom1Speech] = useState("");
  const aiProcessingTimeoutRef = useRef(null);
  const testSysmptom1Payload = generatePayloadForScreen("test1_symptoms", assessmentData);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();

  const history = useHistory();

  console.log("assesment data is : ", assessmentData);
  const startAIProcessing = (message) => {
    setIsAIProcessing(true);
    setAiProcessingMessage(message);

    if (aiProcessingTimeoutRef.current) {
      clearTimeout(aiProcessingTimeoutRef.current);
      aiProcessingTimeoutRef.current = null;
    }

    const checkTimeout = () => {
      const isAgentSpeaking = window.mayraCode?.getState?.()?.isAgentSpeaking;

      // Agent is speaking → check again later
      if (isAgentSpeaking) {
        aiProcessingTimeoutRef.current = setTimeout(checkTimeout, 10_000);
        return;
      }

      // Agent not speaking → unlock UI
      console.error("AI processing timed out — forcing UI recovery");
      setIsAIProcessing(false);
      aiProcessingTimeoutRef.current = null;
    };

    // First check after 60 seconds
    aiProcessingTimeoutRef.current = setTimeout(checkTimeout, 60_000);
  };

  const stopAIProcessing = () => {
    setIsAIProcessing(false);

    if (aiProcessingTimeoutRef.current) {
      clearTimeout(aiProcessingTimeoutRef.current);
      aiProcessingTimeoutRef.current = null;
    }
  };
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testSysmptom1Payload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    return () => {
      if (aiProcessingTimeoutRef.current) {
        clearTimeout(aiProcessingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    setProgress(80);
    MyraInteraction.onScreenEnter("test1_symptoms");
    window.screenTracker.enterScreen("test1_symptoms");
  }, []);

  useEffect(() => {
    window.currentCommandsAudio = {
      SELECT_SYMPTOM: async (val, customSpeech) => {
        //  SHOW AI PROCESSING LOADER
        // setIsAIProcessing(true);
        // setAiProcessingMessage("Thanks for your effort. I'm working with AI; insights shortly");
        startAIProcessing("Thanks for your effort. I'm working with AI; insights shortly");
        if (customSpeech) {
          setSymptom1Speech(customSpeech);
        }

        console.log("Symptom NLU speech:", customSpeech);
        console.log("Symptom NLU received:", val);
        if (!customSpeech) {
          stopAIProcessing();
          // return; // don't  return if we don't have speech announce the fallback speech and go to next screen
        }

        const fallbackSpeech = val === "WORSENED" ? "Great work so far! Just one more step to go!" : "Great work so far! Just a few more steps to go!";
        const speechToSay = customSpeech ? `${customSpeech} ${fallbackSpeech}` : fallbackSpeech;

        try {
          const match = SYMPTOM_OPTIONS.find((itm) => itm.value.toUpperCase() === String(val).toUpperCase());

          // Get AI response (this will trigger the backend AI processing)
          window.mayraCode.doSay(speechToSay, () => {
            stopAIProcessing();
            setTimeout(() => {
              if (match) {
                setSymptomResponse(match);
                // Call handleContinue WITH the match parameter
                // This tells handleContinue it's a backend response
                handleContinue(match);
              } else {
                console.warn("No match for symptom value:", val);
              }
            }, 500);
          });
        } catch (error) {
          //  HIDE LOADER on error too
          stopAIProcessing();
          console.error("Error processing symptom response:", error);
        }
      },
    };

    window.initFromUserGesture();
    console.log("🔍 [FRONTEND DEBUG] Data being sent:", {
      romStdDev: assessmentData.romStdDev,
      repTimeStdDev: assessmentData.repTimeStdDev,
      rpe: assessmentData.rpe,
      painLocations: assessmentData.selectedZones,
      symptomDuration: assessmentData.symptomDuration,
      preTestNPRS: assessmentData.painLevel,
    });
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraForwardCode = {
        romStdDev: assessmentData.romStdDev ?? null,
        repTimeStdDev: assessmentData.repTimeStdDev ?? null,
        rpe: assessmentData.rpe ?? null,
        painLocations: assessmentData.selectedZones || [],
        symptomDuration: assessmentData.symptomDuration || "",
        preTestNPRS: assessmentData.painLevel ?? null,
        midjourneyData: testSysmptom1Payload,
        symptomType: "initial",
      };
      window.mayraCode.setIsVisible(true);
      setTimeout(() => {
        window.mayraCode.startFlow("flow_symptom", "symptom1");
      }, 500);
    }
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(testSysmptom1Payload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [testSysmptom1Payload, isVoiceReady]);

  // Special case: override subtype if response worsened
  // if (symptomResponseM.value === "WORSENED") {
  //   updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
  //   updateAssessmentData(updatedData);
  //   localStorage.setItem("assessmentData", JSON.stringify(updatedData));
  //   AnalyticsService.trackStep(updatedData);
  //   history.replace("/plan-recommendation");
  //   return;
  // }

  const proceedWithNavigation = (symptomResponseM) => {
    window.screenTracker.exitScreen("symptom1", {
      exitReason: "symptom_response_submitted",
      completed: true,
    });
    MyraInteraction.onScreenEnter("test2_demo");
    const screenFlow = window.screenTracker.getScreenFlow();
    const { rom, dur } = parseDataAfterInfo();

    const updatedData = {
      ...assessmentData,
      symptomResponseRelief: symptomResponseM.value,
      ...(rom.length > 0 && { rom1: rom }),
      ...(dur.length > 0 && { duration1: dur }),
      symptomResponse: symptomResponseM,
      symptom1Speech: symptom1Speech,
      rom_test1_completed: true,
      submitted_symptoms_1: true,
      symptomResponse1: symptomResponseM.value,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    const problemArea = assessmentData.problemArea || "LBP";
    const subtype = assessmentData.probableSubtype;
    const SECOND_TEST_REQUIRED_SUBTYPES = ["FLEXION_INTOLERANT", "EXTENSION_INTOLERANT", "LIMITED_LUMBAR_MOBILITY", "ROTATIONAL_INTOLERANT", "SUBSTITUTE_TEST_2"];
    let needsSecondTest = subtype === "NEUTRAL_SENSITIVE" ? false : true;
    // ============================================================
    // LBP OVERRIDE LOGIC (existing - no changes)
    // ============================================================
    // LBP OVERRIDE LOGIC
    if (problemArea === "LBP") {
      // DP OVERWRITE: Rotational Intolerant + Felt Better = Flexion Intolerant
      // Clinical rationale: Positive response to extension reveals directional preference
      if (subtype === "ROTATIONAL_INTOLERANT" && symptomResponseM.value === "IMPROVED") {
        updatedData.finalPainSubtype = "FLEXION_INTOLERANT";
        updatedData.probableSubtype = "FLEXION_INTOLERANT";
        updatedData.wasDPOverwrite = true;
        updatedData.overrideReason = "Directional Preference Overwrite — positive extension response";
        updatedData.diagnosisChanged = true;
        needsSecondTest = false;
      }
      // Standard override: any subtype + Felt Worse = Neutral Sensitive
      if (symptomResponseM.value === "WORSENED") {
        updatedData.finalPainSubtype = "NEUTRAL_SENSITIVE";
        updatedData.probableSubtype = "NEUTRAL_SENSITIVE";
        updatedData.wasOverridden = true;
        updatedData.overrideReason = "First Test Felt Worse";
        updatedData.diagnosisChanged = true;
        needsSecondTest = false;
      }
    }

    // ============================================================
    // HIP OVERRIDE LOGIC
    // When First Test = "Felt Worse", override to PELVIC_CONTROL_IMPAIRMENT
    // ============================================================
    if (problemArea === "HIP" && symptomResponseM.value === "WORSENED") {
      const overrideTarget = getOverrideTarget("HIP"); // PELVIC_CONTROL_IMPAIRMENT
      updatedData.finalPainSubtype = overrideTarget;
      updatedData.probableSubtype = overrideTarget;
      updatedData.cpgForBackend = SUBTYPE_TO_CPG_MAP["HIP"][overrideTarget];
      updatedData.wasOverridden = true;
      updatedData.overrideReason = "First Test Felt Worse";
      updatedData.diagnosisChanged = true;
      needsSecondTest = false;
    }
    // ============================================================
    // THIGH OVERRIDE LOGIC
    // When First Test = "Felt Worse", override to HAMSTRING_LOADING_LENGTHENING_DEFICIT
    // CHANGED: Was NERVE_GLIDING_DYSFUNCTION (no non-floor exercises)
    // ============================================================
    if (problemArea === "THIGH" && symptomResponseM.value === "WORSENED") {
      const overrideTarget = getOverrideTarget("THIGH"); // HAMSTRING_LOADING_LENGTHENING_DEFICIT
      updatedData.finalPainSubtype = overrideTarget;
      updatedData.probableSubtype = overrideTarget;
      updatedData.cpgForBackend = SUBTYPE_TO_CPG_MAP["THIGH"][overrideTarget];
      updatedData.wasOverridden = true;
      updatedData.overrideReason = "First Test Felt Worse";
      updatedData.diagnosisChanged = true;
      needsSecondTest = false;
    }

    // ============================================================
    // KNEE OVERRIDE LOGIC
    // When First Test = "Felt Worse", override to LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY
    // ============================================================
    if (problemArea === "KNEE" && symptomResponseM.value === "WORSENED") {
      const overrideTarget = getOverrideTarget("KNEE"); // LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY
      updatedData.finalPainSubtype = overrideTarget;
      updatedData.probableSubtype = overrideTarget;
      updatedData.cpgForBackend = SUBTYPE_TO_CPG_MAP["KNEE"][overrideTarget];
      updatedData.wasOverridden = true;
      updatedData.overrideReason = "First Test Felt Worse";
      updatedData.diagnosisChanged = true;
      needsSecondTest = false;
    }
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (needsSecondTest) {
      history.replace("/test-intro-2");
    } else {
      history.replace("/plan-recommendation");
    }
  };

  const handleContinue = (passResp) => {
    if (!symptomResponse && !passResp) return;

    const symptomResponseM = symptomResponse ? symptomResponse : passResp;

    // SIMPLE: If no passResp = button click, send to backend
    if (!passResp) {
      console.log("Button click - sending to backend:", symptomResponseM.value);
      if (window.audioPlayer && window.audioPlayer.pcm) {
        // Stoping the any ongoing PCM playback
        if (typeof window.audioPlayer.ttsPcmAbort === "function") {
          window.audioPlayer.ttsPcmAbort();
        }
        window.audioPlayer.pcm.active = false;
        window.audioPlayer.pcm.queuedSamples = 0;
      }

      // Show loader immediately when button is clicked
      startAIProcessing("Thanks for your effort. I'm working with AI; insights shortly");

      const symptomData = {
        type: "symptom_selection",
        data: { action: "SELECT_SYMPTOM", value: symptomResponseM.value },
      };

      if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify(symptomData));
      } else {
        console.error("WebSocket not connected");
        stopAIProcessing();
        proceedWithNavigation(symptomResponseM);
      }
      return; // Stop here
    }

    // If passResp exists = backend response, navigate
    proceedWithNavigation(symptomResponseM);
  };

  const handleKeyDown = (e, option) => {
    if (e.key === "Enter") {
      setSymptomResponse(option);
    }
  };

  return (
    <div className={styles.ScreenWrapper}>
      <AIProcessingLoader message={aiProcessingMessage} isVisible={isAIProcessing} />
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="symptom1" />
        <div>
          <div id="screen-rom-symptom-response" className={styles.FeeLAffectScreenContainer}>
            <h3 className={styles.FeeLAffectHeading}>How did that movement affect your pain?</h3>

            <div id="symptom-response-options" className={styles.FeeLAffectOptionList}>
              {SYMPTOM_OPTIONS.map((option) => (
                <div className={styles.FeeLAffectOptionWrapper} key={option.id}>
                  <input type="radio" autoComplete="off" name="symptom-response" id={option.id} value={option.value} checked={symptomResponse?.value === option.value} onChange={() => setSymptomResponse(option)} className={styles.FeeLAffectHiddenRadio} />
                  <label htmlFor={option.id} tabIndex={0} onKeyDown={(e) => handleKeyDown(e, option)} className={`${styles.FeeLAffectOptionLabel} ${symptomResponse?.value === option.value ? styles.FeeLAffectOptionSelected : styles.FeeLAffectOptionUnselected}`}>
                    <h4 className={styles.FeeLAffectOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
            <CommonButton
              title={"Continue"}
              disabled={!symptomResponse}
              onClick={() => handleContinue()} //  Call without parameter for button click
            />
          </div>
        </div>
      </div>
    </div>
  );
};

// helper function which make sure the video which is currently playing is removed from DOM
const stopAllVideos = () => {
  const ids = ["secondTestVideo", "secondTestVideo2", "rom-test-video-two"];

  ids.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;

    try {
      el.pause();
      el.currentTime = 0;
      el.muted = true;
      el.src = "";
      el.load();
      el.remove();
    } catch (err) {
      console.warn(`Failed removing ${id}:`, err);
    }
  });
};

// test intro 2 screeen
export const TestIntroTwo = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [isBtnClicked, setIsBtnClicked] = useState(false);
  const probableSubtype = assessmentData?.probableSubtype || "NEUTRAL_SENSITIVE";
  const floorCapability = assessmentData?.floorCapability || "floor";
  // let test = negativeTestMap[probableSubtype] || null;
  let test = getTestForCurrentAssessment(assessmentData, true);
  const testVideo = test ? testSpecificIntroVideos[test.name] : PLACEHOLDER_VIDEO;
  console.log("Test Video for current assessment is : ", testVideo);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  console.log("assesment data is : ", assessmentData);
  console.log("test is : ", test);
  console.log("subtype  is : ", probableSubtype);
  console.log("Substituted Prone Press Up with:", test.name);
  if (test?.name === "Prone Press Up" && floorCapability === "seated_standing") {
    test = negativeTestMap.SUBSTITUTE_TEST_2;
  }
  if (test?.name === "Prone Press Up") {
    test = { ...negativeTestMap.SUBSTITUTE_TEST_2 };
    console.log("Substituted Prone Press Up with:", test.name);
  }
  let currentTest = test.name;
  let movementTestPayload = generatePayloadForScreen("movement_test_2", assessmentData);
  window.movementTestPayload = movementTestPayload;
  const videoRef = useRef(null);
  let testIntro2Payload = generatePayloadForScreen("test2_demo", assessmentData, currentTest);

  var clickedOnTime = false;
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(testIntro2Payload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected");
      const isAgentSpeaking = window.mayraCode?.getState?.()?.isAgentSpeaking;
      if (isAgentSpeaking) {
        VoiceService.stopAgentSpeech();
      } else {
        console.log("[VIDEO] Agent not speaking, no action needed");
      }
    };

    videoElement.addEventListener("play", handleVideoPlay);
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, [test?.name]);
  useEffect(() => {
    window.videoController = {
      pause: () => {
        if (videoRef.current) {
          videoRef.current.pause();
          console.log("Video paused via global controller");
        }
      },
      play: () => {
        if (videoRef.current) {
          videoRef.current.play().catch((err) => console.log("Video play failed:", err));
        }
      },
      expand: () => {
        if (videoRef.current) {
          document.body.classList.add("videoplay-expanded");
          // Check for both possible video element IDs
          const videoElement = document.getElementById("secondTestVideo") || document.getElementById("secondTestVideo2") || document.getElementById("rom-test-video-two");
          if (videoElement) {
            videoElement.onclick = function () {
              document.body.classList.remove("videoplay-expanded");
            };
          }
        }
      },
      replay: () => {
        if (videoRef.current) {
          videoRef.current.currentTime = 0;
          videoRef.current.play().catch((err) => console.log("Video replay failed:", err));
        }
      },
      isPaused: () => videoRef.current?.paused ?? true,
    };

    // Cleanup on unmount
    return () => {
      window.videoController = null;
    };
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(testIntro2Payload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [testIntro2Payload, isVoiceReady]);

  useEffect(() => {
    window.screenTracker.enterScreen("test2_demo");
    MyraInteraction.onScreenEnter("test2_demo");
    setProgress(85);
    window.initFromUserGesture();

    if (document.getElementById("testtwovideo") && document.getElementById("secondTestVideo")) {
      let videoSecondID = "secondTestVideo";
      if (test?.name === "Seated Trunk Rotation" && window.hasSecondVideoRotation) {
        videoSecondID = "secondTestVideo2";
        document.getElementById("secondTestVideo").parentNode.removeChild(document.getElementById("secondTestVideo"));
      }
      // Remove default video
      document.getElementById("testtwovideo").innerHTML = "";

      // Append unlocked video
      document.getElementById("testtwovideo").appendChild(document.getElementById(videoSecondID));
      videoRef.current = document.getElementById(videoSecondID);
      videoRef.current.style.display = "block";
      videoRef.current.style.position = "";
      videoRef.current.style.left = "";
      videoRef.current.style.bottom = "";
      videoRef.current.style.width = "";
      videoRef.current.style.height = "";

      videoRef.current.className = styles.Video;

      console.log("All set for video");
    }
    if (window.mayraCode) {
      window.mayraForwardCode = {
        midjourneyData: testIntro2Payload,
      };
      window.mayraCode.startFlow("flow_demo_video", "second_test", () => {
        doReplyVideo();
      });

      // Enable skip or reply video
      window.currentCommandsAudio = {
        SKIP_VIDEO: () => {
          doPauseVideo();
          if (window.videoController) {
            window.videoController.pause();
          }
          window.mayraCode.doSay("Got it! Skipping the video.", () => {
            handleContinue();
            window.mayraCode.disableCallback();
            //window.mayraCode.setIsVisible(false);
          });
        },
        ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
          if (intent === "continue_command") {
            handleContinue();
          }
        },
        MOVE_ON: (value, speech, intent) => {
          handleContinue();
        },
        REPLAY_VIDEO: () => {
          if (window.videoController) {
            window.videoController.pause();
          }
          doPauseVideo();
          window.mayraCode.doSay("Sure! I'll replay the video for you.", () => {
            doReplyVideo();
            if (window.videoController) {
              setTimeout(() => {
                window.videoController.replay();
              }, 400);
            }
          });
        },
        PAUSE_VIDEO: () => {
          if (window.videoController) {
            if (window.videoController.isPaused()) {
              // Already paused
              window.mayraCode.doSay("The video is already paused.");
            } else {
              // Not paused → pause it
              window.videoController.pause();
              window.mayraCode.doSay("Sure! I’ll pause the video for you. When you’re ready to continue, just say Myra, resume the video.", () => {
                doPauseVideo();
              });
            }
          }
        },

        RESUME_VIDEO: () => {
          if (window.videoController && window.videoController.isPaused()) {
            window.mayraCode.doSay("Sure! I'll resume the video for you.", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          } else {
          }
        },
        EXPAND_VIDEO: () => {
          doPauseVideo();
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("Sure! I'll expand the video for you.", () => {
              window.videoController.expand();
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
        INVALID_COMMAND: () => {
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("I didn’t catch that one. Here's what I can help with: Skip the video, Replay the video, pauze the video, and Expand the video", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
        VALID_COMMAND: () => {
          if (window.videoController) {
            window.videoController.pause();
            window.mayraCode.doSay("On this screen I can help you with the following : Skip the video, Replay the video, pauze the video, and Expand the video", () => {
              setTimeout(() => {
                window.videoController.play();
              }, 400);
            });
          }
        },
      };
    }
  }, []);

  // this useeffect will check if the video is manually played then stop agent speech
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Simple event listener for video play
    const handleVideoPlay = () => {
      console.log("[VIDEO] Manual play detected - stopping agent speech");

      // Stop agent speech immediately
      VoiceService.stopAgentSpeech();
    };

    // Add event listener
    videoElement.addEventListener("play", handleVideoPlay);

    // Cleanup
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("play", handleVideoPlay);
      }
    };
  }, []);

  const doPauseVideo = () => {
    videoRef.current.pause();
  };

  const doReplyVideo = () => {
    videoRef.current.currentTime = 0;
    videoRef.current.play().catch((err) => {
      console.log("Replay autoplay prevented:", err);
    });
  };

  const handleContinue = async () => {
    window.screenTracker.exitScreen("test2_demo", {
      exitReason: "started_test",
      completed: true,
      videoWatched: true,
      videoSkipped: false,
    });
    MyraInteraction.onScreenEnter("movement_test_2");
    const screenFlow = window.screenTracker.getScreenFlow();
    doPauseVideo();
    stopAllVideos();
    window.movementTestPayload = movementTestPayload;
    // Calculate video watching metrics before removing
    let videoWatchedFully = false;
    let videoDurationWatched = 0;
    if (videoRef.current) {
      videoDurationWatched = Math.round(videoRef.current.currentTime);

      // Check if video was watched to at least 90% completion
      if (videoRef.current.duration > 0) {
        const completionPercentage = (videoRef.current.currentTime / videoRef.current.duration) * 100;
        videoWatchedFully = completionPercentage >= 90;
      }
    }
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
      videoRef.current.muted = true;
      videoRef.current.src = "";
      videoRef.current.load();
      videoRef.current.remove();
    }

    const testTwoVideoContainer = document.getElementById("testtwovideo");
    if (testTwoVideoContainer) testTwoVideoContainer.innerHTML = "";

    if (clickedOnTime) {
      return;
    }
    clickedOnTime = true;

    setIsBtnClicked(true);
    const updatedData = {
      ...assessmentData,
      testName2: test.name,
      test2VideoWatched: videoWatchedFully,
      test2VideoDuration: videoDurationWatched,
      rom_test2_started: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    localStorage.setItem("runStep", "2");
    localStorage.setItem("loadSelf", test.name);

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);

    document.body.classList.remove("videoplay-expanded");

    if (window.mayraCode && window.mayraCode.setIsVisible) {
      //window.mayraCode.setIsVisible(false);
    }

    if (window.mayraCode) {
      window.mayraCode.disableCallback();
    }
    window.currentCommandsAudio = {};

    /*
    setTimeout(() => {
      if (window.mayraCode && window.mayraCode.forceStop) {
        window.mayraCode.forceStop();
      }
    }, 2000); */
    if (movementTestPayload) {
      VoiceService.sendMidJourneyData(movementTestPayload);
    }
    MyraInteraction.onScreenEnter("movement_test_2");
    // setting wakeup lock on initialization to prevent the device from sleeping in the middle of the session
    // setTimeout(async () => {
    //   if (window.wakeLockManager) {
    //     await window.wakeLockManager.acquire();
    //   }
    // }, 100);

    console.log("Level 2 - 1");
    document.getElementById("OnDemandPlayingRoot").style.display = "block";
    document.querySelector("html").classList = [];
    document.getElementById("assesmentDiv").style.display = "none";

    if (document.querySelector("#assesmentDiv video")) {
      document.querySelector("#assesmentDiv video").play();
      setTimeout(() => {
        document.querySelector("#assesmentDiv video").pause();
      }, 50);
    }

    console.log("Level 2 - 2");
    setIsBtnClicked(false);

    window.blockNextSelfCall = true;
    setTimeout(() => {
      window.blockNextSelfCall = false;
    }, 5000);
    if (window.nextActivityStart) {
      window.nextActivityStart();
    }
  };

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleVideoEnd = () => {
      try {
        const videoWatchedFully = true;
        const videoDurationWatched = Math.round(videoElement.duration);

        // Update assessment data with video completion
        assessmentData.test2VideoWatched = videoWatchedFully;
        assessmentData.test2VideoDuration = videoDurationWatched;
        assessmentData.rom_test2_started = true;
        window.mayraCode.doSay("Now, that you’ve seen how it works, let’s move to the next step.", () => {
          setTimeout(() => {
            handleContinue();
          }, 500);
        });
      } catch (err) {
        console.error("Error sending speech command:", err);
      }
      // try {
      //   if (window.mayraCode && window.mayraCode.doSay && window.mayraCode.isEnabled) {
      //     window.mayraCode.doSay("Now that you’ve seen how it works, let’s move to the next step.");
      //     console.log("Sent speech command to backend");
      //   } else {
      //     console.warn("WebSocket not connected - cannot send speech command");
      //   }
      // } catch (error) {
      //   console.error("Error sending speech command:", error);
      // }
    };
    // Add event listener for video end
    videoElement.addEventListener("ended", handleVideoEnd);

    // Cleanup function to remove event listener
    return () => {
      if (videoElement) {
        videoElement.removeEventListener("ended", handleVideoEnd);
      }
    };
  }, []);

  if (!test) {
    return (
      <div style={{ textAlign: "center", padding: 6 }}>
        <p className="text-gray-500">Loading test instructions...</p>
      </div>
    );
  }

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="test2_demo" videoRef={videoRef} />
        <div>
          <div id="screen-rom-intro" className={styles.ScreenContainer}>
            <Heading styles={{ textAlign: "center" }} heading="Great. Now for the Second Movement" />
            <SubHeading styles={{ textAlign: "center" }} subheading="This helps us confirm your movement pattern." />

            <div className={styles.VideoContainer} id="testtwovideo">
              <video id="rom-test-video-two" className={styles.Video} controls playsInline ref={videoRef}>
                <source src={testVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            {test.name && (
              <div id="rom-test-instruction" className={styles.InstructionBox}>
                <h4 className={styles.InstructionTitle}>{test.name}</h4>
                <p className={styles.InstructionText}>
                  Please perform 4 repetitions of {test.name}. <br />{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                    }}
                  >
                    Important{" "}
                  </span>{" "}
                  : Stop & Press <strong>Skip Exercise</strong> if you feel a significant increase in pain.
                </p>
              </div>
            )}

            <CommonButton className="rom-test-start-button" title={isBtnClicked ? "Loading Movement Test…" : "Start Movement Test"} onClick={handleContinue} />
          </div>
        </div>
      </div>
    </div>
  );
};

// feedback 2 screen
export const Feedback2 = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  const [response, setResponse] = useState("");
  console.log("responsy is : ", response); // -> WORSE , BETTER
  const test_symptom_2 = generatePayloadForScreen("symptom2", assessmentData);

  const [romValues, setRomValues] = useState([]);
  const [durations, setDurations] = useState([]);
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const history = useHistory();
  const data = localStorage.getItem("dataAfterInfo");
  console.log("data from feedback 2 : ", data);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(test_symptom_2);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  document.body.style = "";

  useEffect(() => {
    const { rom, dur } = parseDataAfterInfo();
    setRomValues(rom);
    setDurations(dur);
    setProgress(95);
    window.screenTracker.enterScreen("symptom2");
    MyraInteraction.onScreenEnter("symptom2");
  }, []);

  useEffect(() => {
    // VoiceService._ws = null;
    window.currentCommandsAudio = {
      SELECT_SYMPTOM: (val) => {
        // Normalize "WORSENED" → "WORSE"
        if (val === "WORSENED") {
          val = "WORSE";
        }
        if (val === "TOLERABLE" || val === "IMPROVED") {
          val = "BETTER";
        }
        console.log("Symptom NLU received:", val);
        setResponse(val);
        const symptomMsg = val.toLowerCase() === "worse" || val.toUpperCase() === "WORSENED" ? "Thanks for sharing—that’s what we’d expect from this test. It helps us better understand what’s going on and how to tailor your recovery plan. Let’s move on to the next step." : "Thanks for sharing that with me! That’s very helpful information, and we’ll take it into account as we refine your recovery plan. Let’s move on to the next step.";
        window.mayraCode.doSay(symptomMsg, () => {
          setTimeout(() => {
            console.log("Clicked next", val, response);
            handleContinue(val);
          }, 500);
        });
      },
    };
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      window.mayraForwardCode = {
        midjourneyData: test_symptom_2,
      };
      window.mayraCode.startFlow("flow_symptom", "symptom2");
    }
  }, []);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(test_symptom_2);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [test_symptom_2, isVoiceReady]);

  const handleContinue = (passResp) => {
    if (!response && !passResp) return;
    const responseM = response || passResp;
    let testName2 = assessmentData?.testName2 === "Seated Trunk Rotation";
    window.screenTracker.exitScreen("symptom2", {
      exitReason: "symptom_response_submitted",
      completed: true,
    });
    MyraInteraction.onScreenEnter("personalize");
    const screenFlow = window.screenTracker.getScreenFlow();

    const { rom, dur } = parseDataAfterInfo();

    const updated = {
      ...assessmentData,
      symptomResponseConfirm: responseM === "WORSE" ? "WORSENED" : "TOLERABLE",
      rom2: rom.length ? rom : romValues,
      duration2: dur.length ? dur : durations,
      rom_test2_completed: true,
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };
    const subtype = updated.probableSubtype;
    const problemArea = assessmentData.problemArea || "LBP";
    console.log("subtype before reclassification logic is : ", subtype);
    console.log("Problem area is : ", problemArea);
    // ============================================================
    // LBP RECLASSIFICATION LOGIC (existing - no changes)
    // ============================================================
    if (problemArea === "LBP") {
      if (["FLEXION_INTOLERANT", "EXTENSION_INTOLERANT", "ROTATIONAL_INTOLERANT"].includes(subtype) && responseM !== "WORSE") {
        updated.finalPainSubtype = "NEUTRAL_SENSITIVE";
        updated.probableSubtype = "NEUTRAL_SENSITIVE";
        updated.diagnosisChanged = true;
      } else {
        updated.finalPainSubtype = subtype;
        updated.probableSubtype = subtype;
      }
      if (testName2 && responseM === "BETTER") {
        updated.probableSubtype = "NEUTRAL_SENSITIVE";
      }
    }
    // ============================================================
    // HIP RECLASSIFICATION LOGIC
    // When Second Test = "Felt Same/Better", reclassify to PELVIC_CONTROL_IMPAIRMENT
    // ============================================================
    if (problemArea === "HIP") {
      if (responseM === "WORSE") {
        // Confirms original diagnosis
        updated.finalPainSubtype = subtype;
      } else {
        // Reclassify to override target
        const overrideTarget = getOverrideTarget("HIP"); // PELVIC_CONTROL_IMPAIRMENT
        updated.finalPainSubtype = overrideTarget;
        updated.probableSubtype = overrideTarget;
        updated.cpgForBackend = SUBTYPE_TO_CPG_MAP["HIP"][overrideTarget];
        updated.wasReclassified = true;
        updated.reclassifyReason = "Second Test did not worsen symptoms";
        updated.diagnosisChanged = true;
      }
    }

    // ============================================================
    // THIGH RECLASSIFICATION LOGIC
    // When Second Test = "Felt Same/Better", reclassify to HAMSTRING_LOADING_LENGTHENING_DEFICIT
    // CHANGED: Was NERVE_GLIDING_DYSFUNCTION (no non-floor exercises)
    // ============================================================
    if (problemArea === "THIGH") {
      if (responseM === "WORSE") {
        // Confirms original diagnosis
        updated.finalPainSubtype = subtype;
      } else {
        // Reclassify to override target
        const overrideTarget = getOverrideTarget("THIGH"); // HAMSTRING_LOADING_LENGTHENING_DEFICIT
        updated.finalPainSubtype = overrideTarget;
        updated.probableSubtype = overrideTarget;
        updated.cpgForBackend = SUBTYPE_TO_CPG_MAP["THIGH"][overrideTarget];
        updated.wasReclassified = true;
        updated.reclassifyReason = "Second Test did not worsen symptoms";
        updated.diagnosisChanged = true;
      }
    }

    // ============================================================
    // KNEE RECLASSIFICATION LOGIC
    // When Second Test = "Felt Same/Better", reclassify to LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY
    // ============================================================
    if (problemArea === "KNEE") {
      if (responseM === "WORSE") {
        // Confirms original diagnosis
        updated.finalPainSubtype = subtype;
      } else {
        // Reclassify to override target
        const overrideTarget = getOverrideTarget("KNEE"); // LIMITED_KNEE_EXTENSION_FLEXION_MOBILITY
        updated.finalPainSubtype = overrideTarget;
        updated.probableSubtype = overrideTarget;
        updated.cpgForBackend = SUBTYPE_TO_CPG_MAP["KNEE"][overrideTarget];
        updated.wasReclassified = true;
        updated.reclassifyReason = "Second Test did not worsen symptoms";
        updated.diagnosisChanged = true;
      }
    }
    updateAssessmentData(updated);
    localStorage.setItem("assessmentData", JSON.stringify(updated));

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updated);

    console.log("Final subtype after reclassification logic is : ", subtype);
    history.replace("/plan-recommendation");
  };
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="symptom2" />
        <div>
          <h2 id="symptom-response-title" className={styles.FeedbackkHeading}>
            How did the second movement test feel compared to the first movement test?
          </h2>

          <div id="symptom-response-options" className={styles.FeedbackkOptionList}>
            <label className={`${styles.FeedbackkOptionLabel} ${response === "WORSE" ? styles.FeedbackkSelected : styles.FeedbackkUnselected}`}>
              <input type="radio" autoComplete="off" name="symptom-response-simple" value="WORSE" checked={response === "WORSE"} onChange={() => setResponse("WORSE")} className={styles.FeedbackkHiddenInput} />
              <h4 className={styles.FeedbackkOptionText}>Felt Worse</h4>
            </label>
            <label className={`${styles.FeedbackkOptionLabel} ${response === "BETTER" ? styles.FeedbackkSelected : styles.FeedbackkUnselected}`}>
              <input type="radio" autoComplete="off" name="symptom-response-simple" value="BETTER" checked={response === "BETTER"} onChange={() => setResponse("BETTER")} className={styles.FeedbackkHiddenInput} />
              <h4 className={styles.FeedbackkOptionText}>Felt Better</h4>
            </label>
          </div>

          <CommonButton title={"Continue"} onClick={handleContinue} disabled={!response} />
        </div>
      </div>
    </div>
  );
};

// demographic modal
const ConservativePlanModal = ({ onClose, onConfirm, showBalanceWarning }) => {
  return (
    <div className={styles.SDMOverlay}>
      <div className={styles.SDMBackdrop}></div>
      <div className={styles.SDMModal}>
        <h3 className={styles.SDMTitle}>A Quick Note Before We Continue</h3>
        <p className={styles.SDMText}>Since we don't have your personal details just yet, we will keep things on the conservative side, which is the safest way to begin.</p>
        {/* Paragraph 2 — conditional: only shown if floor or balance was not selected */}
        {showBalanceWarning && <p className={styles.SDMText}>Because we don't know your current balance ability or if getting up from the floor is tricky for you, please take things at your own pace. Always listen to your body as you move, and feel free to skip any exercises that do not feel completely safe.</p>}
        <div className={styles.SDMButtonGroup}>
          <button onClick={onClose} className={styles.SDMBackButton}>
            Go Back &amp; Add My Info
          </button>
          <button onClick={onConfirm} className={styles.SDMConfirmButton}>
            Continue With Conservative Plan
          </button>
        </div>
      </div>
    </div>
  );
};
// demographic form
const DemographicsForm = React.forwardRef(({ onSubmit, onSkip, selectedGoals, setSelectedGoals, disabled, setForm, form, checklistItems }, ref) => {
  const [ageError, setAgeError] = useState("");
  const [showValidation, setShowValidation] = useState(false);
  const validationBannerRef = useRef(null);

  // Helper to update form state
  const updateField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  useEffect(() => {
    if (window.destroyFlutterResources) {
      try {
        window.destroyFlutterResources();
        console.log("Flutter resources destroyed after performing 2nd exercise");
      } catch (error) {
        console.warn("something went wrong while destroying flutter resources");
      }
    }
  }, []);

  const fieldChecks = [
    { key: "age", value: form.age, label: "your age" },
    { key: "weight", value: form.weight, label: "your weight" },
    { key: "heightFt", value: form.heightFt, label: "your height in feet" },
    { key: "heightIn", value: form.heightIn, label: "your height in inches" },
    { key: "activity", value: form.activity, label: "your weekly activity level" },
    { key: "floorCapability", value: form.floorCapability, label: "your floor capability" },
    { key: "balance", value: form.balance, label: "your balance" },
    { key: "goal", value: selectedGoals.length > 0, label: "your primary goal" },
    { key: "scheduleDays", value: form.scheduleDays, label: "your available days for exercise" },
    { key: "scheduleTime", value: form.scheduleTime, label: "your preferred session time" },
    { key: "sessionPref", value: form.sessionPref, label: "your session preference" },
  ];

  const getFirstMissingField = () => {
    for (let check of fieldChecks) {
      if (!check.value) return check.label;
    }
    return null;
  };

  const getAllMissingFields = () => {
    const missing = fieldChecks.filter((check) => !check.value).map((check) => check.label);
    return missing.length > 0 ? missing.join(", ") : null;
  };

  if (window.closeStream) {
    window.closeStream();
  }

  useEffect(() => {
    if (form.age === "") {
      setAgeError("");
    } else if (parseInt(form.age) < 18) {
      setAgeError("Participants must be 18 or older.");
    } else {
      setAgeError("");
    }
  }, [form.age]);

  const getFormData = () => ({
    ...form,
    goal: selectedGoals,
  });

  const handleSubmit = () => {
    if (parseInt(form.age) < 18) {
      setAgeError("Participants must be 18 or older.");
      return;
    }
    // const missing = getFirstMissingField();
    // if (missing) {
    //   window.mayraCode.doSay(`Please enter ${missing}.`, () => {});
    //   return;
    // }
    if (form.preExistingConditions || form.currentConditions) {
      const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
      const currentConditions = userCondition.usercondition || {};

      // Only update if field has value
      if (form.preExistingConditions) {
        currentConditions.pre_existing = form.preExistingConditions;
      }

      if (form.currentConditions) {
        currentConditions.current = form.currentConditions;
      }
      userCondition.usercondition = currentConditions;
      localStorage.setItem("userCondition", JSON.stringify(userCondition));

      console.log("[CONDITIONS SAVED] Updated:", currentConditions);
    }

    onSubmit(getFormData());
  };

  React.useImperativeHandle(ref, () => ({
    handleSubmit,
    getAllMissingFields,
  }));

  return (
    <div id="screen-demographics">
      <Heading heading={"Personalize Your Recovery Plan"} styles={{ textAlign: "center" }} />
      <SubHeading subheading={"This helps us accurately calculate your Recovery Compass Score and tailor your plan."} styles={{ textAlign: "center", color: "#6b7280", padding: "10px 0" }} />

      <form onSubmit={(e) => e.preventDefault()}>
        {/* Age & Biometrics */}
        <div id="section-age">
          <label htmlFor="age" className={styles.dfLabel}>
            Age & Biometrics
          </label>
          <div className={styles.dfTwoColGrid}>
            <input type="number" id="age" placeholder="Age" value={form.age} className={styles.dfTextInput} tabIndex={1} onChange={(e) => updateField("age", e.target.value)} />
            <input type="number" id="weight_lbs" placeholder="Weight (lbs)" className={styles.dfTextInput} value={form.weight} tabIndex={2} onChange={(e) => updateField("weight", e.target.value)} />
          </div>
          {ageError && (
            <p style={{ color: "#ef4444", fontSize: "0.75rem" }} className={styles.DFError}>
              {ageError}
            </p>
          )}
          <div className={styles.dfTwoColGrid} style={{ marginTop: "0.5rem" }}>
            <input type="number" id="height_ft" placeholder="Height (ft)" className={styles.dfTextInput} tabIndex={3} value={form.heightFt} onChange={(e) => updateField("heightFt", e.target.value)} />
            <input type="number" id="height_in" placeholder="Height (in)" className={styles.dfTextInput} tabIndex={4} value={form.heightIn} onChange={(e) => updateField("heightIn", e.target.value)} />
          </div>
        </div>

        {/* Activity Levels */}
        <div id="section-activity" style={{ padding: "1rem 0" }}>
          <label className={styles.dfLabel}>In a typical week, how many days do you get at least 20 minutes of exercise?</label>
          <div className={styles.dfOptionsGrid4}>
            {activityLevels.map(({ id, value, label, tabIndex }, index) => (
              <React.Fragment key={id}>
                <input type="radio" autoComplete="off" name="activity" id={id} value={value} checked={form.activity === value} onChange={(e) => updateField("activity", e.target.value)} className={styles.DFHiddenRadio} />
                <label htmlFor={id} tabIndex={tabIndex} onKeyDown={(e) => e.key === "Enter" && updateField("activity", value)} className={`${styles.DFOption} ${form.activity === value ? styles.DFOptionSelected : styles.DFOptionUnselected}`}>
                  <h4 className={styles.DFOptionText}>{label}</h4>
                </label>
              </React.Fragment>
            ))}
          </div>
        </div>

        <div className={`${styles.dfSectionBorder}`}>
          {/* <p className={styles.sectionIntro}></p> */}
          <SubHeading subheading={"Sharing this helps us select exercises that are safe and appropriate for your body."} styles={{ color: "#6b7280", padding: "10px 0" }} />
          {/* Floor Capability */}
          <div id="section-floor" style={{ padding: "10px 0" }}>
            <label className={styles.dfLabel}>Are you comfortable doing exercises on the floor, or is that too difficult for you right now?</label>
            <div className={styles.dfTwoColGrid}>
              {floorOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="floor-capability" id={option.id} value={option.value} checked={form.floorCapability === option.value} onChange={(e) => updateField("floorCapability", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.floorCapability === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("floorCapability", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Balance */}
          <div id="section-balance">
            <label className={styles.dfLabel}>How would you rate your balance while standing?</label>
            <div className={styles.dfTwoColGrid}>
              {balanceOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="balance" id={option.id} value={option.value} checked={form.balance === option.value} onChange={(e) => updateField("balance", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${styles.dfOptionLabel2}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.balance === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("balance", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>
          {/* Optional Health Context */}
          <div style={{ padding: "10px 0" }}>
            <label className={` ${styles.dfLabel}`} style={{ marginBottom: "10px" }}>
              Do you have any pre-existing conditions?
              <span className={styles.optionalBadge}>(optional)</span>
            </label>
            <input type="text" id="pre_existing_conditions" className={styles.userConditionInput} placeholder="e.g., arthritis, prior surgery, osteoporosis, pregnancy, joint replacement" value={form.preExistingConditions} onChange={(e) => updateField("preExistingConditions", e.target.value)} />
          </div>

          <div style={{ padding: "10px 0" }}>
            <label className={`${styles.dfLabel}`} style={{ marginBottom: "10px" }}>
              Is there anything currently going on with your body?
              <span className={styles.optionalBadge}>(optional)</span>
            </label>
            <input type="text" id="current_conditions" className={styles.userConditionInput} placeholder="e.g., pulled muscle, recent flare-up, tweaked my back yesterday" value={form.currentConditions} onChange={(e) => updateField("currentConditions", e.target.value)} />
          </div>
        </div>

        <div className={`${styles.dfSectionBorder}`}>
          {/* Primary Goal */}
          <div id="section-goals">
            <label className={styles.dfLabel} style={{ margin: "10px 0" }}>
              What is your primary goal?
            </label>
            <GoalsMultiSelect selectedGoals={selectedGoals} onChange={setSelectedGoals} tabIndex={13} />
          </div>

          {/* Schedule Days */}
          <div id="section-schedule" style={{ padding: "1rem 0" }}>
            <label className={styles.dfLabel}>How many days a week does your schedule allow for exercise?</label>
            <div className={styles.dfOptionsGrid6}>
              {scheduleDaysOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="schedule-days" id={option.id} value={option.value} checked={form.scheduleDays === option.value} onChange={(e) => updateField("scheduleDays", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.scheduleDays === option.value ? styles.DFOptionSelected : ""}`}
                    style={{
                      border: form.scheduleDays === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    tabIndex={option.tabIndex}
                    onKeyDown={(e) => e.key === "Enter" && updateField("scheduleDays", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Session Preference */}
          <div id="section-sessionPref">
            <label className={styles.dfLabel}>Would you prefer one session or two sessions per day?</label>
            <div className={styles.dfTwoColGrid}>
              {sessionOptions.map((option, index) => (
                <div key={option.id}>
                  <input
                    type="radio"
                    name="session-pref"
                    id={option.id}
                    value={option.value}
                    checked={form.sessionPref === option.value}
                    onChange={(e) => {
                      updateField("sessionPref", e.target.value);
                    }}
                    className={styles.dfHiddenRadio}
                  />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.sessionPref === option.value ? styles.DFOptionSelected : ""}`}
                    style={{
                      border: form.sessionPref === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    tabIndex={option.tabIndex}
                    onKeyDown={(e) => e.key === "Enter" && updateField("sessionPref", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Session Time */}
          <div id="section-duration" style={{ padding: "1rem 0" }}>
            <label className={styles.dfLabel}>How much time per session fits into your schedule?</label>
            <div className={styles.dfOptionsGrid3}>
              {scheduleTimeOptions.map((option, index) => (
                <div key={option.id}>
                  <input type="radio" name="schedule-time" id={option.id} value={option.value} checked={form.scheduleTime === option.value} onChange={(e) => updateField("scheduleTime", e.target.value)} className={styles.dfHiddenRadio} />
                  <label
                    htmlFor={option.id}
                    className={`${styles.dfOptionLabel} ${form.scheduleTime === option.value ? styles.DFOptionSelected : ""}`}
                    tabIndex={option.tabIndex}
                    style={{
                      border: form.scheduleTime === option.value ? "3px solid #0d9488" : "2px solid #e5e7eb",
                    }}
                    onKeyDown={(e) => e.key === "Enter" && updateField("scheduleTime", option.value)}
                  >
                    <h4 className={styles.DFOptionText}>{option.label}</h4>
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </form>

      {/* Validation Banner — rendered in place, positioned dynamically */}
      {showValidation &&
        checklistItems &&
        (() => {
          const missingItems = checklistItems.filter((item) => !item.completed);
          // Map checklist item IDs to form section IDs
          const sectionMap = {
            age: "section-age",
            weight: "section-age",
            height: "section-age",
            activity: "section-activity",
            floor: "section-floor",
            balance_check: "section-balance",
            goals: "section-goals",
            schedule: "section-schedule",
            session_pref: "section-sessionPref",
            duration: "section-duration",
          };

          return missingItems.length > 0 ? (
            <div className={styles.validationBanner} ref={validationBannerRef}>
              <div className={styles.validationBannerHeader}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="#f59e0b">
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
                </svg>
                <span className={styles.validationBannerTitle}>
                  {missingItems.length} field{missingItems.length > 1 ? "s" : ""} still needed
                </span>
                <button className={styles.validationBannerClose} onClick={() => setShowValidation(false)}>
                  &times;
                </button>
              </div>
              <div className={styles.validationChips}>
                {missingItems.map((item) => (
                  <button
                    key={item.id}
                    className={styles.validationChip}
                    onClick={() => {
                      const sectionId = sectionMap[item.id];
                      const el = sectionId ? document.getElementById(sectionId) : null;
                      if (el) {
                        el.scrollIntoView({ behavior: "smooth", block: "center" });
                      }
                    }}
                  >
                    {item.label} ↗
                  </button>
                ))}
              </div>
              <p className={styles.validationHint}>Tap any item to jump to that field</p>
            </div>
          ) : null;
        })()}

      {/* Buttons */}
      <div>
        <button
          tabIndex={23}
          onClick={() => {
            const incompleteItems = checklistItems ? checklistItems.filter((item) => !item.completed) : [];
            if (incompleteItems.length > 0) {
              setShowValidation(true);
              // Scroll to first missing field — preserved as informational behavior
              const sectionMap = {
                age: "section-age",
                weight: "section-age",
                height: "section-age",
                activity: "section-activity",
                floor: "section-floor",
                balance_check: "section-balance",
                goals: "section-goals",
                schedule: "section-schedule",
                session_pref: "section-sessionPref",
                duration: "section-duration",
              };
              const firstMissing = incompleteItems[0];
              const sectionId = sectionMap[firstMissing.id];
              setTimeout(() => {
                const el = sectionId ? document.getElementById(sectionId) : null;
                if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
              }, 100);
            }
            handleSubmit();
          }}
          className={styles.DFPrimaryButton}
        >
          See My Recovery Compass Score
          {checklistItems && checklistItems.filter((item) => !item.completed).length > 0 && <span className={styles.remainingBadge}>{checklistItems.filter((item) => !item.completed).length} remaining</span>}
        </button>
      </div>
    </div>
  );
});

// plan recommnedation screen
export const PlanRecommendation = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { assessmentData, updateAssessmentData } = useAssessment();
  console.log("data is : ", assessmentData);
  const [showConservativeModal, setShowConservativeModal] = useState(false);
  const formRef = useRef();
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const [demographics, setDemographics] = useState({
    age: "",
    weight: "",
    heightFt: "",
    heightIn: "",
    activity: null,
    floorCapability: null,
    balance: null,
    preExistingConditions: userConditions.pre_existing || "",
    currentConditions: userConditions.current || "",
    scheduleDays: null,
    scheduleTime: null,
    sessionPref: "",
  });
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const checklistItems = [
    { id: "age", label: "Age", completed: !!demographics.age && demographics.age >= 18 },
    { id: "weight", label: "Weight", completed: !!demographics.weight },
    { id: "height", label: "Height", completed: !!demographics.heightFt && !!demographics.heightIn },
    { id: "activity", label: "Activity Level", completed: !!demographics.activity },
    { id: "floor", label: "Floor Capability", completed: !!demographics.floorCapability },
    { id: "balance_check", label: "Balance", completed: !!demographics.balance },
    { id: "goals", label: "Goals", completed: selectedGoals.length > 0 },
    { id: "schedule", label: "Avail. Schedule", completed: !!demographics.scheduleDays },
    { id: "duration", label: "How Long", completed: !!demographics.scheduleTime },
    { id: "session_pref", label: "Session Pref", completed: demographics.sessionPref === "one" || demographics.sessionPref === "multiple" },
  ];

  // True when ALL 6 key fields are filled — user goes straight through, no modal.
  const allKeyFieldsFilled = !!demographics.age && Number(demographics.age) >= 18 && !!demographics.weight && !!demographics.heightFt && !!demographics.heightIn && !!demographics.activity && !!demographics.floorCapability && !!demographics.balance;

  // True when floor OR balance is missing — triggers paragraph 2 in the modal.
  const showBalanceWarning = !demographics.floorCapability || !demographics.balance;

  useEffect(() => {
    try {
      const storedData = JSON.parse(localStorage.getItem("assessmentData")) || {};
      if (storedData.symptomResponseConfirm === "WORSENED") {
        updateAssessmentData(storedData);
        console.log("Synced WORSENED symptomResponseConfirm to context");
      }
    } catch (err) {
      console.error("Error syncing WORSENED symptomResponseConfirm from localStorage", err);
    }
  }, []);

  const personalizePayload = generatePayloadForScreen("personalize", assessmentData);
  useEffect(() => {
    window.screenTracker.enterScreen("personalize");
    MyraInteraction.onScreenEnter("personalize");
    setProgress(100);
    if (window.closeStream) {
      window.closeStream();
    }
  }, []);
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(personalizePayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);
  const history = useHistory();

  useEffect(() => {
    window.currentCommandsAudio = {
      MOVE_ON: () => {
        // eslint-disable-next-line no-unused-expressions
        formRef.current?.handleSubmit();
      },
      FORM_QUESTION: () => {
        const missing = formRef.current?.getAllMissingFields();
        if (missing) {
          window.mayraCode.doSay(`Please enter ${missing}.`, () => {});
          return;
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent, extracted) => {
        if (intent === "continue_command") {
          formRef.current.handleSubmit();
          return;
        }
        console.log("EXTRACTED IS : ", extracted);

        if (extracted && Object.keys(extracted).length > 0) {
          console.log("[VOICE] Updating form with extracted data:", extracted);

          setDemographics((prev) => {
            const updates = {};
            const fieldMappings = {
              age: "age",
              weightLbs: "weight",
              heightFt: "heightFt",
              heightIn: "heightIn",
              activityLevel: "activity",
              floorCapability: "floorCapability",
              balance: "balance",
              scheduleDays: "scheduleDays",
              sessionPref: "sessionPref",
              sessionLength: "scheduleTime",
              preExistingConditions: "preExistingConditions",
              currentConditions: "currentConditions",
            };
            Object.entries(fieldMappings).forEach(([extractedKey, formKey]) => {
              if (extracted[extractedKey] !== undefined && extracted[extractedKey] !== null) {
                updates[formKey] = extracted[extractedKey];
                console.log(`[VOICE] Updating ${formKey} to:`, extracted[extractedKey]);
              }
            });

            // Handle goals - convert from string values to the expected object format
            if (extracted.goals) {
              const goalTextMap = {
                reduce_pain: "Reduce Pain",
                less_stiff: "Reduce Stiffness",
                improve_strength: "Improve Strength",
                improve_flexibility: "Improve Flexibility",
                daily_tasks: "Make Daily Tasks Easier",
                balance: "Improve Balance & Stability",
                picking_up: "Picking Up Things",
                sleep: "Improve Sleep Quality",
                walking: "Improve Walking & Endurance",
                lifting: "Make Bending & Lifting Easier",
                posture: "Improve Sitting & Standing Posture",
                rotational_sports: "Return to Sports (Golf, Tennis, etc.)",
                overhead_sports: "Return to Sports (Basketball, Swimming, etc.)",
                running: "Running, Cycling, etc.",
                fitness: "Fitness: Gym, CrossFit, etc.",
              };

              const goalsArray = Array.isArray(extracted.goals) ? extracted.goals : [extracted.goals];
              const formattedGoals = goalsArray
                .filter((goalValue) => goalTextMap[goalValue])
                .map((goalValue) => ({
                  value: goalValue,
                  text: goalTextMap[goalValue],
                }));

              if (formattedGoals.length > 0) {
                setSelectedGoals(formattedGoals);
                console.log("[VOICE] Updating goals to:", formattedGoals);
              }
            }

            return { ...prev, ...updates };
          });
        }

        // Also check localStorage for conditions (existing behavior)
        const stored = JSON.parse(localStorage.getItem("userCondition") || "{}");
        const userConditions = stored?.usercondition || {};

        setDemographics((prev) => ({
          ...prev,
          preExistingConditions: prev.preExistingConditions || userConditions.pre_existing || "",
          currentConditions: prev.currentConditions || userConditions.current || "",
        }));
      },
    };
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      window.mayraForwardCode = {
        midjourneyData: personalizePayload,
      };
      let announcement = "";
      if (mode === "voice") {
        window.mayraCode.startFlow("flow_personalized", "personalized");
      } else if (mode === "chat") {
        announcement = "Let’s make this all about you! To tailor your plan, I need a little more information about you. Please type your details, including any prior surgeries or injuries to your spine or hips, or any conditions related to lower back pain. If there’s anything else you think is important for me to know, feel free to share that too. When you’re done, just type, 'continue.' If you have any questions about why I’m asking for something, just ask!";
        VoiceService.startFlowWithoutAnnouncement("flow_personalized", "", announcement);
      } else {
        announcement = "Let’s make this all about you! To tailor your plan, I need a little more information about you. Use the buttons to share details about any prior surgeries, injuries, or conditions related to lower back pain. If you’d like to ask me something, tap the Myra icon in the bottom left corner to start a conversation. When you’re ready, press the Continue button to move forward.";
        VoiceService.startFlowWithoutAnnouncement("flow_personalized", "", announcement);
      }
    }
  }, []);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(personalizePayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [personalizePayload, isVoiceReady]);
  const handleConfirmWithDefaults = () => {
    setShowConservativeModal(false);
    navigateWithDemographics(true);
  };
  const handleFormSubmit = () => {
    // If any of the 6 key fields are missing, show the ConservativePlanModal.
    // The modal gives the user a chance to go back and fill them in,
    // or acknowledge the conservative defaults and continue.
    if (!allKeyFieldsFilled) {
      setShowConservativeModal(true);
      return;
    }

    // All 6 key fields are filled — proceed directly, no modal.
    navigateWithDemographics(false);
  };
  // Shared navigation function used by both the full-data path and the defaults path.
  // useDefaults=false: user filled all key fields, use their data as-is.
  // useDefaults=true: called from handleConfirmWithDefaults after modal confirmation.
  const navigateWithDemographics = (useDefaults) => {
    window.screenTracker.exitScreen("personalize", {
      exitReason: useDefaults ? "conservative_defaults_accepted" : "demographics_completed",
      completed: !useDefaults,
    });
    MyraInteraction.onScreenEnter("recovery_score");
    const screenFlow = window.screenTracker.getScreenFlow();
    const now = new Date();
    const formattedTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    // Merge user-provided values with defaults for any missing key fields.
    // Non-key fields (goals, schedule, sessionPref) also fall back to defaults
    // if the user did not provide them.
    const resolvedAge = Number(demographics.age) || 60;
    const resolvedHeightFt = Number(demographics.heightFt) || 5;
    const resolvedHeightIn = Number(demographics.heightIn) || 7;
    const resolvedWeight = Number(demographics.weight) || 225;
    const resolvedActivity = demographics.activity || "SEDENTARY";
    const resolvedFloor = demographics.floorCapability || "yes";
    const resolvedBalance = demographics.balance || "steady";
    const resolvedGoals = selectedGoals.length > 0 ? selectedGoals : ["Reduce Pain"];
    const resolvedSchedule = demographics.scheduleDays || "2-3";
    const resolvedSessionPref = demographics.sessionPref === "one" || demographics.sessionPref === "multiple" ? demographics.sessionPref : "one";
    const resolvedScheduleTime = demographics.scheduleTime || null;

    const isMultipleSessions = resolvedSessionPref === "multiple";
    let daily_sessions = null;
    if (isMultipleSessions) {
      const hours = now.getHours();
      daily_sessions = hours < 12 ? ["Morning", "Evening"] : ["Evening"];
    } else {
      daily_sessions = ["One"];
    }

    // personal_info_skipped is true when the user did not fill all 6 key fields.
    // Used by analytics to track how often defaults are applied.
    const personalInfoSkipped = !allKeyFieldsFilled;

    const updatedData = {
      ...assessmentData,
      signature: !personalInfoSkipped,
      biometrics: {
        skipped: personalInfoSkipped,
        age: resolvedAge,
        activityLevel: resolvedActivity,
        heightFt: resolvedHeightFt,
        heightIn: resolvedHeightIn,
        weightLbs: resolvedWeight,
        floorCapability: resolvedFloor,
        balance: resolvedBalance,
        preExistingConditions: demographics.preExistingConditions || null,
        currentConditions: demographics.currentConditions || null,
        goal: resolvedGoals,
        sessionPref: resolvedSessionPref,
        scheduleTime: resolvedScheduleTime,
        scheduleDays: resolvedSchedule,
        daily_sessions,
        ...(isMultipleSessions && { currentTime: formattedTime }),
      },
      scheduleDays: resolvedSchedule,
      scheduleTime: resolvedScheduleTime,
      useStandardPlan: personalInfoSkipped,
      demographics_provided: !personalInfoSkipped,
      completed_demographics: !personalInfoSkipped,
      personal_info_skipped: personalInfoSkipped, // analytics flag
      screenFlow: screenFlow,
      session_last_update: new Date().toISOString(),
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);
    history.replace("/recovery-score");
  };

  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header screenName="personalize" />
        <div>
          <DemographicsForm onSubmit={handleFormSubmit} ref={formRef} selectedGoals={selectedGoals} setSelectedGoals={setSelectedGoals} form={demographics} setForm={setDemographics} checklistItems={checklistItems} />
          {/* ConservativePlanModal replaces SkipDemographicsModal.
            showBalanceWarning controls conditional paragraph 2. */}
          {showConservativeModal && <ConservativePlanModal onClose={() => setShowConservativeModal(false)} onConfirm={handleConfirmWithDefaults} showBalanceWarning={showBalanceWarning} />}
        </div>
      </div>
    </div>
  );
};

// personalized recovery pplan small sub component of recovery plan
const PersonalizationInfoCard = () => {
  return (
    <div className={styles.personalizationCard}>
      <p className={styles.personalizationTitle}>How We've Personalized Your Plan</p>

      <div className={styles.personalizationFactors}>
        <div className={styles.factor}>
          <svg className={styles.factorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M3 3v18h18" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7 16l4-6 4 4 5-8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className={styles.factorLabel}>Your Score</span>
        </div>

        <span className={styles.factorPlus}>+</span>

        <div className={styles.factor}>
          <svg className={styles.factorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 2v4M8 2v4M3 10h18" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className={styles.factorLabel}>Your History</span>
        </div>

        <span className={styles.factorPlus}>+</span>

        <div className={styles.factor}>
          <svg className={styles.factorIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className={styles.factorLabel}>Your Info</span>
        </div>
      </div>
    </div>
  );
};

// recovery score component
const RecoveryScoreComp = ({ score = 0, subtype = null, complexityLevel = 1, scoreData = {}, onContinue }) => {
  const gaugeRef = useRef(null);

  useEffect(() => {
    const circle = gaugeRef.current;
    const full = 2 * Math.PI * 45;
    const offset = full - (score / 100) * full;
    if (circle) {
      circle.style.strokeDasharray = `${full}`;
      setTimeout(() => {
        circle.style.strokeDashoffset = offset;
      }, 100);
    }
  }, [score]);

  const resolvedSubtype = subtype || cpgToSubtype(scoreData?.cpgValue?.value);
  const diagnosisKey = complexityLevel === 5 ? "HIGH_FUNCTIONING" : resolvedSubtype || "NEUTRAL_SENSITIVE";

  const diagnosis = messaging.diagnosis[diagnosisKey] || {
    headline: "Your Back Diagnosis",
    clinicalTerm: "Unknown",
    implications: "No diagnosis details available.",
  };

  const readinessModifier = scoreData?.readinessModifier ?? 100;
  let readinessTier;
  if (readinessModifier >= 90) readinessTier = messaging.readinessTiers.READY_TO_GO;
  else if (readinessModifier >= 75) readinessTier = messaging.readinessTiers.CAUTIOUS_START;
  else if (readinessModifier >= 50) readinessTier = messaging.readinessTiers.GENTLE_APPROACH;
  else readinessTier = messaging.readinessTiers.STARTING_WITH_CARE;

  // const gaugeColor = score < 40 ? styles.RSCGaugeRed : score < 61 ? styles.RSCGaugeYellow : styles.RSCGaugeGreen;
  const gaugeColor = styles.RSCGaugeGreen;

  const textColor = score < 40 ? styles.RSCGaugeRed : score < 61 ? styles.RSCGaugeYellow : styles.RSCGaugeGreen;

  const factorsHTML = scoreData?.biometrics?.skipped ? ["Your health history (symptom duration).", "Providing details like activity level and BMI can help us personalize your plan even further in the future."] : ["The history of your condition.", "The personal information you provided."];

  // score ring calculation
  const radius = 65;
  const circumference = 2 * Math.PI * radius; // ≈ 408.4

  const progress = score / 100;
  const dashOffset = circumference * (1 - progress);

  const [offset, setOffset] = useState(circumference);

  useEffect(() => {
    setTimeout(() => {
      setOffset(dashOffset);
    }, 200);
  }, [dashOffset]);

  return (
    <div id="screen-recovery-score" className={styles.RSCScreen}>
      <div>
        <h2 className={styles.compassTitle}>Recovery Compass</h2>
        <p className={styles.compassSubtitle}>The Starting Point of Your Recovery Journey</p>
      </div>
      <div className={styles.scoreSection}>
        <span className={styles.scoreLabel}>Your Score</span>

        <div className={styles.scoreRingContainer}>
          <svg viewBox="0 0 160 160">
            <defs>
              <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#16a34a" />
                <stop offset="100%" stopColor="#15803d" />
              </linearGradient>
            </defs>

            <circle className={styles.scoreRingBg} cx="80" cy="80" r="65" />

            <circle className={styles.scoreRingFill} cx="80" cy="80" r="65" stroke="url(#scoreGradient)" strokeDasharray={circumference} strokeDashoffset={offset} />
          </svg>

          <span className={styles.scoreNumber}>{score}</span>
        </div>
      </div>

      <p className={styles.scoreExplanation}>Your Recovery Compass Score starts at {score}, reflecting your current recovery stage. As you follow your personalized plan over the next 8 weeks, this score is designed to improve steadily, with a goal of reaching closer to 100 as you make progress.</p>

      <div className={styles.diagnosisCard}>
        <h3 className={styles.diagnosisHeadline}>{diagnosis.headline}</h3>
        <p className={styles.diagnosisRelief}>{diagnosis.relief}</p>
      </div>

      <PersonalizationInfoCard />

      <CommonButton title={"View My Week 1 Recovery Plan"} onClick={onContinue} />
    </div>
  );
};

// utils/fetchWithRetry.js (or inside the component file)
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

/**
 * fetchWithRetry
 * - url: API endpoint
 * - options: fetch options (headers, body, method)
 * - opts:
 *    - maxAttempts: number
 *    - initialDelay: ms
 *    - factor: exponential factor
 *    - jitter: true/false (adds small random)
 *    - timeout: per-request timeout in ms (optional)
 *    - signal: AbortSignal (optional)
 */
async function fetchWithRetry(url, options = {}, opts = {}) {
  const { maxAttempts = 4, initialDelay = 800, factor = 2, jitter = true, timeout = 20000, signal } = opts;

  let attempt = 0;

  while (attempt < maxAttempts) {
    attempt += 1;

    // per-attempt timeout
    const controller = new AbortController();
    const combinedSignal = signal
      ? new AbortController().signal // placeholder, we'll combine below
      : controller.signal;

    // Combine signals: prefer outer signal (if provided), but ensure we can timeout.
    // If a signal was passed, we listen to it and abort our controller when it fires.
    if (signal) {
      if (signal.aborted) {
        controller.abort();
      } else {
        const onAbort = () => controller.abort();
        signal.addEventListener("abort", onAbort, { once: true });
      }
    }

    let timeoutId;
    try {
      if (timeout) {
        timeoutId = setTimeout(() => controller.abort(), timeout);
      }

      const res = await fetch(url, {
        ...options,
        signal: controller.signal,
      });

      // if server error (5xx) treat as retryable; if 4xx treat as permanent failure
      if (res.ok) {
        clearTimeout(timeoutId);
        return { ok: true, response: await res.json(), attempt };
      } else if (res.status >= 500 && res.status < 600) {
        // retryable server error
        const errText = await res.text().catch(() => "");
        throw new Error(`Server error ${res.status}: ${errText}`);
      } else {
        // client error - do not retry
        const errText = await res.text().catch(() => "");
        return { ok: false, permanentError: true, status: res.status, body: errText };
      }
    } catch (err) {
      clearTimeout(timeoutId);

      // If aborted externally, rethrow so caller can handle immediate abort
      if (signal && signal.aborted) {
        throw new DOMException("Aborted", "AbortError");
      }

      // If this was the last attempt, return failure info
      if (attempt >= maxAttempts) {
        return { ok: false, error: err, attempt };
      }

      // compute backoff delay (exponential + jitter)
      let delay = initialDelay * Math.pow(factor, attempt - 1);
      if (jitter) {
        const jitterVal = Math.random() * (delay * 0.25); // up to 25% jitter
        delay = delay - jitterVal;
      }

      // wait and retry
      await sleep(delay);
      // then continue loop for next attempt
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  }

  // fallback - should never reach here because loop returns
  return { ok: false, error: new Error("Retries exhausted") };
}

// recovery score screen
export const RecoveryScoreScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const { setProgress } = useProgress();
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const [scoreData, setScoreData] = useState(null);
  const [loadingWait, setLoadingWait] = useState(true);
  const [error, setError] = useState(null);
  const [loadingDots, setLoadingDots] = useState(".");
  const [retryAttempt, setRetryAttempt] = useState(0);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const history = useHistory();
  console.log("assesment data is : ", assessmentData);
  const [safetyHalt, setSafetyHalt] = useState(false);
  const recoveryScorePayload = generatePayloadForScreen("recovery_score", assessmentData);
  const userName = localStorage.getItem("self_name") || "";
  const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  const userConditions = userCondition?.usercondition || {};
  const [isVoiceReady, setIsVoiceReady] = useState(false);
  const problemArea = assessmentData.problemArea || "LBP";
  const [mode, setMode] = useState(MyraInteraction.getMode());
  const isLBP = problemArea === "LBP";
  useEffect(() => {
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(recoveryScorePayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    window.screenTracker.enterScreen("recovery_score");
    MyraInteraction.onScreenEnter("recovery_score");
    window.initFromUserGesture();
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      window.mayraCode.setIsVisible(true);
      // window.mayraCode.startFlow("Compass_Score");
      window.mayraCode.doSay(`${userName ? userName : ""}. | We've got everything we need—thank you for your effort, especially while in pain. Now it's our turn to do the work! I am analyzing your information to calculate your Recovery Compass Score and create your personalized recovery plan. Hang tight—we'll be ready in just a moment.`, () => {
        setLoadingWait(false);
      });
    }
  }, []);
  const safetlyHaltSpeech = "Your Safety is Our Priority Based on how your body responds to movement and your preferences, we couldn't create a safe plan for you right now. Your well-being is what matters most, and we recommend consulting with a healthcare professional to explore the best next steps. If you have any questions, Myra is here to help.";
  useEffect(() => {
    if (safetyHalt) {
      if (window.mayraCode && safetyHalt) {
        // Small delay to ensure clean stop
        setTimeout(() => {
          window.mayraCode.doSay(safetlyHaltSpeech, () => {
            console.log("safetlyHaltSpeech speech finished.");
            // setTimeout(() => {
            //   history.replace("/hard-stop");
            // }, 2000);
          });
        }, 500);
      }
    }
  }, [safetyHalt]);
  useEffect(() => {
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(recoveryScorePayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [recoveryScorePayload, isVoiceReady]);

  useEffect(() => {
    if (!safetyHalt) {
      window.initFromUserGesture();
      window.currentCommandsAudio = {
        READY_TO_PROCEED: (val) => {
          console.log("Symptom NLU received:", val);
          //  Check if the action matches and value is true
          if (val === true) {
            setTimeout(() => {
              console.log("Clicked next", val);
              handleContinue();
            }, 2000);
          }
        },
        ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
          if (intent === "continue_command") {
            setTimeout(() => {
              handleContinue();
            }, 2000);
          }
        },
        MOVE_ON: (value, speech, intent) => {
          setTimeout(() => {
            handleContinue();
          }, 2000);
        },
      };
      window.initFromUserGesture();
      if (!loadingWait) {
        if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
          window.mayraCode.setIsVisible(true);
          // window.mayraCode.startFlow("recovery_score");
          window.mayraForwardCode = {
            midjourneyData: recoveryScorePayload,
          };
          let announcement = "";
          if (mode === "voice") {
            window.mayraCode.startFlow("flow_recovery_compass_score", "recovery_score");
          } else if (mode === "chat") {
            announcement = "Here’s your Recovery Compass Score! It’s your personal guide, uniquely tailored to your journey. It reflects how your movements and responses come together to shape your recovery. When you’re ready, type, 'I’m ready to continue,' and I’ll take you through your personalized recovery plan!";
            VoiceService.startFlowWithoutAnnouncement("flow_recovery_compass_score", "", announcement);
          } else {
            announcement = "Here’s your Recovery Compass Score! It’s your personal guide, uniquely tailored to your journey. It reflects how your movements and responses come together to shape your recovery. Tap the continue button to see your recovery plan. If you’d like to ask me something, tap the Myra icon in the bottom left corner to start a conversation.";
            VoiceService.startFlowWithoutAnnouncement("flow_recovery_compass_score", "", announcement);
          }
        }
      }
    }
  }, [loadingWait]);

  useEffect(() => {
    const saved = localStorage.getItem("assessmentData");
    if (!saved) {
      console.warn("No assessment data found in localStorage.");
      setError("No assessment data found. Please restart the assessment.");
      setLoadingWait(false);
      return;
    }

    let isMounted = true;
    const parsed = JSON.parse(saved);

    const transformedRequest = {
      painLocations: parsed.selectedZones || [],
      cpgClassification: isLBP ? parsed.cpgValue?.value : parsed.cpgForBackend,
      ...(parsed.subtypeQuestions && parsed.selfAssessmentAnswer
        ? {
            subjectiveResponses: {
              q1: parsed.subtypeQuestions?.value || "",
              q2a: parsed.selfAssessmentAnswer || "",
            },
          }
        : {}),
      symptomDuration: parsed.symptomDuration || "",
      analyticsId: parsed.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
      preTestNPRS: parsed.painLevel || 0,
      probableSubtype: parsed.probableSubtype || "",
      diagnosisChanged: parsed.diagnosisChanged || false,
      degradation: parsed.degradation ?? null,
      timing: parsed.timing ?? null,
      signature: parsed.signature || false,
      current_conditions: parsed?.biometrics?.currentConditions || userConditions.current || "",
      pre_existing_conditions: parsed?.biometrics?.preExistingConditions || userConditions.pre_existing || "",

      romTest1: {
        testName: parsed.testName || "",
        symptomaticResponse: parsed.symptomResponse?.value || "",
        rpe: parsed.rpe || 0,
        movementQuality: parsed.romQuality || "",
        cvData: {
          rom: parsed.rom || [],
          duration: parsed.duration || [],
        },
      },
      ...(parsed.testName2 && parsed.symptomResponseConfirm
        ? {
            romTest2: {
              testName: parsed.testName2,
              symptomaticResponse: parsed.symptomResponseConfirm,
            },
          }
        : {}),

      biometrics: parsed.biometrics?.skipped
        ? { skipped: true }
        : {
            skipped: false,
            age: parsed.biometrics.age,
            activityLevel: parsed.biometrics.activityLevel,
            heightFt: parsed.biometrics.heightFt,
            heightIn: parsed.biometrics.heightIn,
            weightLbs: parsed.biometrics.weightLbs,
            floorCapability: parsed.biometrics.floorCapability,
            balance: parsed.biometrics.balance,
            goal: parsed.biometrics.goal || "",
            sessionPref: parsed.biometrics.sessionPref || "one",
            scheduleTime: parsed.biometrics.scheduleTime || "",
            scheduleDays: parsed.biometrics.scheduleDays || "",
            current_conditions: parsed?.biometrics?.currentConditions || userConditions.current || "",
            pre_existing_conditions: parsed?.biometrics?.preExistingConditions || userConditions.pre_existing || "",
          },
    };
    console.log("Transformed request payload for recovery score API: ", transformedRequest);

    setProgress(100);

    const abortController = new AbortController();

    let didFinish = false;

    (async () => {
      setError(null);
      setRetryAttempt(0);
      try {
        const payload = JSON.stringify(transformedRequest);
        const apiStartTime = Date.now();

        // configure retry attempts and timeouts as desired
        const {
          ok,
          response,
          attempt,
          error: fetchErr,
          permanentError,
          status,
          body,
        } = await fetchWithRetry(
          URL,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
          },
          {
            maxAttempts: 4,
            initialDelay: 800,
            factor: 2,
            jitter: true,
            timeout: 20000, // per-attempt timeout
            signal: abortController.signal,
          },
        );

        const apiLatencyMs = Date.now() - apiStartTime;
        if (!isMounted) return;

        if (ok && response) {
          // success path
          const result = response;
          setSafetyHalt(result.recoveryPlan?.safetyHalt || false);
          console.log("API Response for recovery score is : ", result);

          const updatedData = {
            ...parsed,
            finalPainSubtype: result?.userProfile.finalPainSubtype || "",
            finalCpgClassification: result?.userProfile.finalCpgClassification || "",
            finalScore: result.userProfile?.recoveryScore,
            finalComplexityLevel: result?.userProfile?.level || 1,
            readinessModifier: result?.userProfile?.planDetails.readinessModifier ?? 100,
            recoveryPlan: result.recoveryPlan || { exercises: [] },
            planRationaleSpeech: result?.recoveryPlan?.rationale || "",
            totalAdjustment: result?.userProfile?.totalAdjustment ?? result?.totalAdjustment ?? 0,
            rcsCalculated: result?.userProfile?.rcsCalculated ?? result?.rcsCalculated ?? 0,
            adjustmentDetails: result?.userProfile?.adjustmentDetails || result?.adjustmentDetails || {},
            completed_assessment: true,
            planGeneratedAt: new Date().toISOString(),
            aiLatencyMs: apiLatencyMs,
            exerciseCandidatesCount: result.recoveryPlan?.exercises?.length || 0,
          };

          console.log("API Response updated this data as : ", updatedData);

          updateAssessmentData(updatedData);
          localStorage.setItem("assessmentData", JSON.stringify(updatedData));
          setScoreData(updatedData);

          const localStorageAssessmentDataOld = localStorage.getItem("assessmentData");
          const rationaleSpeech = updatedData.planRationaleSpeech || localStorageAssessmentDataOld.rationale;
          window.mayraCode.doSayPreload(rationaleSpeech);

          setTimeout(() => {
            if (isMounted) setLoadingWait(false);
          }, 19000);

          // Analytics: success
          if (AnalyticsService && typeof AnalyticsService.trackStep === "function") {
            AnalyticsService.trackStep(updatedData);
          }

          didFinish = true;
        } else {
          console.log("API fetch attempt:", attempt);
          console.log("API fetch error/permanent failure:", fetchErr || `${status} - ${body}`);
          // handle permanent errors or final failure
          if (permanentError) {
            const message = `Request failed (${status}). Please contact support.`;
            setError(message);
            console.error("Permanent API error:", status, body);
          } else {
            const message = fetchErr?.message ? `Failed to contact server: ${fetchErr.message}` : "Empty response from API.";
            setError(message);
            console.error("Final fetch error after retries:", fetchErr);
          }

          if (AnalyticsService && typeof AnalyticsService.trackFailure === "function") {
            AnalyticsService.trackFailure({ reason: fetchErr?.message || "no-response", attempts: attempt || 0 });
          }

          // stop waiting spinner and allow manual retry
          setLoadingWait(false);
        }
      } catch (err) {
        if (!isMounted) return;
        if (err.name === "AbortError") {
          console.log("Fetch was aborted");
          // Do not set error; the user navigated away
          return;
        }
        console.error("Unexpected error fetching recovery score:", err);
        setError(err.message || "Unexpected error occurred.");
        setLoadingWait(false);
      }
    })();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, []);
  // const rationaleSpeech = scoreData?.planRationaleSpeech || assessmentData.planRationaleSpeech;
  // let userName = localStorage.getItem("self_name") || "";
  // let fullSpeech = userName ? `${userName} , ${rationaleSpeech}` : rationaleSpeech;
  const handleContinue = () => {
    window.screenTracker.exitScreen("recovery_score", {
      exitReason: "score_viewed",
      completed: true,
    });
    MyraInteraction.onScreenEnter("plan_screen");
    const screenFlow = window.screenTracker.getScreenFlow();
    const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
    const latestConditions = userCondition?.usercondition || {};

    // Get current assessmentData
    const assessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");

    // Update biometrics with latest conditions
    const updatedBiometrics = {
      ...(assessmentData.biometrics || {}),
      currentConditions: latestConditions.current || assessmentData.biometrics?.currentConditions || "",
      preExistingConditions: latestConditions.pre_existing || assessmentData.biometrics?.preExistingConditions || "",
    };

    // const recoveryScoreSpeech = {
    //   type: "recovery_score_speech",
    //   speech: fullSpeech,
    // };
    // if (window.mayraCode && VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
    //   VoiceService._ws.send(JSON.stringify(recoveryScoreSpeech));
    // }
    const updatedData = { ...scoreData, biometrics: updatedBiometrics, viewed_plan: true, recovery_score_viewed: true, screenFlow: screenFlow, session_last_update: new Date().toISOString() };
    updateAssessmentData(updatedData);
    localStorage.setItem(
      "assessmentData",
      JSON.stringify({
        ...assessmentData,
        ...updatedData,
        biometrics: updatedBiometrics,
      }),
    );
    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedData);
    history.replace("/screen-plan", { state: { scoreData: updatedData } });
  };
  const SafetyHaltBlock = () => (
    <div style={{ padding: 20 }}>
      <p style={{ fontSize: 20, fontWeight: "bold", color: "red", textAlign: "center" }}>Your Safety is Our Priority</p>
      <p style={{ marginTop: 10, textAlign: "center" }}>Based on how your body responds to movement and your preferences, we couldn't create a safe plan for you right now. Your well-being is what matters most, and we recommend consulting with a healthcare professional to explore the best next steps. If you have any questions, Myra is here to help.</p>
    </div>
  );
  return (
    <div className={styles.ScreenWrapper}>
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        {/* <Header showProgress={!scoreData?.finalScore?.total}/> */}
        <Header showProgress={loadingWait === false && !!scoreData?.finalScore && !error} screenName="recovery_score" />
        <div>
          {safetyHalt && <SafetyHaltBlock />}
          {!safetyHalt && error && (
            <div
              style={{
                color: "#ef4444",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              {error}
            </div>
          )}
          {/* Loader while waiting */}
          {(loadingWait === true || (!scoreData?.finalScore && !error && !safetyHalt)) && (
            <div className={styles.RSC_loaderWrapper}>
              <div className={styles.RSC_loaderText}>
                Myra is working with our Advanced AI to create your personalized Recovery Plan, designed with expert guidance. This will just take a moment
                {loadingDots}
              </div>
              <div className={styles.RSC_spinner}></div>
            </div>
          )}

          {loadingWait === false && scoreData?.finalScore && !safetyHalt && <RecoveryScoreComp score={scoreData?.finalScore} subtype={scoreData?.finalPainSubtype} complexityLevel={scoreData?.finalComplexityLevel} scoreData={scoreData} onContinue={handleContinue} />}
        </div>
      </div>
    </div>
  );
};

// custom notification Modal
const CustomNotificationModal = ({ visible, message, onClose }) => {
  if (!visible) return null;
  return (
    <div className={styles.CNMContainer}>
      <div className={styles.CNMOverlay}></div>
      <div className={styles.CNMModalWrapper}>
        <div className={styles.CNMModalBox}>
          <p className={styles.CNMMessage}>{message}</p>
          <button onClick={onClose} className={styles.CNMButton}>
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

const SPPlanMissionCard = ({ planFocusText }) => {
  return (
    <div className={styles.SPPlanInfoCard2}>
      <h3 className={styles.SPPlanMissionTitle}>Your Week 1 Mission</h3>
      <div className={styles.SPPlanFlex2}>
        {/* Focus */}
        <div className={styles.SPPlanSection2}>
          <svg className={styles.SPPlanIcon2} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6H8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" />
          </svg>
          <span className={styles.SPPlanLabel2}>Focus</span>
          <span className={styles.SPPlanValue2}>{planFocusText}</span>
        </div>

        {/* Plus Sign */}
        <div className={styles.SPPlanOperator}>+</div>

        {/* Goal */}
        <div className={styles.SPPlanSection}>
          <svg className={styles.SPPlanIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
          <span className={styles.SPPlanLabel}>Goal</span>
          <span className={styles.SPPlanValue}>Consistency</span>
        </div>

        {/* Equal Sign */}
        <div className={styles.SPPlanOperator2}>=</div>

        {/* Result */}
        <div className={styles.SPPlanSection}>
          <svg className={styles.SPPlanIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
          <span className={styles.SPPlanLabel}>Result</span>
          <span className={styles.SPPlanValue}>5-15 Point Increase</span>
          <span className={styles.SPPlanSubtext}>in your recovery compass score</span>
        </div>
      </div>
    </div>
  );
};

// hlper function to generate the payload for userJourneyData
function generateUserJourneyPayload(assessmentData) {
  if (!assessmentData) {
    console.log("No assessment data provided for payload generation.");
    throw new Error("assessmentData is required");
  }

  // Build screen flow with duration
  const screenFlowWithDuration = (assessmentData.screenFlow || []).map((screen, index, arr) => {
    const next = arr[index + 1];
    let duration_sec = null;

    if (next?.enteredAt && screen?.enteredAt) {
      const start = new Date(screen.enteredAt);
      const end = new Date(next.enteredAt);
      duration_sec = Math.round((end - start) / 1000);
    }

    return {
      screen: screen.screen,
      entered_at: screen.enteredAt || null,
      duration_sec,

      ...(screen.videoWatched !== undefined && {
        video_watched: screen.videoWatched,
      }),

      ...(screen.videoSkipped !== undefined && {
        video_skipped: screen.videoSkipped,
      }),

      ...(screen.completed !== undefined && {
        completed: screen.completed,
      }),

      ...(screen.exitReason && {
        exit_reason: screen.exitReason,
      }),
    };
  });

  const journeyData = {
    analyticsId: assessmentData.analyticsId || window.trSessionId || localStorage.getItem("trSessionId") || null,
    screen_flow: screenFlowWithDuration,

    myra_engagement: {
      landing: {
        engaged: !!assessmentData.myraEngagedLanding,
        message_count: window.landingMessageCount || 0,
        topics: window.landingTopic || [],
      },
      gsa: {
        engaged: !!window.myraEngagedGsa,
        message_count: window.gsaMessageCount || 0,
        topics: window.flowGsaTopic || [],
      },
      post_plan: {
        engaged: !!window.myraEngagedPlanV2,
        message_count: window.planV2MessageCount || 0,
        topics: window.planV2Topic || [],
      },
    },

    test1: assessmentData.testName
      ? {
          name: assessmentData.testName,
          video_watched_fully: !!assessmentData.test1VideoWatched,
          video_duration_watched_sec: assessmentData.test1VideoDuration || null,
          ar_duration_sec: assessmentData.test1ArDuration || null,
          rom: assessmentData.rom || [],
          duration: assessmentData.duration || [],
          rpe: assessmentData.rpe || null,
          symptom_response: assessmentData.symptomResponse?.value || null,
          completed: !!assessmentData.rom_test1_completed,
          exit_reason: assessmentData.test1ExitReason || null,
        }
      : null,

    test2: assessmentData.testName2
      ? {
          name: assessmentData.testName2,
          video_watched_fully: !!assessmentData.test2VideoWatched,
          video_duration_watched_sec: assessmentData.test2VideoDuration || null,
          ar_duration_sec: assessmentData.test2ArDuration || null,
          rom: assessmentData.rom2 || [],
          duration: assessmentData.duration2 || [],
          rpe: assessmentData.rpe2 || null,
          symptom_response: assessmentData.symptomResponseConfirm || null,
          completed: !!assessmentData.rom_test2_completed,
          exit_reason: assessmentData.test2ExitReason || null,
        }
      : null,

    ai_plan_generation: assessmentData.aiLogId
      ? {
          ai_log_id: assessmentData.aiLogId,
          exercise_candidates_count: assessmentData.exerciseCandidatesCount || null,
          plan_generated_at: assessmentData.planGeneratedAt || null,
          latency_ms: assessmentData.aiLatencyMs || null,
        }
      : null,
  };

  return journeyData;
}
async function saveUserJourney(assessmentData) {
  const payload = generateUserJourneyPayload(assessmentData);
  console.log("[PAYLOAD IS : ] ", payload);
  const response = await fetch(`${ANALYTICS_API_URL}/updateUserJourneyData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      journeyData: payload, // ✅ wrap inside journeyData
    }),
  });

  if (!response.ok) {
    throw new Error("Failed to save journey data");
  }

  return await response.json();
}

// screenplan screen
export const ScreenPlan = () => {
  usePreventNavigation("/");
  useScrollToTop();
  const location = useLocation();
  const { state } = location.state || {};
  // Modified on Aug 7th - for user tracking
  const { updateAssessmentData, assessmentData } = useAssessment();
  const { setProgress } = useProgress();
  // const assessmentData = state?.scoreData;
  // console.log("data is : ", assessmentData);
  // const assessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");
  const [isVoiceReady, setIsVoiceReady] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [isOpeningLink, setIsOpeningLink] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [visibleRationaleIds, setVisibleRationaleIds] = useState([]);
  const [showEmailPart, setShowEmailPart] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [speechInProgress, setSpeechInProgress] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isExpanded, panelSize, isMobile } = useMyraPanel();
  const detailsRef = useRef(null);
  const inputRef = useRef(null);
  let userName = localStorage.getItem("self_name") || "";
  const rationaleSpeech = assessmentData?.planRationaleSpeech;
  console.log("Rationale speech is : ", rationaleSpeech);
  let fullSpeech = userName ? `${userName} | ${rationaleSpeech}` : rationaleSpeech;
  let sessionId = window.trSessionId || localStorage.getItem("trSessionId");
  let screenPlanPayload = generatePayloadForScreen("plan_screen", assessmentData);
  const userConditions = getUserConditions();
  useEffect(() => {
    VoiceService.updateRational(rationaleSpeech);
    let prevIsListening = VoiceService._isListening;
    const checkInterval = setInterval(() => {
      const currentIsListening = VoiceService._isListening;
      if (!prevIsListening && currentIsListening) {
        VoiceService.sendMidJourneyData(screenPlanPayload);
      }

      if (prevIsListening && !currentIsListening) {
        console.log("[Myra] Turned OFF");
        setIsVoiceReady(false);
      }
      prevIsListening = currentIsListening;
    }, 500);

    return () => clearInterval(checkInterval);
  }, []);

  useEffect(() => {
    if (window.mayraCode) {
      setDetailsOpen(true);
    }
    // VoiceService.proceedToRecoveryPlan(fullSpeech);
  }, []);
  useEffect(() => {
    window.initFromUserGesture();
    const initializeVoice = () => {
      if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
        if (VoiceService._ws?.readyState === WebSocket.OPEN) {
          VoiceService.sendMidJourneyData(screenPlanPayload);
          setIsVoiceReady(true);
        }
      }
    };
    initializeVoice();
    const checkConnectionInterval = setInterval(() => {
      if (VoiceService._ws?.readyState === WebSocket.OPEN && !isVoiceReady) {
        initializeVoice();
      }
    }, 1000);
    const originalOnConnected = VoiceService._callbacks?.onConnected;
    VoiceService._callbacks.onConnected = () => {
      initializeVoice();
      if (originalOnConnected) originalOnConnected();
    };
    return () => {
      clearInterval(checkConnectionInterval);
      if (originalOnConnected) {
        VoiceService._callbacks.onConnected = originalOnConnected;
      }
    };
  }, [screenPlanPayload, isVoiceReady]);
  useEffect(() => {
    // Track when user enters the plan screen
    window.screenTracker.enterScreen("plan_screen");
    MyraInteraction.onScreenEnter("plan_screen");

    // ... existing code ...

    return () => {
      // Cleanup - track exit if component unmounts
      window.screenTracker.exitScreen("plan_screen");
    };
  }, []);

  useEffect(() => {
    if (!assessmentData) {
      const storedData = localStorage.getItem("assessmentData");
      if (storedData) {
        // Redirect to recovery-score to regenerate the plan
        window.location.href = "/recovery-score";
      } else {
        // No data found, go to beginning
        window.location.href = "/";
      }
    }
  }, [assessmentData]);

  useEffect(() => {
    const el = detailsRef.current;
    if (!el) return;

    const handleToggle = () => setDetailsOpen(el.open);
    el.addEventListener("toggle", handleToggle);
    return () => el.removeEventListener("toggle", handleToggle);
  }, []);

  // Handle audio button click
  // Alternative Play Handler using mayraCode but with proper stop
  const handlePlayAudio = () => {
    let fullSpeech = userName ? `${userName} , ${rationaleSpeech}` : rationaleSpeech;

    if (window.mayraCode && fullSpeech) {
      // Small delay to ensure clean stop
      setTimeout(() => {
        window.mayraCode.doSay(fullSpeech, () => {
          console.log("Rationale speech finished.");
          setIsAudioPlaying(false);
          setSpeechInProgress(false);
        });

        // Update UI state immediately
        setIsAudioPlaying(true);
        setSpeechInProgress(true);
      }, 150); // Slightly longer delay for cleanup
    }
  };

  // Stop Audio Handler
  const handleStopAudio = () => {
    if (speechInProgress) {
      VoiceService.stopAllVoiceActivity();
      // Clear any pending callbacks
      VoiceService._callbacks.onAgentSpeechEndCustom = () => {};

      console.log("Speech completely stopped by user");
    }

    // Reset UI state
    setIsAudioPlaying(false);
    setSpeechInProgress(false);
  };

  useEffect(() => {
    return () => {
      // Clean up any ongoing speech when component unmounts
      if (speechInProgress) {
        handleStopAudio();
      }
    };
  }, [speechInProgress]);
  const toggleRationale = (id) => {
    setVisibleRationaleIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]));
  };
  useEffect(() => {
    window.initFromUserGesture();
    window.currentFlow = "flow_plan_v2";
    VoiceService._currentFlow = "flow_plan_v2";
    window.currentCommandsAudio = {
      ANSWER_QNA_QUESTION: (value, speech, intent) => {
        if (intent === "signup_request") {
          setTimeout(() => {
            setIsLoading(true);
            handleClick();
          }, 3000);
        }
      },
      ANSWER_MidJourneyFlow_QUESTION: (value, speech, intent) => {
        if (intent === "continue_command") {
          setTimeout(() => {
            setIsLoading(true);
            handleClick();
          }, 3000);
        }
      },
      MOVE_ON: (value, speech, intent) => {
        setTimeout(() => {
          setIsLoading(true);
          handleClick();
        }, 3000);
      },
      SIGN_UP: (value, speech, intent) => {
        setTimeout(() => {
          setIsLoading(true);
          handleClick();
        }, 3000);
      },
    };
    if (window.mayraCode && typeof window.mayraCode.setIsVisible === "function") {
      // Extract data from localStorage
      const localStorageAssessmentData = JSON.parse(localStorage.getItem("assessmentData"));
      const recoveryPlan = localStorageAssessmentData?.recoveryPlan || {};

      // Build userProfile with all required fields
      const userProfile = {
        // Pain and assessment data
        painLocations: localStorageAssessmentData?.selectedZones || [],
        cpgClassification: localStorageAssessmentData?.finalCpgClassification || "",
        subjectiveResponses: localStorageAssessmentData?.subtypeQuestions || {},
        symptomDuration: localStorageAssessmentData?.symptomDuration || "",
        preTestNPRS: localStorageAssessmentData?.painLevel || 0,
        probableSubtype: localStorageAssessmentData?.probableSubtype || "",
        finalPainSubtype: localStorageAssessmentData?.finalPainSubtype || "",
        recoveryScore: localStorageAssessmentData?.finalScore || 0,
        level: localStorageAssessmentData?.finalComplexityLevel || 3,

        // ROM test data
        romTest1: {
          testName: localStorageAssessmentData?.testName || "",
          symptomaticResponse: localStorageAssessmentData?.symptomResponse?.value || "TOLERABLE",
          rpe: localStorageAssessmentData?.rpe || 0,
        },
        romTest2: {
          testName: localStorageAssessmentData?.testName2 || "",
          symptomaticResponse: localStorageAssessmentData?.symptomResponseConfirm || "TOLERABLE",
        },

        // Biometrics
        biometrics: localStorageAssessmentData?.biometrics || {},

        // Additional calculated fields
        pillar1: localStorageAssessmentData?.pillar1 || 0,
        pillar2: localStorageAssessmentData?.pillar2 || 0,
        pillar3: localStorageAssessmentData?.pillar3 || 0,
        pillar4: localStorageAssessmentData?.pillar4 || 0,
        rcsCalculated: localStorageAssessmentData?.rcsCalculated || 0,
        totalAdjustment: localStorageAssessmentData?.totalAdjustment || 0,
        adjustmentDetails: localStorageAssessmentData?.adjustmentDetails || {},
        planDetails: localStorageAssessmentData?.planDetails || {},
        ...(userConditions && { user_conditions: userConditions }),
      };

      // Build currentPlan
      const currentPlan = {
        exercises: recoveryPlan.exercises || [],
        estimatedTime: recoveryPlan.estimatedTime || "",
        rationale: recoveryPlan.rationale || "",
      };

      const qnaData = {
        userProfile: userProfile,
        currentPlan: currentPlan,
        planRationale: rationaleSpeech,
        sessionId: sessionId,
      };

      console.log("Sending QnA data to backend:", qnaData);

      window.mayraCode.setIsVisible(true);
      // VoiceService.proceedToRecoveryPlan(fullSpeech, localStorage.getItem("help_ai_pick") ? localStorage.getItem("help_ai_pick") : "gemini", qnaData); // -> gemini or claude
      VoiceService.sendMidJourneyData(screenPlanPayload);
      // VoiceService.proceedToRecoveryPlan(fullSpeech, "claude", qnaData); // -> gemini or claude
      window.mayraCode.startFlow("flow_plan_v2");
    }
  }, [rationaleSpeech]);
  useEffect(() => {
    const el = detailsRef.current;
    if (!el) return;

    const handleToggle = () => setIsDetailsOpen(el.open);
    el.addEventListener("toggle", handleToggle);

    return () => el.removeEventListener("toggle", handleToggle);
  }, []);
  useEffect(() => {
    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    try {
      if (window.gtag) {
        window.gtag("event", "conversion", { send_to: "AW-18002481001/Kf-vCLqv7YUcEOmeoIhD" });
      }
    } catch (e) {
      console.warn(e);
    }

    window.screenTracker.enterScreen("screen_plan");
    setProgress(100);
  }, []);
  let { finalPainSubtype, recoveryPlan } = assessmentData || {};
  finalPainSubtype = undefined ? assessmentData.finalPainSubtype : finalPainSubtype;
  const exercises = recoveryPlan?.exercises || [];
  const focus = recoveryPlan?.focus || "This plan is designed to help you recover.";
  const planFocusText = messaging.planFocus[finalPainSubtype];
  const goal = recoveryPlan?.goal || `The goal for this first week is to complete your sessions consistently and learn how your body responds to the movements. The key is consistency, not intensity. Many people in a similar situation see their score improve by <strong>5-15 points</strong> in the first one to two weeks.*<br><p class='text-xs italic mt-2'>*Your results may vary. The most important metric is feeling more confident and in control.</p>`;
  const estimatedTime = recoveryPlan?.estimatedTime || "15-20";
  const readinessModifier = assessmentData?.readinessModifier ?? 100;
  let readinessTier;
  if (readinessModifier >= 90) readinessTier = messaging.readinessTiers.READY_TO_GO;
  else if (readinessModifier >= 75) readinessTier = messaging.readinessTiers.CAUTIOUS_START;
  else if (readinessModifier >= 50) readinessTier = messaging.readinessTiers.GENTLE_APPROACH;
  else readinessTier = messaging.readinessTiers.STARTING_WITH_CARE;

  // Returns " — Left Leg" / " — Right Leg" / "" based on exercise definition
  const getPerformanceSideLabel = (ex) => {
    if (!ex.performance_side) return "";

    // For now assume lower back plan → legs
    // If you want arm/leg logic later, we extend here safely.
    return ` — ${ex.performance_side} Leg`;
  };

  useEffect(() => {
    if (!assessmentData) return; // wait for data
    console.log("Tracking analytics for plan screen with data: ", assessmentData);

    const updatedAssessmentData = {
      ...assessmentData,
      exercises,
      final_conversion_type: "signup",
    };

    updatedAssessmentData.analyticsId = window.trSessionId;

    // Encode full data
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(updatedAssessmentData))));
    // Track analytics immediately when screen opens
    try {
      AnalyticsService.saveFullData(encoded);
    } catch (err) {
      console.error("Error tracking analytics on screen open:", err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentData]);

  const handlePlan = (e) => {
    e.preventDefault();
    const updatedAssessmentData = { ...assessmentData, exercises, final_conversion_type: "email_plan" };
    updateAssessmentData(updatedAssessmentData);

    // Modified on Aug 7th - for user tracking
    AnalyticsService.trackStep(updatedAssessmentData);
    // await AnalyticsService.saveFullData(encoded)
    console.log("updated assesment data : ", updatedAssessmentData);

    showCustomNotification("Your recovery plan has been sent to the provided email address.");

    fetch(URLPlan, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name: firstName, email: email, assessment: updatedAssessmentData }),
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch analysis");
        }
        console.log("response from api plan is : ", res);
        return res.json();
      })
      .then((result) => {
        if (!result) {
          console.error("Empty response from API.");
          return;
        }
      })
      .catch((err) => {
        console.error("Failed to analyze assessment:", err);
      });
  };
  const showCustomNotification = (msg) => {
    setModalMessage(msg);
    setModalVisible(true);
  };
  const handleClick = async () => {
    setIsLoading(true);
    setIsOpeningLink(true);
    MyraInteraction.onScreenEnter("results");

    window.screenTracker.exitScreen("plan_screen", {
      exitReason: "signup_initiated",
      completed: true,
    });
    const screenFlow = window.screenTracker.getScreenFlow();
    const latestAssessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");

    const finalGSADuration = window.timeTracker.getGSADuration();
    const updatedAssessmentData = { ...latestAssessmentData, exercises, final_conversion_type: "signup", gsaDurationSec: finalGSADuration, viewed_plan: true, completed_assessment: true, screenFlow: screenFlow, session_last_update: new Date().toISOString() };
    updateAssessmentData(updatedAssessmentData);
    AnalyticsService.trackStep(updatedAssessmentData);
    const encoded = btoa(unescape(encodeURIComponent(JSON.stringify(updatedAssessmentData))));
    // Track analytics immediately when screen opens
    try {
      AnalyticsService.saveFullData(encoded);
    } catch (err) {
      console.error("Error tracking analytics on screen open:", err);
    }

    try {
      if (window.closePoseAll) {
        window.closePoseAll();
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (window.destroyOwnedResources) {
        window.destroyOwnedResources();
      }
    } catch (e) {
      console.log(e);
    }

    try {
      if (window.gtag) {
        window.gtag("event", "conversion", { send_to: "AW-18002481001/mZpjCLO7gYYcEOmeoIhD" });
      }
    } catch (e) {
      console.warn(e);
    }

    await saveUserJourney(updatedAssessmentData);

    if (window.mayraCode) {
      if (window.mayraCode.setOnMicEnabled) {
        window.mayraCode.setOnMicEnabled(null);
      }
      if (window.mayraCode.setIsVisible) {
        window.mayraCode.setIsVisible(false);
      }

      if (window.VoiceService && window.VoiceService.destroyMyraCompletely) {
        window.VoiceService.destroyMyraCompletely();
      }

      window.mayraCode = null;
      window.startFlow = null;
      window.currentCommandsAudio = {};
    }
    sessionStorage.removeItem("voiceService_wasListening");
    sessionStorage.removeItem("voiceService_currentFlow");
    var subDomain = "live";
    if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
      subDomain = "uat";
    }
    window.timeTracker.reset(); // resets timer
    console.log("sending data");

    // window.location.replace("https://" + subDomain + ".virdiohealth.com/register?self-assessment=true&fromsite=" + window.location.host + "&data=" + window.trSessionId);

    history.replace("/register");
  };

  console.log("assesment data : ", assessmentData);
  const history = useHistory();

  if (!assessmentData) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "black",
        }}
      >
        Redirecting to your recovery plan...
      </div>
    );
  }
  return (
    <div className={styles.ScreenWrapper}>
      {isLoading && (
        <div className={styles.fullScreenLoader}>
          <div className={styles.loaderSpinner}></div>
        </div>
      )}
      <div className={styles.ScreenModal} style={{ paddingBottom: isExpanded && isMobile ? panelSize : undefined, marginLeft: isExpanded && !isMobile ? panelSize : undefined }}>
        <Header showProgress={false} screenName="plan_screen" />
        <div>
          <div className={styles.recoveryHeaderWrapper} style={{ position: "relative" }}>
            <button
              onClick={() => history.replace("/recovery-score")}
              style={{
                position: "absolute",
                top: "-20",
                left: "-10",
                color: "#6B7280", // text-gray-500
                transition: "color 0.2s",
                backgroundColor: "transparent",
                border: "none",
                outline: "none",
                cursor: "pointer",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#374151")} // hover:text-gray-700
              onMouseLeave={(e) => (e.currentTarget.style.color = "#6B7280")}
            >
              <svg style={{ width: "1.5rem", height: "1.5rem" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <h2 className={styles.recoveryHeaderTitle}>Your Week 1 Recovery Plan</h2>
            <svg className={styles.recoveryHeaderLine} viewBox="0 0 104 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M103.39 10.211C103.39 10.211 72.841 2.35103 51.644 2.35103C30.447 2.35103 0.609985 10.211 0.609985 10.211" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
          <SPPlanMissionCard planFocusText={planFocusText} />
          {/* Exercise Summary */}
          <details className={styles.exerciseDetails} ref={detailsRef} open={detailsOpen}>
            <summary className={styles.SPsummary}>
              <div className={styles.SPsummaryHeader}>
                <div className={styles.SPsummaryHeaderText}>
                  <span>This Week's Program</span>
                  {/* Audio Button */}
                  {/* Audio Buttons - Separate Play/Pause */}
                  {isAudioPlaying ? (
                    <button className={`${styles.SPaudioButton} ${styles.isPlaying}`} onClick={handleStopAudio} type="button" aria-label="Stop my analysis">
                      {/* Pause Icon - Two Bars */}
                      <svg className={styles.iconPause} fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5h3v14H8V5zm5 0h3v14h-3V5z" />
                      </svg>
                    </button>
                  ) : (
                    <button className={styles.SPaudioButton} onClick={handlePlayAudio} type="button" aria-label="Play my analysis">
                      {/* Play Icon - Talking Head */}
                      <svg className={styles.iconPlay} fill="currentColor" viewBox="0 0 24 24">
                        {/* Path for a standard right-pointing triangle */}
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </button>
                  )}
                </div>
                <svg className={styles.SPsummaryIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isDetailsOpen
                        ? "M19 15l-7-7-7 7" // Up arrow
                        : "M19 9l-7 7-7-7" // Down arrow
                    }
                  />
                </svg>
              </div>
              <p className={styles.SPsummaryText}>
                Your 1st week consists of <strong>{recoveryPlan?.exercises.length} exercises</strong>. This session should take <strong>{estimatedTime} minutes</strong> and is recommended <strong>3 times this week</strong>.
              </p>
            </summary>

            <div className={styles.exerciseList}>
              {recoveryPlan?.exercises.map((ex, i) => {
                const rationaleId = `rationale-${i}`;
                const isVisible = visibleRationaleIds.includes(rationaleId);
                const hasValidImage = typeof ex.image === "string" && ex.image.trim().length > 0;

                return (
                  <div key={rationaleId} className={styles.exerciseCard}>
                    <div className={styles.exerciseCardContent}>
                      {/* Exercise name in circle */}
                      <div className={styles.exerciseThumbnail} style={{ backgroundColor: hasValidImage ? "transparent" : "#e2e8f0" }}>
                        {hasValidImage ? <img src={ex.image} alt={ex.name} className={styles.exerciseThumbnailImage} /> : <span className={styles.exerciseThumbnailLabel}>{ex.name?.replace("*", "")}</span>}
                      </div>

                      {/* Text content */}
                      <div className={styles.exerciseTextBlock}>
                        <h4 className={styles.exerciseCardTitle}>
                          {ex.name}
                          {getPerformanceSideLabel(ex)}
                          {ex.rationale && (
                            <button onClick={() => toggleRationale(rationaleId)} className={styles.rationaleToggle}>
                              <svg className={styles.rationaleIcon} fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" clipRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" />
                              </svg>
                            </button>
                          )}
                        </h4>
                        <p className={styles.exerciseDescription}>
                          {ex.sets} Sets of {ex.reps} Reps
                          {ex.hold ? ` | ${ex.hold}s hold` : ""}
                        </p>
                      </div>
                    </div>

                    {ex.rationale && isVisible && (
                      <div className={styles.exerciseRationale}>
                        <p className={styles.rationaleText}>
                          <span className={styles.rationaleLabel}>Why it helps:</span> {ex.rationale}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </details>

          <div className={styles.startRecInfoCard}>
            <h3 className={styles.startRecHeading}>Sign Up to Continue Your Recovery Journey with Virdio Health</h3>
            <p className={styles.startRecSubheading}>You took the first step, and it felt amazing! Now, let us help you build on your progress:</p>
            <ul className={styles.startRecList}>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>AI-powered guidance & Augmented Reality exercises</span>
              </li>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>Weekly Recovery Compass updates</span>
              </li>
              <li className={styles.startRecItem}>
                <svg className={styles.startRecIcon} fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path>
                </svg>
                <span>Reminders, Progress reports, and so much more</span>
              </li>
            </ul>
            <button onClick={handleClick} className={styles.SPctaButton} style={{ padding: "15px 0" }}>
              {isOpeningLink === true ? "Loading..." : "Sign Up to Start Your Recovery Today"}
            </button>
          </div>
          <CustomNotificationModal visible={modalVisible} message={modalMessage} onClose={() => setModalVisible(false)} />

          {/* Email Option */}
          <summary
            className={styles.sendPlanSummary}
            onClick={() => {
              setShowEmailPart(true);

              setTimeout(() => {
                if (inputRef.current) {
                  inputRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                  });
                  inputRef.current.focus({ preventScroll: true });
                }
              }, 50);
            }}
          >
            Send me the plan
          </summary>

          {showEmailPart && (
            <div className={styles.SPemailContainer}>
              <form onSubmit={handlePlan} className={styles.SPemailForm}>
                <input type="text" autoComplete="off" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Your first name" required className={styles.SPemailInput} ref={inputRef} />
                <input type="email" autoComplete="off" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email" required className={styles.SPemailInput} />
                <button type="submit" className={styles.SPemailButton}>
                  Send Plan
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const PdfViewerPage = () => {
  const url = new URLSearchParams(window.location.search).get("file");
  console.log("PDF URL: ", url);
  if (!url) return <div style={{ color: "white", padding: 20 }}>No PDF URL provided</div>;

  return (
    <div style={{ height: "100vh", width: "100vw" }}>
      <PdfViewer url={decodeURIComponent(url)} />
    </div>
  );
};
